"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundImage = exports.ContainerBase = exports.StylableCardElementContainer = exports.ContainerStyleProperty = exports.ActionSet = exports.ShowCardAction = exports.HttpAction = exports.HttpHeader = exports.ToggleVisibilityAction = exports.OpenUrlAction = exports.DataQuery = exports.ExecuteAction = exports.UniversalAction = exports.SubmitAction = exports.SubmitActionBase = exports.Action = exports.TimeInput = exports.TimeProperty = exports.DateInput = exports.NumberInput = exports.FilteredChoiceSet = exports.ChoiceSetInput = exports.ChoiceSetInputDataQuery = exports.Choice = exports.ToggleInput = exports.TextInput = exports.Input = exports.Media = exports.YouTubePlayer = exports.DailymotionPlayer = exports.VimeoPlayer = exports.IFrameMediaMediaPlayer = exports.CustomMediaPlayer = exports.HTML5MediaPlayer = exports.MediaPlayer = exports.MediaSource = exports.CaptionSource = exports.ContentSource = exports.ImageSet = exports.CardElementContainer = exports.Image = exports.FactSet = exports.Fact = exports.RichTextBlock = exports.TextRun = exports.TextBlock = exports.BaseTextBlock = exports.ActionProperty = exports.CardElement = exports.renderSeparation = void 0;
exports.SerializationContext = exports.AdaptiveCard = exports.Authentication = exports.TokenExchangeResource = exports.AuthCardButton = exports.RefreshDefinition = exports.RefreshActionProperty = exports.ContainerWithActions = exports.ColumnSet = exports.Column = exports.Container = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var Enums = require("./enums");
var shared_1 = require("./shared");
var Utils = require("./utils");
var host_config_1 = require("./host-config");
var TextFormatters = require("./text-formatters");
var card_object_1 = require("./card-object");
var serialization_1 = require("./serialization");
var registry_1 = require("./registry");
var strings_1 = require("./strings");
var controls_1 = require("./controls");
function clearElement(element) {
  var _a, _b;
  var trustedHtml = typeof window === 'undefined' ? "" : (_b = (_a = window.trustedTypes) === null || _a === void 0 ? void 0 : _a.emptyHTML) !== null && _b !== void 0 ? _b : "";
  element.innerHTML = trustedHtml;
}
function renderSeparation(hostConfig, separationDefinition, orientation) {
  if (separationDefinition.spacing > 0 || separationDefinition.lineThickness && separationDefinition.lineThickness > 0) {
    var separator = document.createElement("div");
    separator.className = hostConfig.makeCssClassName("ac-" + (orientation === Enums.Orientation.Horizontal ? "horizontal" : "vertical") + "-separator");
    separator.setAttribute("aria-hidden", "true");
    var color = separationDefinition.lineColor ? Utils.stringToCssColor(separationDefinition.lineColor) : "";
    if (orientation === Enums.Orientation.Horizontal) {
      if (separationDefinition.lineThickness) {
        separator.style.paddingTop = separationDefinition.spacing / 2 + "px";
        separator.style.marginBottom = separationDefinition.spacing / 2 + "px";
        separator.style.borderBottom = separationDefinition.lineThickness + "px solid " + color;
      } else {
        separator.style.height = separationDefinition.spacing + "px";
      }
    } else {
      if (separationDefinition.lineThickness) {
        separator.style.paddingLeft = separationDefinition.spacing / 2 + "px";
        separator.style.marginRight = separationDefinition.spacing / 2 + "px";
        separator.style.borderRight = separationDefinition.lineThickness + "px solid " + color;
      } else {
        separator.style.width = separationDefinition.spacing + "px";
      }
    }
    separator.style.overflow = "hidden";
    separator.style.flex = "0 0 auto";
    return separator;
  } else {
    return undefined;
  }
}
exports.renderSeparation = renderSeparation;
var CardElement = /** @class */function (_super) {
  __extends(CardElement, _super);
  function CardElement() {
    //#region Schema
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._truncatedDueToOverflow = false;
    return _this;
  }
  Object.defineProperty(CardElement.prototype, "lang", {
    get: function () {
      var lang = this.getValue(CardElement.langProperty);
      if (lang) {
        return lang;
      } else {
        if (this.parent) {
          return this.parent.lang;
        } else {
          return undefined;
        }
      }
    },
    set: function (value) {
      this.setValue(CardElement.langProperty, value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CardElement.prototype, "isVisible", {
    get: function () {
      return this.getValue(CardElement.isVisibleProperty);
    },
    set: function (value) {
      // If the element is going to be hidden, reset any changes that were due
      // to overflow truncation (this ensures that if the element is later
      // un-hidden it has the right content)
      if (shared_1.GlobalSettings.useAdvancedCardBottomTruncation && !value) {
        this.undoOverflowTruncation();
      }
      if (this.isVisible !== value) {
        this.setValue(CardElement.isVisibleProperty, value);
        this.updateRenderedElementVisibility();
        if (this._renderedElement) {
          raiseElementVisibilityChangedEvent(this);
        }
      }
      if (this._renderedElement) {
        this._renderedElement.setAttribute("aria-expanded", value.toString());
      }
    },
    enumerable: false,
    configurable: true
  });
  CardElement.prototype.internalRenderSeparator = function () {
    var renderedSeparator = renderSeparation(this.hostConfig, {
      spacing: this.hostConfig.getEffectiveSpacing(this.spacing),
      lineThickness: this.separator ? this.hostConfig.separator.lineThickness : undefined,
      lineColor: this.separator ? this.hostConfig.separator.lineColor : undefined
    }, this.separatorOrientation);
    if (shared_1.GlobalSettings.alwaysBleedSeparators && renderedSeparator && this.separatorOrientation === Enums.Orientation.Horizontal) {
      // Adjust separator's margins if the option to always bleed separators is turned on
      var parentContainer = this.getParentContainer();
      if (parentContainer && parentContainer.getEffectivePadding()) {
        var parentPhysicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(parentContainer.getEffectivePadding());
        renderedSeparator.style.marginLeft = "-" + parentPhysicalPadding.left + "px";
        renderedSeparator.style.marginRight = "-" + parentPhysicalPadding.right + "px";
      }
    }
    return renderedSeparator;
  };
  CardElement.prototype.updateRenderedElementVisibility = function () {
    var displayMode = this.isDesignMode() || this.isVisible ? this._defaultRenderedElementDisplayMode : "none";
    if (this._renderedElement) {
      if (displayMode) {
        this._renderedElement.style.display = displayMode;
      } else {
        this._renderedElement.style.removeProperty("display");
      }
    }
    if (this._separatorElement) {
      if (this.parent && this.parent.isFirstElement(this)) {
        this._separatorElement.style.display = "none";
      } else {
        if (displayMode) {
          this._separatorElement.style.display = displayMode;
        } else {
          this._separatorElement.style.removeProperty("display");
        }
      }
    }
  };
  CardElement.prototype.hideElementDueToOverflow = function () {
    if (this._renderedElement && this.isVisible) {
      this._renderedElement.style.visibility = "hidden";
      this.isVisible = false;
      raiseElementVisibilityChangedEvent(this, false);
    }
  };
  CardElement.prototype.showElementHiddenDueToOverflow = function () {
    if (this._renderedElement && !this.isVisible) {
      this._renderedElement.style.removeProperty("visibility");
      this.isVisible = true;
      raiseElementVisibilityChangedEvent(this, false);
    }
  };
  // Marked private to emulate internal access
  CardElement.prototype.handleOverflow = function (maxHeight) {
    if (this.isVisible || this.isHiddenDueToOverflow()) {
      var handled = this.truncateOverflow(maxHeight);
      // Even if we were unable to truncate the element to fit this time,
      // it still could have been previously truncated
      this._truncatedDueToOverflow = handled || this._truncatedDueToOverflow;
      if (!handled) {
        this.hideElementDueToOverflow();
      } else if (handled && !this.isVisible) {
        this.showElementHiddenDueToOverflow();
      }
    }
  };
  // Marked private to emulate internal access
  CardElement.prototype.resetOverflow = function () {
    var sizeChanged = false;
    if (this._truncatedDueToOverflow) {
      this.undoOverflowTruncation();
      this._truncatedDueToOverflow = false;
      sizeChanged = true;
    }
    if (this.isHiddenDueToOverflow()) {
      this.showElementHiddenDueToOverflow();
    }
    return sizeChanged;
  };
  CardElement.prototype.getDefaultSerializationContext = function () {
    return new SerializationContext();
  };
  CardElement.prototype.createPlaceholderElement = function () {
    var styleDefinition = this.getEffectiveStyleDefinition();
    var foregroundCssColor = Utils.stringToCssColor(styleDefinition.foregroundColors.default.subtle);
    var element = document.createElement("div");
    element.style.border = "1px dashed " + foregroundCssColor;
    element.style.padding = "4px";
    element.style.minHeight = "32px";
    element.style.fontSize = "10px";
    if (foregroundCssColor) {
      element.style.color = foregroundCssColor;
    }
    element.innerText = strings_1.Strings.defaults.emptyElementText(this.getJsonTypeName());
    return element;
  };
  CardElement.prototype.adjustRenderedElementSize = function (renderedElement) {
    if (this.height === "auto") {
      renderedElement.style.flex = "0 0 auto";
    } else {
      renderedElement.style.flex = "1 1 auto";
    }
  };
  /*
   * Called when mouse enters or leaves the card.
   * Inputs elements need to update their visual state in such events like showing or hiding borders etc.
   * It calls Input.updateVisualState(eventType) for all inputs.
   * This method on input (updateVisualState) is supposed to be called from card level on mouse events.
   */
  CardElement.prototype.updateInputsVisualState = function (hover) {
    var allInputs = this.getAllInputs();
    var inputEventType = !!hover ? InputEventType.MouseEnterOnCard : InputEventType.MouseLeaveOnCard;
    allInputs.forEach(function (input) {
      return input.updateVisualState(inputEventType);
    });
  };
  CardElement.prototype.isDisplayed = function () {
    return this._renderedElement !== undefined && this.isVisible && this._renderedElement.offsetHeight > 0;
  };
  CardElement.prototype.overrideInternalRender = function () {
    return this.internalRender();
  };
  CardElement.prototype.applyPadding = function () {
    if (this.separatorElement && this.separatorOrientation === Enums.Orientation.Horizontal) {
      if (shared_1.GlobalSettings.alwaysBleedSeparators && !this.isBleeding()) {
        var padding = new shared_1.PaddingDefinition();
        this.getImmediateSurroundingPadding(padding);
        var physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(padding);
        this.separatorElement.style.marginLeft = "-" + physicalPadding.left + "px";
        this.separatorElement.style.marginRight = "-" + physicalPadding.right + "px";
      } else {
        this.separatorElement.style.marginRight = "0";
        this.separatorElement.style.marginLeft = "0";
      }
    }
  };
  /*
   * Called when this element overflows the bottom of the card.
   * maxHeight will be the amount of space still available on the card (0 if
   * the element is fully off the card).
   */
  CardElement.prototype.truncateOverflow = function (_maxHeight) {
    // Child implementations should return true if the element handled
    // the truncation request such that its content fits within maxHeight,
    // false if the element should fall back to being hidden
    return false;
  };
  /*
   * This should reverse any changes performed in truncateOverflow().
   */
  CardElement.prototype.undoOverflowTruncation = function () {
    return;
  };
  CardElement.prototype.getDefaultPadding = function () {
    return new shared_1.PaddingDefinition();
  };
  CardElement.prototype.getHasBackground = function (ignoreBackgroundImages) {
    if (ignoreBackgroundImages === void 0) {
      ignoreBackgroundImages = false;
    }
    return false;
  };
  CardElement.prototype.getHasBorder = function () {
    return false;
  };
  CardElement.prototype.getPadding = function () {
    return this._padding;
  };
  CardElement.prototype.setPadding = function (value) {
    this._padding = value;
  };
  CardElement.prototype.shouldSerialize = function (context) {
    return context.elementRegistry.findByName(this.getJsonTypeName()) !== undefined;
  };
  Object.defineProperty(CardElement.prototype, "useDefaultSizing", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CardElement.prototype, "separatorOrientation", {
    get: function () {
      return Enums.Orientation.Horizontal;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CardElement.prototype, "defaultStyle", {
    get: function () {
      return Enums.ContainerStyle.Default;
    },
    enumerable: false,
    configurable: true
  });
  CardElement.prototype.parse = function (source, context) {
    _super.prototype.parse.call(this, source, context ? context : new SerializationContext());
  };
  CardElement.prototype.asString = function () {
    return "";
  };
  CardElement.prototype.isBleeding = function () {
    return false;
  };
  CardElement.prototype.getEffectiveStyle = function () {
    if (this.parent) {
      return this.parent.getEffectiveStyle();
    }
    return this.defaultStyle;
  };
  CardElement.prototype.getEffectiveStyleDefinition = function () {
    return this.hostConfig.containerStyles.getStyleByName(this.getEffectiveStyle());
  };
  CardElement.prototype.getEffectiveTextStyleDefinition = function () {
    if (this.parent) {
      return this.parent.getEffectiveTextStyleDefinition();
    }
    return this.hostConfig.textStyles.default;
  };
  CardElement.prototype.getForbiddenActionTypes = function () {
    return [];
  };
  CardElement.prototype.getImmediateSurroundingPadding = function (result, processTop, processRight, processBottom, processLeft) {
    if (processTop === void 0) {
      processTop = true;
    }
    if (processRight === void 0) {
      processRight = true;
    }
    if (processBottom === void 0) {
      processBottom = true;
    }
    if (processLeft === void 0) {
      processLeft = true;
    }
    if (this.parent) {
      var doProcessTop = processTop && this.parent.isTopElement(this);
      var doProcessRight = processRight && this.parent.isRightMostElement(this);
      var doProcessBottom = processBottom && this.parent.isBottomElement(this);
      var doProcessLeft = processLeft && this.parent.isLeftMostElement(this);
      var effectivePadding = this.parent.getEffectivePadding();
      if (effectivePadding) {
        if (doProcessTop && effectivePadding.top !== Enums.Spacing.None) {
          result.top = effectivePadding.top;
          doProcessTop = false;
        }
        if (doProcessRight && effectivePadding.right !== Enums.Spacing.None) {
          result.right = effectivePadding.right;
          doProcessRight = false;
        }
        if (doProcessBottom && effectivePadding.bottom !== Enums.Spacing.None) {
          result.bottom = effectivePadding.bottom;
          doProcessBottom = false;
        }
        if (doProcessLeft && effectivePadding.left !== Enums.Spacing.None) {
          result.left = effectivePadding.left;
          doProcessLeft = false;
        }
      }
      if (doProcessTop || doProcessRight || doProcessBottom || doProcessLeft) {
        this.parent.getImmediateSurroundingPadding(result, doProcessTop, doProcessRight, doProcessBottom, doProcessLeft);
      }
    }
  };
  CardElement.prototype.getActionCount = function () {
    return 0;
  };
  CardElement.prototype.getActionAt = function (index) {
    throw new Error(strings_1.Strings.errors.indexOutOfRange(index));
  };
  CardElement.prototype.indexOfAction = function (action) {
    for (var i = 0; i < this.getActionCount(); i++) {
      if (this.getActionAt(i) === action) {
        return i;
      }
    }
    return -1;
  };
  CardElement.prototype.remove = function () {
    if (this.parent && this.parent instanceof CardElementContainer) {
      return this.parent.removeItem(this);
    }
    return false;
  };
  CardElement.prototype.render = function () {
    this._renderedElement = this.overrideInternalRender();
    this._separatorElement = this.internalRenderSeparator();
    if (this._renderedElement) {
      if (this.id) {
        this._renderedElement.id = this.id;
      }
      if (this.customCssSelector) {
        this._renderedElement.classList.add(this.customCssSelector);
      }
      this._renderedElement.style.boxSizing = "border-box";
      this._defaultRenderedElementDisplayMode = this._renderedElement.style.display ? this._renderedElement.style.display : undefined;
      this.adjustRenderedElementSize(this._renderedElement);
      this.updateLayout(false);
    } else if (this.isDesignMode()) {
      this._renderedElement = this.createPlaceholderElement();
    }
    return this._renderedElement;
  };
  CardElement.prototype.updateLayout = function (_processChildren) {
    if (_processChildren === void 0) {
      _processChildren = true;
    }
    this.updateRenderedElementVisibility();
    this.applyPadding();
  };
  CardElement.prototype.updateActionsEnabledState = function () {
    var allActions = this.getRootElement().getAllActions();
    for (var _i = 0, allActions_1 = allActions; _i < allActions_1.length; _i++) {
      var action = allActions_1[_i];
      action.updateEnabledState();
    }
  };
  CardElement.prototype.indexOf = function (_cardElement) {
    return -1;
  };
  CardElement.prototype.isDesignMode = function () {
    var rootElement = this.getRootElement();
    return rootElement instanceof AdaptiveCard && rootElement.designMode;
  };
  CardElement.prototype.isFirstElement = function (_element) {
    return true;
  };
  CardElement.prototype.isLastElement = function (_element) {
    return true;
  };
  CardElement.prototype.isAtTheVeryLeft = function () {
    return this.parent ? this.parent.isLeftMostElement(this) && this.parent.isAtTheVeryLeft() : true;
  };
  CardElement.prototype.isAtTheVeryRight = function () {
    return this.parent ? this.parent.isRightMostElement(this) && this.parent.isAtTheVeryRight() : true;
  };
  CardElement.prototype.isAtTheVeryTop = function () {
    return this.parent ? this.parent.isFirstElement(this) && this.parent.isAtTheVeryTop() : true;
  };
  CardElement.prototype.isAtTheVeryBottom = function () {
    return this.parent ? this.parent.isLastElement(this) && this.parent.isAtTheVeryBottom() : true;
  };
  CardElement.prototype.isBleedingAtTop = function () {
    return false;
  };
  CardElement.prototype.isBleedingAtBottom = function () {
    return false;
  };
  CardElement.prototype.isLeftMostElement = function (_element) {
    return true;
  };
  CardElement.prototype.isRightMostElement = function (_element) {
    return true;
  };
  CardElement.prototype.isTopElement = function (element) {
    return this.isFirstElement(element);
  };
  CardElement.prototype.isBottomElement = function (element) {
    return this.isLastElement(element);
  };
  CardElement.prototype.isHiddenDueToOverflow = function () {
    return this._renderedElement !== undefined && this._renderedElement.style.visibility === "hidden";
  };
  CardElement.prototype.getRootElement = function () {
    return this.getRootObject();
  };
  CardElement.prototype.getParentContainer = function () {
    var currentElement = this.parent;
    while (currentElement) {
      if (currentElement instanceof Container) {
        return currentElement;
      }
      currentElement = currentElement.parent;
    }
    return undefined;
  };
  CardElement.prototype.getAllInputs = function (processActions) {
    if (processActions === void 0) {
      processActions = true;
    }
    return [];
  };
  CardElement.prototype.getAllActions = function () {
    var result = [];
    for (var i = 0; i < this.getActionCount(); i++) {
      var action = this.getActionAt(i);
      if (action) {
        result.push(action);
      }
    }
    return result;
  };
  CardElement.prototype.getResourceInformation = function () {
    return [];
  };
  CardElement.prototype.getElementById = function (id) {
    return this.id === id ? this : undefined;
  };
  CardElement.prototype.getActionById = function (_id) {
    return undefined;
  };
  CardElement.prototype.getElementByIdFromAction = function (id) {
    var result = undefined;
    for (var i = 0; i < this.getActionCount(); i++) {
      var action = this.getActionAt(i);
      if (action instanceof ShowCardAction) {
        result = action.card.getElementById(id);
        if (result) {
          break;
        }
      }
    }
    return result;
  };
  CardElement.prototype.getEffectivePadding = function () {
    var padding = this.getPadding();
    return padding ? padding : this.getDefaultPadding();
  };
  CardElement.prototype.getEffectiveHorizontalAlignment = function () {
    if (this.horizontalAlignment !== undefined) {
      return this.horizontalAlignment;
    }
    if (this.parent) {
      return this.parent.getEffectiveHorizontalAlignment();
    }
    return Enums.HorizontalAlignment.Left;
  };
  Object.defineProperty(CardElement.prototype, "hostConfig", {
    get: function () {
      if (this._hostConfig) {
        return this._hostConfig;
      } else {
        if (this.parent) {
          return this.parent.hostConfig;
        } else {
          return host_config_1.defaultHostConfig;
        }
      }
    },
    set: function (value) {
      this._hostConfig = value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CardElement.prototype, "index", {
    get: function () {
      if (this.parent) {
        return this.parent.indexOf(this);
      } else {
        return 0;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CardElement.prototype, "isInteractive", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CardElement.prototype, "isStandalone", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CardElement.prototype, "isInline", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CardElement.prototype, "hasVisibleSeparator", {
    get: function () {
      if (this.parent && this.separatorElement) {
        return !this.parent.isFirstElement(this) && (this.isVisible || this.isDesignMode());
      } else {
        return false;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CardElement.prototype, "separatorElement", {
    get: function () {
      return this._separatorElement;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CardElement.prototype, "parent", {
    get: function () {
      return this._parent;
    },
    enumerable: false,
    configurable: true
  });
  CardElement.langProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_1, "lang", true, /^[a-z]{2,3}$/gi);
  CardElement.isVisibleProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_2, "isVisible", true);
  CardElement.separatorProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_0, "separator", false);
  CardElement.heightProperty = new serialization_1.ValueSetProperty(serialization_1.Versions.v1_1, "height", [{
    value: "auto"
  }, {
    value: "stretch"
  }], "auto");
  CardElement.horizontalAlignmentProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_0, "horizontalAlignment", Enums.HorizontalAlignment);
  CardElement.spacingProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_0, "spacing", Enums.Spacing, Enums.Spacing.Default);
  __decorate([(0, serialization_1.property)(CardElement.horizontalAlignmentProperty)], CardElement.prototype, "horizontalAlignment", void 0);
  __decorate([(0, serialization_1.property)(CardElement.spacingProperty)], CardElement.prototype, "spacing", void 0);
  __decorate([(0, serialization_1.property)(CardElement.separatorProperty)], CardElement.prototype, "separator", void 0);
  __decorate([(0, serialization_1.property)(CardElement.heightProperty)], CardElement.prototype, "height", void 0);
  __decorate([(0, serialization_1.property)(CardElement.langProperty)], CardElement.prototype, "lang", null);
  __decorate([(0, serialization_1.property)(CardElement.isVisibleProperty)], CardElement.prototype, "isVisible", null);
  return CardElement;
}(card_object_1.CardObject);
exports.CardElement = CardElement;
var ActionProperty = /** @class */function (_super) {
  __extends(ActionProperty, _super);
  function ActionProperty(targetVersion, name, forbiddenActionTypes) {
    if (forbiddenActionTypes === void 0) {
      forbiddenActionTypes = [];
    }
    var _this = _super.call(this, targetVersion, name, undefined) || this;
    _this.targetVersion = targetVersion;
    _this.name = name;
    _this.forbiddenActionTypes = forbiddenActionTypes;
    return _this;
  }
  ActionProperty.prototype.parse = function (sender, source, context) {
    var parent = sender;
    return context.parseAction(parent, source[this.name], this.forbiddenActionTypes, parent.isDesignMode());
  };
  ActionProperty.prototype.toJSON = function (sender, target, value, context) {
    context.serializeValue(target, this.name, value ? value.toJSON(context) : undefined, undefined, true);
  };
  return ActionProperty;
}(serialization_1.PropertyDefinition);
exports.ActionProperty = ActionProperty;
var BaseTextBlock = /** @class */function (_super) {
  __extends(BaseTextBlock, _super);
  function BaseTextBlock(text) {
    var _this = _super.call(this) || this;
    _this.ariaHidden = false;
    if (text) {
      _this.text = text;
    }
    return _this;
  }
  BaseTextBlock.prototype.populateSchema = function (schema) {
    _super.prototype.populateSchema.call(this, schema);
    // selectAction is declared on BaseTextBlock but is only exposed on TextRun,
    // so the property is removed from the BaseTextBlock schema.
    schema.remove(BaseTextBlock.selectActionProperty);
  };
  Object.defineProperty(BaseTextBlock.prototype, "text", {
    get: function () {
      return this.getValue(BaseTextBlock.textProperty);
    },
    set: function (value) {
      this.setText(value);
    },
    enumerable: false,
    configurable: true
  });
  //#endregion
  BaseTextBlock.prototype.getFontSize = function (fontType) {
    switch (this.effectiveSize) {
      case Enums.TextSize.Small:
        return fontType.fontSizes.small;
      case Enums.TextSize.Medium:
        return fontType.fontSizes.medium;
      case Enums.TextSize.Large:
        return fontType.fontSizes.large;
      case Enums.TextSize.ExtraLarge:
        return fontType.fontSizes.extraLarge;
      default:
        return fontType.fontSizes.default;
    }
  };
  BaseTextBlock.prototype.getColorDefinition = function (colorSet, color) {
    switch (color) {
      case Enums.TextColor.Accent:
        return colorSet.accent;
      case Enums.TextColor.Dark:
        return colorSet.dark;
      case Enums.TextColor.Light:
        return colorSet.light;
      case Enums.TextColor.Good:
        return colorSet.good;
      case Enums.TextColor.Warning:
        return colorSet.warning;
      case Enums.TextColor.Attention:
        return colorSet.attention;
      default:
        return colorSet.default;
    }
  };
  BaseTextBlock.prototype.setText = function (value) {
    this.setValue(BaseTextBlock.textProperty, value);
  };
  BaseTextBlock.prototype.init = function (textDefinition) {
    this.size = textDefinition.size;
    this.weight = textDefinition.weight;
    this.color = textDefinition.color;
    this.isSubtle = textDefinition.isSubtle;
  };
  BaseTextBlock.prototype.asString = function () {
    return this.text;
  };
  BaseTextBlock.prototype.applyStylesTo = function (targetElement) {
    var fontType = this.hostConfig.getFontTypeDefinition(this.effectiveFontType);
    if (fontType.fontFamily) {
      targetElement.style.fontFamily = fontType.fontFamily;
    }
    var fontSize;
    switch (this.effectiveSize) {
      case Enums.TextSize.Small:
        fontSize = fontType.fontSizes.small;
        break;
      case Enums.TextSize.Medium:
        fontSize = fontType.fontSizes.medium;
        break;
      case Enums.TextSize.Large:
        fontSize = fontType.fontSizes.large;
        break;
      case Enums.TextSize.ExtraLarge:
        fontSize = fontType.fontSizes.extraLarge;
        break;
      default:
        fontSize = fontType.fontSizes.default;
        break;
    }
    targetElement.style.fontSize = fontSize + "px";
    var colorDefinition = this.getColorDefinition(this.getEffectiveStyleDefinition().foregroundColors, this.effectiveColor);
    var targetColor = Utils.stringToCssColor(this.effectiveIsSubtle ? colorDefinition.subtle : colorDefinition.default);
    if (targetColor) {
      targetElement.style.color = targetColor;
    }
    var fontWeight;
    switch (this.effectiveWeight) {
      case Enums.TextWeight.Lighter:
        fontWeight = fontType.fontWeights.lighter;
        break;
      case Enums.TextWeight.Bolder:
        fontWeight = fontType.fontWeights.bolder;
        break;
      default:
        fontWeight = fontType.fontWeights.default;
        break;
    }
    targetElement.style.fontWeight = fontWeight.toString();
    if (this.ariaHidden) {
      targetElement.setAttribute("aria-hidden", "true");
    }
  };
  BaseTextBlock.prototype.getAllActions = function () {
    var result = _super.prototype.getAllActions.call(this);
    if (this.selectAction) {
      result.push(this.selectAction);
    }
    return result;
  };
  Object.defineProperty(BaseTextBlock.prototype, "effectiveColor", {
    get: function () {
      return this.color !== undefined ? this.color : this.getEffectiveTextStyleDefinition().color;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseTextBlock.prototype, "effectiveFontType", {
    get: function () {
      return this.fontType !== undefined ? this.fontType : this.getEffectiveTextStyleDefinition().fontType;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseTextBlock.prototype, "effectiveIsSubtle", {
    get: function () {
      return this.isSubtle !== undefined ? this.isSubtle : this.getEffectiveTextStyleDefinition().isSubtle;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseTextBlock.prototype, "effectiveSize", {
    get: function () {
      return this.size !== undefined ? this.size : this.getEffectiveTextStyleDefinition().size;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(BaseTextBlock.prototype, "effectiveWeight", {
    get: function () {
      return this.weight !== undefined ? this.weight : this.getEffectiveTextStyleDefinition().weight;
    },
    enumerable: false,
    configurable: true
  });
  //#region Schema
  BaseTextBlock.textProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "text", true);
  BaseTextBlock.sizeProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_0, "size", Enums.TextSize);
  BaseTextBlock.weightProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_0, "weight", Enums.TextWeight);
  BaseTextBlock.colorProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_0, "color", Enums.TextColor);
  BaseTextBlock.isSubtleProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_0, "isSubtle");
  BaseTextBlock.fontTypeProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_2, "fontType", Enums.FontType);
  BaseTextBlock.selectActionProperty = new ActionProperty(serialization_1.Versions.v1_1, "selectAction", ["Action.ShowCard"]);
  __decorate([(0, serialization_1.property)(BaseTextBlock.sizeProperty)], BaseTextBlock.prototype, "size", void 0);
  __decorate([(0, serialization_1.property)(BaseTextBlock.weightProperty)], BaseTextBlock.prototype, "weight", void 0);
  __decorate([(0, serialization_1.property)(BaseTextBlock.colorProperty)], BaseTextBlock.prototype, "color", void 0);
  __decorate([(0, serialization_1.property)(BaseTextBlock.fontTypeProperty)], BaseTextBlock.prototype, "fontType", void 0);
  __decorate([(0, serialization_1.property)(BaseTextBlock.isSubtleProperty)], BaseTextBlock.prototype, "isSubtle", void 0);
  __decorate([(0, serialization_1.property)(BaseTextBlock.textProperty)], BaseTextBlock.prototype, "text", null);
  __decorate([(0, serialization_1.property)(BaseTextBlock.selectActionProperty)], BaseTextBlock.prototype, "selectAction", void 0);
  return BaseTextBlock;
}(CardElement);
exports.BaseTextBlock = BaseTextBlock;
var TextBlock = /** @class */function (_super) {
  __extends(TextBlock, _super);
  function TextBlock() {
    //#region Schema
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.wrap = false;
    _this._treatAsPlainText = true;
    _this.useMarkdown = true;
    return _this;
  }
  TextBlock.prototype.restoreOriginalContent = function () {
    var _a, _b;
    if (this.renderedElement !== undefined) {
      if (this.maxLines && this.maxLines > 0) {
        this.renderedElement.style.maxHeight = this._computedLineHeight * this.maxLines + "px";
      }
      var originalHtml = (_b = (_a = TextBlock._ttRoundtripPolicy) === null || _a === void 0 ? void 0 : _a.createHTML(this._originalInnerHtml)) !== null && _b !== void 0 ? _b : this._originalInnerHtml;
      this.renderedElement.innerHTML = originalHtml;
    }
  };
  TextBlock.prototype.truncateIfSupported = function (maxHeight) {
    if (this.renderedElement !== undefined) {
      // For now, only truncate TextBlocks that contain just a single
      // paragraph -- since the maxLines calculation doesn't take into
      // account Markdown lists
      var children = this.renderedElement.children;
      var isTextOnly = !children.length;
      var truncationSupported = isTextOnly || children.length === 1 && children[0].tagName.toLowerCase() === "p" && !children[0].children.length;
      if (truncationSupported) {
        var element = isTextOnly ? this.renderedElement : children[0];
        Utils.truncateText(element, maxHeight, this._computedLineHeight);
        return true;
      }
    }
    return false;
  };
  TextBlock.prototype.setText = function (value) {
    _super.prototype.setText.call(this, value);
    this._processedText = undefined;
  };
  TextBlock.prototype.internalRender = function () {
    var _this = this;
    var _a, _b;
    this._processedText = undefined;
    if (this.text) {
      var preProcessedText = this.preProcessPropertyValue(BaseTextBlock.textProperty);
      var hostConfig = this.hostConfig;
      var element = void 0;
      if (this.forElementId) {
        var labelElement = document.createElement("label");
        labelElement.htmlFor = this.forElementId;
        element = labelElement;
      } else {
        element = document.createElement("div");
      }
      element.classList.add(hostConfig.makeCssClassName("ac-textBlock"));
      element.style.overflow = "hidden";
      this.applyStylesTo(element);
      if (this.style === "heading") {
        element.setAttribute("role", "heading");
        var headingLevel = this.hostConfig.textBlock.headingLevel;
        if (headingLevel !== undefined && headingLevel > 0) {
          element.setAttribute("aria-level", headingLevel.toString());
        }
      }
      if (this.selectAction && hostConfig.supportsInteractivity) {
        element.onclick = function (e) {
          if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
            e.preventDefault();
            e.cancelBubble = true;
            _this.selectAction.execute();
          }
        };
        this.selectAction.setupElementForAccessibility(element);
        if (this.selectAction.isEffectivelyEnabled()) {
          element.classList.add(hostConfig.makeCssClassName("ac-selectable"));
        }
      }
      if (!this._processedText) {
        this._treatAsPlainText = true;
        var formattedText = TextFormatters.formatText(this.lang, preProcessedText);
        if (this.useMarkdown && formattedText) {
          if (shared_1.GlobalSettings.allowMarkForTextHighlighting) {
            formattedText = formattedText.replace(/<mark>/g, "===").replace(/<\/mark>/g, "/==/");
          }
          var markdownProcessingResult = AdaptiveCard.applyMarkdown(formattedText);
          if (markdownProcessingResult.didProcess && markdownProcessingResult.outputHtml) {
            this._processedText = markdownProcessingResult.outputHtml;
            this._treatAsPlainText = false;
            // Only process <mark> tag if markdown processing was applied because
            // markdown processing is also responsible for sanitizing the input string
            if (shared_1.GlobalSettings.allowMarkForTextHighlighting && this._processedText) {
              var markStyle = "";
              var effectiveStyle = this.getEffectiveStyleDefinition();
              if (effectiveStyle.highlightBackgroundColor) {
                markStyle += "background-color: " + effectiveStyle.highlightBackgroundColor + ";";
              }
              if (effectiveStyle.highlightForegroundColor) {
                markStyle += "color: " + effectiveStyle.highlightForegroundColor + ";";
              }
              if (markStyle) {
                markStyle = 'style="' + markStyle + '"';
              }
              this._processedText = this._processedText.replace(/===/g, "<mark " + markStyle + ">").replace(/\/==\//g, "</mark>");
            }
          } else {
            this._processedText = formattedText;
            this._treatAsPlainText = true;
          }
        } else {
          this._processedText = formattedText;
          this._treatAsPlainText = true;
        }
      }
      if (!this._processedText) {
        this._processedText = "";
      }
      if (this._treatAsPlainText) {
        element.innerText = this._processedText;
      } else {
        var processedHtml = (_b = (_a = TextBlock._ttMarkdownPolicy) === null || _a === void 0 ? void 0 : _a.createHTML(this._processedText)) !== null && _b !== void 0 ? _b : this._processedText;
        element.innerHTML = processedHtml;
      }
      if (element.firstElementChild instanceof HTMLElement) {
        var firstElementChild = element.firstElementChild;
        firstElementChild.style.marginTop = "0px";
        firstElementChild.style.width = "100%";
        if (!this.wrap) {
          firstElementChild.style.overflow = "hidden";
          firstElementChild.style.textOverflow = "ellipsis";
        }
      }
      if (element.lastElementChild instanceof HTMLElement) {
        element.lastElementChild.style.marginBottom = "0px";
      }
      var anchors = element.getElementsByTagName("a");
      var _loop_1 = function (anchor) {
        anchor.classList.add(hostConfig.makeCssClassName("ac-anchor"));
        anchor.target = "_blank";
        anchor.onclick = function (e) {
          if (raiseAnchorClickedEvent(_this, anchor, e)) {
            e.preventDefault();
            e.cancelBubble = true;
          }
        };
        anchor.oncontextmenu = function (e) {
          if (raiseAnchorClickedEvent(_this, anchor, e)) {
            e.preventDefault();
            e.cancelBubble = true;
            return false;
          }
          return true;
        };
      };
      for (var _i = 0, _c = Array.from(anchors); _i < _c.length; _i++) {
        var anchor = _c[_i];
        _loop_1(anchor);
      }
      if (this.wrap) {
        element.style.wordWrap = "break-word";
        if (this.maxLines && this.maxLines > 0) {
          element.style.overflow = "hidden";
          if (Utils.isInternetExplorer() || !shared_1.GlobalSettings.useWebkitLineClamp) {
            element.style.maxHeight = this._computedLineHeight * this.maxLines + "px";
          } else {
            // While non standard, --webkit-line-clamp works in every browser (except IE)
            // and is a great solution to support the maxLines feature with ellipsis
            // truncation. With --webkit-line-clamp there is need to use explicit line heights
            element.style.removeProperty("line-height");
            element.style.display = "-webkit-box";
            element.style.webkitBoxOrient = "vertical";
            element.style.webkitLineClamp = this.maxLines.toString();
          }
        }
      } else {
        element.style.whiteSpace = "nowrap";
        element.style.textOverflow = "ellipsis";
      }
      if (shared_1.GlobalSettings.useAdvancedTextBlockTruncation || shared_1.GlobalSettings.useAdvancedCardBottomTruncation) {
        this._originalInnerHtml = element.innerHTML;
      }
      return element;
    } else {
      return undefined;
    }
  };
  TextBlock.prototype.truncateOverflow = function (maxHeight) {
    if (maxHeight >= this._computedLineHeight) {
      return this.truncateIfSupported(maxHeight);
    }
    return false;
  };
  TextBlock.prototype.undoOverflowTruncation = function () {
    this.restoreOriginalContent();
    if (shared_1.GlobalSettings.useAdvancedTextBlockTruncation && this.maxLines) {
      var maxHeight = this._computedLineHeight * this.maxLines;
      this.truncateIfSupported(maxHeight);
    }
  };
  TextBlock.prototype.applyStylesTo = function (targetElement) {
    _super.prototype.applyStylesTo.call(this, targetElement);
    switch (this.getEffectiveHorizontalAlignment()) {
      case Enums.HorizontalAlignment.Center:
        targetElement.style.textAlign = "center";
        break;
      case Enums.HorizontalAlignment.Right:
        targetElement.style.textAlign = "end";
        break;
      default:
        targetElement.style.textAlign = "start";
        break;
    }
    var lineHeights = this.hostConfig.lineHeights;
    if (lineHeights) {
      switch (this.effectiveSize) {
        case Enums.TextSize.Small:
          this._computedLineHeight = lineHeights.small;
          break;
        case Enums.TextSize.Medium:
          this._computedLineHeight = lineHeights.medium;
          break;
        case Enums.TextSize.Large:
          this._computedLineHeight = lineHeights.large;
          break;
        case Enums.TextSize.ExtraLarge:
          this._computedLineHeight = lineHeights.extraLarge;
          break;
        default:
          this._computedLineHeight = lineHeights.default;
          break;
      }
    } else {
      // Looks like 1.33 is the magic number to compute line-height
      // from font size.
      this._computedLineHeight = this.getFontSize(this.hostConfig.getFontTypeDefinition(this.effectiveFontType)) * 1.33;
    }
    targetElement.style.lineHeight = this._computedLineHeight + "px";
  };
  TextBlock.prototype.getJsonTypeName = function () {
    return "TextBlock";
  };
  TextBlock.prototype.getEffectiveTextStyleDefinition = function () {
    if (this.style) {
      return this.hostConfig.textStyles.getStyleByName(this.style);
    }
    return _super.prototype.getEffectiveTextStyleDefinition.call(this);
  };
  TextBlock.prototype.updateLayout = function (processChildren) {
    if (processChildren === void 0) {
      processChildren = false;
    }
    _super.prototype.updateLayout.call(this, processChildren);
    if (shared_1.GlobalSettings.useAdvancedTextBlockTruncation && this.maxLines && this.isDisplayed()) {
      // Reset the element's innerHTML in case the available room for
      // content has increased
      this.restoreOriginalContent();
      this.truncateIfSupported(this._computedLineHeight * this.maxLines);
    }
  };
  var _a, _b;
  TextBlock.wrapProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_0, "wrap", false);
  TextBlock.maxLinesProperty = new serialization_1.NumProperty(serialization_1.Versions.v1_0, "maxLines");
  TextBlock.styleProperty = new serialization_1.ValueSetProperty(serialization_1.Versions.v1_5, "style", [{
    value: "default"
  }, {
    value: "columnHeader"
  }, {
    value: "heading"
  }]);
  // Markdown processing is handled outside of Adaptive Cards. It's up to the host to ensure that markdown is safely
  // processed.
  TextBlock._ttMarkdownPolicy = typeof window === 'undefined' ? undefined : (_a = window.trustedTypes) === null || _a === void 0 ? void 0 : _a.createPolicy("adaptivecards#markdownPassthroughPolicy", {
    createHTML: function (value) {
      return value;
    }
  });
  // When "advanced" truncation is enabled (see GlobalSettings.useAdvancedCardBottomTruncation and
  // GlobalSettings.useAdvancedTextBlockTruncation), we store the original pre-truncation content in
  // _originalInnerHtml so that we can restore/recalculate truncation later if space availability has changed (see
  // TextBlock.restoreOriginalContent())
  TextBlock._ttRoundtripPolicy = typeof window === 'undefined' ? undefined : (_b = window.trustedTypes) === null || _b === void 0 ? void 0 : _b.createPolicy("adaptivecards#restoreContentsPolicy", {
    createHTML: function (value) {
      return value;
    }
  });
  __decorate([(0, serialization_1.property)(TextBlock.wrapProperty)], TextBlock.prototype, "wrap", void 0);
  __decorate([(0, serialization_1.property)(TextBlock.maxLinesProperty)], TextBlock.prototype, "maxLines", void 0);
  __decorate([(0, serialization_1.property)(TextBlock.styleProperty)], TextBlock.prototype, "style", void 0);
  return TextBlock;
}(BaseTextBlock);
exports.TextBlock = TextBlock;
var TextRun = /** @class */function (_super) {
  __extends(TextRun, _super);
  function TextRun() {
    //#region Schema
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.italic = false;
    _this.strikethrough = false;
    _this.highlight = false;
    _this.underline = false;
    return _this;
  }
  TextRun.prototype.populateSchema = function (schema) {
    _super.prototype.populateSchema.call(this, schema);
    schema.add(BaseTextBlock.selectActionProperty);
  };
  //#endregion
  TextRun.prototype.internalRender = function () {
    var _this = this;
    if (this.text) {
      var preProcessedText = this.preProcessPropertyValue(BaseTextBlock.textProperty);
      var hostConfig = this.hostConfig;
      var formattedText = TextFormatters.formatText(this.lang, preProcessedText);
      if (!formattedText) {
        formattedText = "";
      }
      var element = document.createElement("span");
      element.classList.add(hostConfig.makeCssClassName("ac-textRun"));
      this.applyStylesTo(element);
      if (this.selectAction && hostConfig.supportsInteractivity) {
        var anchor = document.createElement("a");
        anchor.classList.add(hostConfig.makeCssClassName("ac-anchor"));
        var href = this.selectAction.getHref();
        anchor.href = href ? href : "";
        anchor.target = "_blank";
        anchor.onclick = function (e) {
          if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
            e.preventDefault();
            e.cancelBubble = true;
            _this.selectAction.execute();
          }
        };
        this.selectAction.setupElementForAccessibility(anchor);
        anchor.innerText = formattedText;
        element.appendChild(anchor);
      } else {
        element.innerText = formattedText;
      }
      return element;
    } else {
      return undefined;
    }
  };
  TextRun.prototype.applyStylesTo = function (targetElement) {
    _super.prototype.applyStylesTo.call(this, targetElement);
    if (this.italic) {
      targetElement.style.fontStyle = "italic";
    }
    if (this.strikethrough) {
      targetElement.style.textDecoration = "line-through";
    }
    if (this.highlight) {
      var colorDefinition = this.getColorDefinition(this.getEffectiveStyleDefinition().foregroundColors, this.effectiveColor);
      var backgroundColor = Utils.stringToCssColor(this.effectiveIsSubtle ? colorDefinition.highlightColors.subtle : colorDefinition.highlightColors.default);
      if (backgroundColor) {
        targetElement.style.backgroundColor = backgroundColor;
      }
    }
    if (this.underline) {
      targetElement.style.textDecoration = "underline";
    }
  };
  TextRun.prototype.getJsonTypeName = function () {
    return "TextRun";
  };
  Object.defineProperty(TextRun.prototype, "isStandalone", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(TextRun.prototype, "isInline", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  TextRun.italicProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_2, "italic", false);
  TextRun.strikethroughProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_2, "strikethrough", false);
  TextRun.highlightProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_2, "highlight", false);
  TextRun.underlineProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_3, "underline", false);
  __decorate([(0, serialization_1.property)(TextRun.italicProperty)], TextRun.prototype, "italic", void 0);
  __decorate([(0, serialization_1.property)(TextRun.strikethroughProperty)], TextRun.prototype, "strikethrough", void 0);
  __decorate([(0, serialization_1.property)(TextRun.highlightProperty)], TextRun.prototype, "highlight", void 0);
  __decorate([(0, serialization_1.property)(TextRun.underlineProperty)], TextRun.prototype, "underline", void 0);
  return TextRun;
}(BaseTextBlock);
exports.TextRun = TextRun;
var RichTextBlock = /** @class */function (_super) {
  __extends(RichTextBlock, _super);
  function RichTextBlock() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._inlines = [];
    return _this;
  }
  RichTextBlock.prototype.internalAddInline = function (inline, forceAdd) {
    if (forceAdd === void 0) {
      forceAdd = false;
    }
    if (!inline.isInline) {
      throw new Error(strings_1.Strings.errors.elementCannotBeUsedAsInline());
    }
    var doAdd = inline.parent === undefined || forceAdd;
    if (!doAdd && inline.parent !== this) {
      throw new Error(strings_1.Strings.errors.inlineAlreadyParented());
    } else {
      inline.setParent(this);
      this._inlines.push(inline);
    }
  };
  RichTextBlock.prototype.internalParse = function (source, context) {
    _super.prototype.internalParse.call(this, source, context);
    this._inlines = [];
    if (Array.isArray(source["inlines"])) {
      for (var _i = 0, _a = source["inlines"]; _i < _a.length; _i++) {
        var jsonInline = _a[_i];
        var inline = void 0;
        if (typeof jsonInline === "string") {
          var textRun = new TextRun();
          textRun.text = jsonInline;
          inline = textRun;
        } else {
          // No fallback for inlines in 1.2
          inline = context.parseElement(this, jsonInline, [], false);
        }
        if (inline) {
          this.internalAddInline(inline, true);
        }
      }
    }
  };
  RichTextBlock.prototype.internalToJSON = function (target, context) {
    _super.prototype.internalToJSON.call(this, target, context);
    if (this._inlines.length > 0) {
      var jsonInlines = [];
      for (var _i = 0, _a = this._inlines; _i < _a.length; _i++) {
        var inline = _a[_i];
        jsonInlines.push(inline.toJSON(context));
      }
      context.serializeValue(target, "inlines", jsonInlines);
    }
  };
  RichTextBlock.prototype.internalRender = function () {
    if (this._inlines.length > 0) {
      var element = void 0;
      if (this.forElementId) {
        var labelElement = document.createElement("label");
        labelElement.htmlFor = this.forElementId;
        element = labelElement;
      } else {
        element = document.createElement("div");
      }
      element.className = this.hostConfig.makeCssClassName("ac-richTextBlock");
      switch (this.getEffectiveHorizontalAlignment()) {
        case Enums.HorizontalAlignment.Center:
          element.style.textAlign = "center";
          break;
        case Enums.HorizontalAlignment.Right:
          element.style.textAlign = "end";
          break;
        default:
          element.style.textAlign = "start";
          break;
      }
      var renderedInlines = 0;
      for (var _i = 0, _a = this._inlines; _i < _a.length; _i++) {
        var inline = _a[_i];
        var renderedInline = inline.render();
        if (renderedInline) {
          element.appendChild(renderedInline);
          renderedInlines++;
        }
      }
      if (renderedInlines > 0) {
        return element;
      }
    }
    return undefined;
  };
  RichTextBlock.prototype.asString = function () {
    var result = "";
    for (var _i = 0, _a = this._inlines; _i < _a.length; _i++) {
      var inline = _a[_i];
      result += inline.asString();
    }
    return result;
  };
  RichTextBlock.prototype.getJsonTypeName = function () {
    return "RichTextBlock";
  };
  RichTextBlock.prototype.getInlineCount = function () {
    return this._inlines.length;
  };
  RichTextBlock.prototype.getInlineAt = function (index) {
    if (index >= 0 && index < this._inlines.length) {
      return this._inlines[index];
    } else {
      throw new Error(strings_1.Strings.errors.indexOutOfRange(index));
    }
  };
  RichTextBlock.prototype.addInline = function (inline) {
    if (typeof inline === "string") {
      this.internalAddInline(new TextRun(inline));
    } else {
      this.internalAddInline(inline);
    }
  };
  RichTextBlock.prototype.removeInline = function (inline) {
    var index = this._inlines.indexOf(inline);
    if (index >= 0) {
      this._inlines[index].setParent(undefined);
      this._inlines.splice(index, 1);
      return true;
    }
    return false;
  };
  return RichTextBlock;
}(CardElement);
exports.RichTextBlock = RichTextBlock;
var Fact = /** @class */function (_super) {
  __extends(Fact, _super);
  function Fact(name, value) {
    var _this = _super.call(this) || this;
    _this.name = name;
    _this.value = value;
    return _this;
  }
  //#endregion
  Fact.prototype.getSchemaKey = function () {
    return "Fact";
  };
  //#region Schema
  Fact.titleProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "title");
  Fact.valueProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "value");
  __decorate([(0, serialization_1.property)(Fact.titleProperty)], Fact.prototype, "name", void 0);
  __decorate([(0, serialization_1.property)(Fact.valueProperty)], Fact.prototype, "value", void 0);
  return Fact;
}(serialization_1.SerializableObject);
exports.Fact = Fact;
var FactSet = /** @class */function (_super) {
  __extends(FactSet, _super);
  function FactSet() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(FactSet.prototype, "useDefaultSizing", {
    //#endregion
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  FactSet.prototype.internalRender = function () {
    var element = undefined;
    var hostConfig = this.hostConfig;
    if (this.facts.length > 0) {
      element = document.createElement("table");
      element.style.borderWidth = "0px";
      element.style.borderSpacing = "0px";
      element.style.borderStyle = "none";
      element.style.borderCollapse = "collapse";
      element.style.display = "block";
      element.style.overflow = "hidden";
      element.classList.add(hostConfig.makeCssClassName("ac-factset"));
      element.setAttribute("role", "presentation");
      for (var i = 0; i < this.facts.length; i++) {
        var trElement = document.createElement("tr");
        if (i > 0) {
          trElement.style.marginTop = hostConfig.factSet.spacing + "px";
        }
        // Title column
        var tdElement = document.createElement("td");
        tdElement.style.padding = "0";
        tdElement.classList.add(hostConfig.makeCssClassName("ac-fact-title"));
        if (hostConfig.factSet.title.maxWidth) {
          tdElement.style.maxWidth = hostConfig.factSet.title.maxWidth + "px";
        }
        tdElement.style.verticalAlign = "top";
        var textBlock = new TextBlock();
        textBlock.setParent(this);
        textBlock.text = !this.facts[i].name && this.isDesignMode() ? "Title" : this.facts[i].name;
        textBlock.size = hostConfig.factSet.title.size;
        textBlock.color = hostConfig.factSet.title.color;
        textBlock.isSubtle = hostConfig.factSet.title.isSubtle;
        textBlock.weight = hostConfig.factSet.title.weight;
        textBlock.wrap = hostConfig.factSet.title.wrap;
        textBlock.spacing = Enums.Spacing.None;
        Utils.appendChild(tdElement, textBlock.render());
        Utils.appendChild(trElement, tdElement);
        // Spacer column
        tdElement = document.createElement("td");
        tdElement.style.width = "10px";
        Utils.appendChild(trElement, tdElement);
        // Value column
        tdElement = document.createElement("td");
        tdElement.style.padding = "0";
        tdElement.style.verticalAlign = "top";
        tdElement.classList.add(hostConfig.makeCssClassName("ac-fact-value"));
        textBlock = new TextBlock();
        textBlock.setParent(this);
        textBlock.text = this.facts[i].value;
        textBlock.size = hostConfig.factSet.value.size;
        textBlock.color = hostConfig.factSet.value.color;
        textBlock.isSubtle = hostConfig.factSet.value.isSubtle;
        textBlock.weight = hostConfig.factSet.value.weight;
        textBlock.wrap = hostConfig.factSet.value.wrap;
        textBlock.spacing = Enums.Spacing.None;
        Utils.appendChild(tdElement, textBlock.render());
        Utils.appendChild(trElement, tdElement);
        Utils.appendChild(element, trElement);
      }
    }
    return element;
  };
  FactSet.prototype.getJsonTypeName = function () {
    return "FactSet";
  };
  //#region Schema
  FactSet.factsProperty = new serialization_1.SerializableObjectCollectionProperty(serialization_1.Versions.v1_0, "facts", Fact);
  __decorate([(0, serialization_1.property)(FactSet.factsProperty)], FactSet.prototype, "facts", void 0);
  return FactSet;
}(CardElement);
exports.FactSet = FactSet;
var ImageDimensionProperty = /** @class */function (_super) {
  __extends(ImageDimensionProperty, _super);
  function ImageDimensionProperty(targetVersion, name, internalName, fallbackProperty) {
    var _this = _super.call(this, targetVersion, name) || this;
    _this.targetVersion = targetVersion;
    _this.name = name;
    _this.internalName = internalName;
    _this.fallbackProperty = fallbackProperty;
    return _this;
  }
  ImageDimensionProperty.prototype.getInternalName = function () {
    return this.internalName;
  };
  ImageDimensionProperty.prototype.parse = function (sender, source, context) {
    var result = undefined;
    var sourceValue = source[this.name];
    if (sourceValue === undefined) {
      return this.defaultValue;
    }
    var isValid = false;
    if (typeof sourceValue === "string") {
      try {
        var size = shared_1.SizeAndUnit.parse(sourceValue, true);
        if (size.unit === Enums.SizeUnit.Pixel) {
          result = size.physicalSize;
          isValid = true;
        }
      } catch (_a) {
        // Swallow the exception
      }
      // If the source value isn't valid per this property definition,
      // check its validity per the fallback property, if specified
      if (!isValid && this.fallbackProperty) {
        isValid = this.fallbackProperty.isValidValue(sourceValue, context);
      }
    }
    if (!isValid) {
      context.logParseEvent(sender, Enums.ValidationEvent.InvalidPropertyValue, strings_1.Strings.errors.invalidPropertyValue(sourceValue, this.name));
    }
    return result;
  };
  ImageDimensionProperty.prototype.toJSON = function (sender, target, value, context) {
    context.serializeValue(target, this.name, typeof value === "number" && !isNaN(value) ? value + "px" : undefined);
  };
  return ImageDimensionProperty;
}(serialization_1.PropertyDefinition);
var Image = /** @class */function (_super) {
  __extends(Image, _super);
  function Image() {
    //#region Schema
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.size = Enums.Size.Auto;
    _this.style = Enums.ImageStyle.Default;
    return _this;
  }
  Image.prototype.populateSchema = function (schema) {
    _super.prototype.populateSchema.call(this, schema);
    schema.remove(CardElement.heightProperty);
  };
  //#endregion
  Image.prototype.applySize = function (element) {
    if (this.pixelWidth || this.pixelHeight) {
      if (this.pixelWidth) {
        element.style.width = this.pixelWidth + "px";
      }
      if (this.pixelHeight) {
        element.style.height = this.pixelHeight + "px";
      }
    } else {
      if (this.maxHeight) {
        // If the image is constrained in height, we set its height property and
        // auto and stretch are ignored (default to medium). THis is necessary for
        // ImageSet which uses a maximum image height as opposed to the cards width
        // as a constraining dimension
        switch (this.size) {
          case Enums.Size.Small:
            element.style.height = this.hostConfig.imageSizes.small + "px";
            break;
          case Enums.Size.Large:
            element.style.height = this.hostConfig.imageSizes.large + "px";
            break;
          default:
            element.style.height = this.hostConfig.imageSizes.medium + "px";
            break;
        }
        element.style.maxHeight = this.maxHeight + "px";
      } else {
        switch (this.size) {
          case Enums.Size.Stretch:
            element.style.width = "100%";
            break;
          case Enums.Size.Auto:
            element.style.maxWidth = "100%";
            break;
          case Enums.Size.Small:
            element.style.width = this.hostConfig.imageSizes.small + "px";
            break;
          case Enums.Size.Large:
            element.style.width = this.hostConfig.imageSizes.large + "px";
            break;
          case Enums.Size.Medium:
            element.style.width = this.hostConfig.imageSizes.medium + "px";
            break;
        }
        element.style.maxHeight = "100%";
      }
    }
  };
  Object.defineProperty(Image.prototype, "useDefaultSizing", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  Image.prototype.internalRender = function () {
    var _this = this;
    var element = undefined;
    if (this.url) {
      element = document.createElement("div");
      element.style.display = "flex";
      element.style.alignItems = "flex-start";
      // Cache hostConfig to avoid walking the parent hierarchy multiple times
      var hostConfig = this.hostConfig;
      switch (this.getEffectiveHorizontalAlignment()) {
        case Enums.HorizontalAlignment.Center:
          element.style.justifyContent = "center";
          break;
        case Enums.HorizontalAlignment.Right:
          element.style.justifyContent = "flex-end";
          break;
        default:
          element.style.justifyContent = "flex-start";
          break;
      }
      var imageElement = document.createElement("img");
      this.renderedImageElement = imageElement;
      imageElement.onload = function (_e) {
        raiseImageLoadedEvent(_this);
      };
      imageElement.onerror = function (_e) {
        if (_this.renderedElement) {
          var card = _this.getRootElement();
          clearElement(_this.renderedElement);
          if (card && card.designMode) {
            var errorElement = document.createElement("div");
            errorElement.style.display = "flex";
            errorElement.style.alignItems = "center";
            errorElement.style.justifyContent = "center";
            errorElement.style.backgroundColor = "#EEEEEE";
            errorElement.style.color = "black";
            errorElement.innerText = ":-(";
            errorElement.style.padding = "10px";
            _this.applySize(errorElement);
            _this.renderedElement.appendChild(errorElement);
          }
        }
        raiseImageLoadedEvent(_this);
      };
      imageElement.style.minWidth = "0";
      imageElement.classList.add(hostConfig.makeCssClassName("ac-image"));
      if (this.selectAction && hostConfig.supportsInteractivity) {
        imageElement.onkeypress = function (e) {
          if (_this.selectAction && _this.selectAction.isEffectivelyEnabled() && (e.code === "Enter" || e.code === "Space")) {
            // enter or space pressed
            e.preventDefault();
            e.cancelBubble = true;
            _this.selectAction.execute();
          }
        };
        imageElement.onclick = function (e) {
          if (_this.selectAction && _this.selectAction.isEffectivelyEnabled()) {
            e.preventDefault();
            e.cancelBubble = true;
            _this.selectAction.execute();
          }
        };
        this.selectAction.setupElementForAccessibility(imageElement);
        if (this.selectAction.isEffectivelyEnabled()) {
          imageElement.classList.add(hostConfig.makeCssClassName("ac-selectable"));
        }
      }
      this.applySize(imageElement);
      if (this.style === Enums.ImageStyle.Person) {
        imageElement.style.borderRadius = "50%";
        imageElement.style.backgroundPosition = "50% 50%";
        imageElement.style.backgroundRepeat = "no-repeat";
      }
      var backgroundColor = Utils.stringToCssColor(this.backgroundColor);
      if (backgroundColor) {
        imageElement.style.backgroundColor = backgroundColor;
      }
      this.setImageSource(imageElement);
      var altTextProperty = this.preProcessPropertyValue(Image.altTextProperty);
      if (altTextProperty) {
        imageElement.alt = altTextProperty;
      }
      element.appendChild(imageElement);
    }
    return element;
  };
  Image.prototype.getJsonTypeName = function () {
    return "Image";
  };
  Image.prototype.getAllActions = function () {
    var result = _super.prototype.getAllActions.call(this);
    if (this.selectAction) {
      result.push(this.selectAction);
    }
    return result;
  };
  Image.prototype.getActionById = function (id) {
    var result = _super.prototype.getActionById.call(this, id);
    if (!result && this.selectAction) {
      result = this.selectAction.getActionById(id);
    }
    return result;
  };
  Image.prototype.getResourceInformation = function () {
    return this.url ? [{
      url: this.url,
      mimeType: "image"
    }] : [];
  };
  Image.prototype.setImageSource = function (imageElement) {
    var imageForceLoader = new ImageForceLoader(this.forceLoad, this.url);
    imageForceLoader.configureImage(this);
    imageElement.src = this.preProcessPropertyValue(Image.urlProperty);
    imageForceLoader.resetImage(this);
  };
  Image.urlProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "url");
  Image.altTextProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "altText");
  Image.backgroundColorProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_1, "backgroundColor");
  Image.styleProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_0, "style", Enums.ImageStyle, Enums.ImageStyle.Default);
  Image.sizeProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_0, "size", Enums.Size, Enums.Size.Auto);
  Image.pixelWidthProperty = new ImageDimensionProperty(serialization_1.Versions.v1_1, "width", "pixelWidth");
  Image.pixelHeightProperty = new ImageDimensionProperty(serialization_1.Versions.v1_1, "height", "pixelHeight", CardElement.heightProperty);
  Image.selectActionProperty = new ActionProperty(serialization_1.Versions.v1_1, "selectAction", ["Action.ShowCard"]);
  Image.shouldForceLoadProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_6, "forceLoad", false);
  __decorate([(0, serialization_1.property)(Image.urlProperty)], Image.prototype, "url", void 0);
  __decorate([(0, serialization_1.property)(Image.altTextProperty)], Image.prototype, "altText", void 0);
  __decorate([(0, serialization_1.property)(Image.backgroundColorProperty)], Image.prototype, "backgroundColor", void 0);
  __decorate([(0, serialization_1.property)(Image.sizeProperty)], Image.prototype, "size", void 0);
  __decorate([(0, serialization_1.property)(Image.styleProperty)], Image.prototype, "style", void 0);
  __decorate([(0, serialization_1.property)(Image.pixelWidthProperty)], Image.prototype, "pixelWidth", void 0);
  __decorate([(0, serialization_1.property)(Image.pixelHeightProperty)], Image.prototype, "pixelHeight", void 0);
  __decorate([(0, serialization_1.property)(Image.selectActionProperty)], Image.prototype, "selectAction", void 0);
  __decorate([(0, serialization_1.property)(Image.shouldForceLoadProperty)], Image.prototype, "forceLoad", void 0);
  return Image;
}(CardElement);
exports.Image = Image;
// configures Image element to fetch a new image data from url source instead of relying on cache
// currently rudimentary refreshing scheme is used
// by attaching unique query string to url, we bypass the cache usage
var ImageForceLoader = /** @class */function () {
  function ImageForceLoader(doForceLoad, url) {
    this.doForceLoad = doForceLoad;
    this.url = url;
    if (url && url.length && doForceLoad) {
      // we can do better by appending unique key such as uuid instead of epoch
      // however the current usage is for front-end ui and networking,  
      // since ui is running in single main thread, this is sufficient mechanism
      // without needing to depend on external library for our small use cases.
      this.uniqueHash = '?' + Date.now();
      this.urlWithForceLoadOption = url + this.uniqueHash;
    }
  }
  ImageForceLoader.prototype.configureImage = function (image) {
    if (this.urlWithForceLoadOption && this.urlWithForceLoadOption.length) {
      image.url = this.urlWithForceLoadOption;
    }
  };
  ImageForceLoader.prototype.resetImage = function (image) {
    image.url = this.url;
  };
  return ImageForceLoader;
}();
var CardElementContainer = /** @class */function (_super) {
  __extends(CardElementContainer, _super);
  function CardElementContainer() {
    //#region Schema
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.allowVerticalOverflow = false;
    return _this;
  }
  CardElementContainer.prototype.populateSchema = function (schema) {
    _super.prototype.populateSchema.call(this, schema);
    if (!this.isSelectable) {
      schema.remove(CardElementContainer.selectActionProperty);
    }
  };
  //#endregion
  CardElementContainer.prototype.isElementAllowed = function (element) {
    return this.hostConfig.supportsInteractivity || !element.isInteractive;
  };
  CardElementContainer.prototype.applyPadding = function () {
    _super.prototype.applyPadding.call(this);
    if (!this.renderedElement) {
      return;
    }
    var physicalPadding = new shared_1.SpacingDefinition();
    if (this.getEffectivePadding()) {
      physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(this.getEffectivePadding());
    }
    this.renderedElement.style.paddingTop = physicalPadding.top + "px";
    this.renderedElement.style.paddingRight = physicalPadding.right + "px";
    this.renderedElement.style.paddingBottom = physicalPadding.bottom + "px";
    this.renderedElement.style.paddingLeft = physicalPadding.left + "px";
    this.renderedElement.style.marginRight = "0";
    this.renderedElement.style.marginLeft = "0";
  };
  Object.defineProperty(CardElementContainer.prototype, "isSelectable", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  CardElementContainer.prototype.forbiddenChildElements = function () {
    return [];
  };
  CardElementContainer.prototype.releaseDOMResources = function () {
    _super.prototype.releaseDOMResources.call(this);
    for (var i = 0; i < this.getItemCount(); i++) {
      this.getItemAt(i).releaseDOMResources();
    }
  };
  CardElementContainer.prototype.internalValidateProperties = function (context) {
    _super.prototype.internalValidateProperties.call(this, context);
    for (var i = 0; i < this.getItemCount(); i++) {
      var item = this.getItemAt(i);
      if (!this.hostConfig.supportsInteractivity && item.isInteractive) {
        context.addFailure(this, Enums.ValidationEvent.InteractivityNotAllowed, strings_1.Strings.errors.interactivityNotAllowed());
      }
      if (!this.isElementAllowed(item)) {
        context.addFailure(this, Enums.ValidationEvent.InteractivityNotAllowed, strings_1.Strings.errors.elementTypeNotAllowed(item.getJsonTypeName()));
      }
      item.internalValidateProperties(context);
    }
    if (this._selectAction) {
      this._selectAction.internalValidateProperties(context);
    }
  };
  CardElementContainer.prototype.render = function () {
    var _this = this;
    var element = _super.prototype.render.call(this);
    if (element) {
      var hostConfig = this.hostConfig;
      if (this.allowVerticalOverflow) {
        element.style.overflowX = "hidden";
        element.style.overflowY = "auto";
      }
      if (element && this.isSelectable && this._selectAction && hostConfig.supportsInteractivity) {
        element.onclick = function (e) {
          if (_this._selectAction && _this._selectAction.isEffectivelyEnabled()) {
            e.preventDefault();
            e.cancelBubble = true;
            _this._selectAction.execute();
          }
        };
        element.onkeypress = function (e) {
          if (_this._selectAction && _this._selectAction.isEffectivelyEnabled() && (e.code === "Enter" || e.code === "Space")) {
            // Enter or space pressed
            e.preventDefault();
            e.cancelBubble = true;
            _this._selectAction.execute();
          }
        };
        this._selectAction.setupElementForAccessibility(element);
        if (this._selectAction.isEffectivelyEnabled()) {
          element.classList.add(hostConfig.makeCssClassName("ac-selectable"));
        }
      }
    }
    return element;
  };
  CardElementContainer.prototype.updateLayout = function (processChildren) {
    if (processChildren === void 0) {
      processChildren = true;
    }
    _super.prototype.updateLayout.call(this, processChildren);
    if (processChildren) {
      for (var i = 0; i < this.getItemCount(); i++) {
        this.getItemAt(i).updateLayout();
      }
    }
  };
  CardElementContainer.prototype.getAllInputs = function (processActions) {
    if (processActions === void 0) {
      processActions = true;
    }
    var result = [];
    for (var i = 0; i < this.getItemCount(); i++) {
      result.push.apply(result, this.getItemAt(i).getAllInputs(processActions));
    }
    return result;
  };
  CardElementContainer.prototype.getAllActions = function () {
    var result = _super.prototype.getAllActions.call(this);
    for (var i = 0; i < this.getItemCount(); i++) {
      result.push.apply(result, this.getItemAt(i).getAllActions());
    }
    if (this._selectAction) {
      result.push(this._selectAction);
    }
    return result;
  };
  CardElementContainer.prototype.getResourceInformation = function () {
    var result = [];
    for (var i = 0; i < this.getItemCount(); i++) {
      result.push.apply(result, this.getItemAt(i).getResourceInformation());
    }
    return result;
  };
  CardElementContainer.prototype.getElementById = function (id) {
    var result = _super.prototype.getElementById.call(this, id);
    if (!result) {
      for (var i = 0; i < this.getItemCount(); i++) {
        result = this.getItemAt(i).getElementById(id);
        if (result) {
          break;
        }
      }
    }
    return result;
  };
  /**
   * @inheritdoc
   */
  CardElementContainer.prototype.findDOMNodeOwner = function (node) {
    var _a;
    var target = undefined;
    for (var i = 0; i < this.getItemCount(); i++) {
      // recur through child elements
      target = this.getItemAt(i).findDOMNodeOwner(node);
      if (target) {
        return target;
      }
    }
    // If not found in children, check the actions
    for (var i = 0; i < this.getActionCount(); i++) {
      target = (_a = this.getActionAt(i)) === null || _a === void 0 ? void 0 : _a.findDOMNodeOwner(node);
      if (target) {
        return target;
      }
    }
    // if not found in children or actions, defer to parent implementation
    return _super.prototype.findDOMNodeOwner.call(this, node);
  };
  CardElementContainer.selectActionProperty = new ActionProperty(serialization_1.Versions.v1_1, "selectAction", ["Action.ShowCard"]);
  __decorate([(0, serialization_1.property)(CardElementContainer.selectActionProperty)], CardElementContainer.prototype, "_selectAction", void 0);
  return CardElementContainer;
}(CardElement);
exports.CardElementContainer = CardElementContainer;
var ImageSet = /** @class */function (_super) {
  __extends(ImageSet, _super);
  function ImageSet() {
    //#region Schema
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._images = [];
    _this.imageSize = Enums.ImageSize.Medium;
    _this.presentationStyle = Enums.ImageSetPresentationStyle.Default;
    _this.pixelOffset = 0;
    return _this;
  }
  //#endregion
  ImageSet.prototype.internalRender = function () {
    var element = undefined;
    if (this._images.length > 0) {
      element = document.createElement("div");
      element.style.display = "flex";
      element.style.flexWrap = "wrap";
      for (var _i = 0, _a = this._images; _i < _a.length; _i++) {
        var image = _a[_i];
        switch (this.imageSize) {
          case Enums.ImageSize.Small:
            image.size = Enums.Size.Small;
            break;
          case Enums.ImageSize.Large:
            image.size = Enums.Size.Large;
            break;
          default:
            image.size = Enums.Size.Medium;
            break;
        }
        image.maxHeight = this.hostConfig.imageSet.maxImageHeight;
        var renderedImage = image.render();
        if (renderedImage) {
          renderedImage.style.display = "inline-flex";
          renderedImage.style.margin = "0px";
          if (this.presentationStyle == Enums.ImageSetPresentationStyle.Default) {
            renderedImage.style.marginRight = "10px";
          }
          Utils.appendChild(element, renderedImage);
        }
      }
      if (this.presentationStyle == Enums.ImageSetPresentationStyle.Stacked) {
        this.applyStackedPresentationStyle();
      }
    }
    return element;
  };
  ImageSet.prototype.applyStackedPresentationStyle = function () {
    if (this._images[0].renderedImageElement) {
      var dimension = StackedImageConfigurator.parseNumericPixelDimension(this._images[0].renderedImageElement.style.height);
      var bgColor = this.getEffectiveBackgroundColor();
      if (dimension) {
        var stackedImageConfigurator = new StackedImageConfigurator(this.pixelOffset, dimension, bgColor);
        stackedImageConfigurator.configureImagesArrayAsStackedLayout(this._images);
      }
    }
  };
  ImageSet.prototype.getEffectiveBackgroundColor = function () {
    var parentContainer = this.getParentContainer();
    var style = parentContainer === null || parentContainer === void 0 ? void 0 : parentContainer.getEffectiveStyle();
    var styleDefinition = this.hostConfig.containerStyles.getStyleByName(style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
    return Utils.stringToCssColor(styleDefinition.backgroundColor);
  };
  ImageSet.prototype.getItemCount = function () {
    return this._images.length;
  };
  ImageSet.prototype.getItemAt = function (index) {
    return this._images[index];
  };
  ImageSet.prototype.getFirstVisibleRenderedItem = function () {
    return this._images && this._images.length > 0 ? this._images[0] : undefined;
  };
  ImageSet.prototype.getLastVisibleRenderedItem = function () {
    return this._images && this._images.length > 0 ? this._images[this._images.length - 1] : undefined;
  };
  ImageSet.prototype.removeItem = function (item) {
    if (item instanceof Image) {
      var itemIndex = this._images.indexOf(item);
      if (itemIndex >= 0) {
        this._images.splice(itemIndex, 1);
        item.setParent(undefined);
        this.updateLayout();
        return true;
      }
    }
    return false;
  };
  ImageSet.prototype.getJsonTypeName = function () {
    return "ImageSet";
  };
  ImageSet.prototype.addImage = function (image) {
    if (!image.parent) {
      this._images.push(image);
      image.setParent(this);
    } else {
      throw new Error("This image already belongs to another ImageSet");
    }
  };
  ImageSet.prototype.indexOf = function (cardElement) {
    return cardElement instanceof Image ? this._images.indexOf(cardElement) : -1;
  };
  ImageSet.imagesProperty = new serialization_1.SerializableObjectCollectionProperty(serialization_1.Versions.v1_0, "images", Image, function (sender, item) {
    item.setParent(sender);
  });
  ImageSet.imageSizeProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_0, "imageSize", Enums.ImageSize, Enums.ImageSize.Medium);
  ImageSet.imagePresentationStyle = new serialization_1.EnumProperty(serialization_1.Versions.v1_6, "style", Enums.ImageSetPresentationStyle, Enums.ImageSetPresentationStyle.Default);
  ImageSet.pixelOffset = new serialization_1.NumProperty(serialization_1.Versions.v1_6, "offset", 0, undefined);
  __decorate([(0, serialization_1.property)(ImageSet.imagesProperty)], ImageSet.prototype, "_images", void 0);
  __decorate([(0, serialization_1.property)(ImageSet.imageSizeProperty)], ImageSet.prototype, "imageSize", void 0);
  __decorate([(0, serialization_1.property)(ImageSet.imagePresentationStyle)], ImageSet.prototype, "presentationStyle", void 0);
  __decorate([(0, serialization_1.property)(ImageSet.pixelOffset)], ImageSet.prototype, "pixelOffset", void 0);
  return ImageSet;
}(CardElementContainer);
exports.ImageSet = ImageSet;
var StackedImageConfigurator = /** @class */function () {
  function StackedImageConfigurator(offset, dimension, style) {
    this.sign45 = 0.7071;
    this.maxImageCounts = 2;
    this.offset = 0;
    this.normalizationConstant = 0;
    this.border = 5;
    this.dimension = 0;
    this.dimension = dimension;
    this.normalizationConstant = (dimension * this.sign45 - 0.5 * dimension) * 2;
    // offset determines how far images are placed from each other
    // at zero, images are separated only by the border
    // there is no restriction on how far they are apart in positive values, their actual
    // positioning is limited by maximum size imposed by Image renderer
    // a negative value can decrease upto the diameter of the image since a value less than the diameter
    // put the images past each other, and the use of such value is not reasonable request
    // users should change image positions in such case.
    this.offset = this.sign45 * (Math.max(offset, -dimension) - this.normalizationConstant);
    this.style = style ? style : "";
  }
  StackedImageConfigurator.prototype.moveImageRight = function (element) {
    element.style.marginLeft = this.offset + "px";
  };
  StackedImageConfigurator.prototype.moveImageUp = function (element) {
    element.style.marginBottom = this.offset + this.dimension + "px";
  };
  StackedImageConfigurator.prototype.moveImageDown = function (element) {
    element.style.marginTop = this.offset + this.dimension + "px";
  };
  StackedImageConfigurator.prototype.makeImageRound = function (element) {
    element.style.borderRadius = "50%";
    element.style.backgroundPosition = "50% 50%";
    element.style.backgroundRepeat = "no-repeat";
  };
  StackedImageConfigurator.prototype.applyBorder = function (element) {
    element.style.height = this.dimension + this.border * 2 + "px";
    element.style.border = this.border + "px" + " solid " + this.style;
  };
  StackedImageConfigurator.prototype.configureImageForBottomLeft = function (element) {
    this.moveImageDown(element);
    this.makeImageRound(element);
    this.applyBorder(element);
    element.style.zIndex = "2";
  };
  StackedImageConfigurator.prototype.configureImageForTopRight = function (element) {
    this.moveImageUp(element);
    this.moveImageRight(element);
    this.makeImageRound(element);
    element.style.zIndex = "1";
  };
  // stacked layout is applied when there are two images in ImageSet,
  // first image in the ImageSet is put bottom left of ImageSet,
  // second image is placed top right diagonally to the first image at 45 angle
  // first image is placed over the second image should the overlap to occur.
  StackedImageConfigurator.prototype.configureImagesArrayAsStackedLayout = function (elements) {
    if (elements.length == 1) {
      if (elements[0].renderedImageElement) {
        this.makeImageRound(elements[0].renderedImageElement);
      }
    } else if (elements.length <= this.maxImageCounts) {
      if (elements[0].renderedImageElement && elements[1].renderedImageElement) {
        this.configureImageForBottomLeft(elements[0].renderedImageElement);
        this.configureImageForTopRight(elements[1].renderedImageElement);
      }
    }
  };
  StackedImageConfigurator.parseNumericPixelDimension = function (dimension) {
    if ((dimension === null || dimension === void 0 ? void 0 : dimension.substring(dimension.length - 2)) == 'px') {
      return parseInt(dimension.substring(0, dimension.length - 2));
    }
    return undefined;
  };
  return StackedImageConfigurator;
}();
var ContentSource = /** @class */function (_super) {
  __extends(ContentSource, _super);
  //#endregion
  function ContentSource(url, mimeType) {
    var _this = _super.call(this) || this;
    _this.url = url;
    _this.mimeType = mimeType;
    return _this;
  }
  ContentSource.prototype.isValid = function () {
    return this.mimeType && this.url ? true : false;
  };
  //#region Schema
  ContentSource.mimeTypeProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_1, "mimeType");
  ContentSource.urlProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_1, "url");
  __decorate([(0, serialization_1.property)(ContentSource.mimeTypeProperty)], ContentSource.prototype, "mimeType", void 0);
  __decorate([(0, serialization_1.property)(ContentSource.urlProperty)], ContentSource.prototype, "url", void 0);
  return ContentSource;
}(serialization_1.SerializableObject);
exports.ContentSource = ContentSource;
var CaptionSource = /** @class */function (_super) {
  __extends(CaptionSource, _super);
  //#endregion
  function CaptionSource(url, mimeType, label) {
    var _this = _super.call(this, url, mimeType) || this;
    _this.label = label;
    return _this;
  }
  CaptionSource.prototype.getSchemaKey = function () {
    return "CaptionSource";
  };
  CaptionSource.prototype.render = function () {
    var result = undefined;
    if (this.isValid()) {
      result = document.createElement("track");
      result.src = this.url;
      result.kind = "captions";
      result.label = this.label;
    }
    return result;
  };
  //#region Schema
  CaptionSource.labelProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_6, "label");
  __decorate([(0, serialization_1.property)(CaptionSource.labelProperty)], CaptionSource.prototype, "label", void 0);
  return CaptionSource;
}(ContentSource);
exports.CaptionSource = CaptionSource;
var MediaSource = /** @class */function (_super) {
  __extends(MediaSource, _super);
  function MediaSource() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MediaSource.prototype.getSchemaKey = function () {
    return "MediaSource";
  };
  MediaSource.prototype.render = function () {
    var result = undefined;
    if (this.isValid()) {
      result = document.createElement("source");
      result.src = this.url;
      result.type = this.mimeType;
    }
    return result;
  };
  return MediaSource;
}(ContentSource);
exports.MediaSource = MediaSource;
var MediaPlayer = /** @class */function () {
  function MediaPlayer() {}
  MediaPlayer.prototype.play = function () {
    // Do nothing in base implementation
  };
  Object.defineProperty(MediaPlayer.prototype, "posterUrl", {
    get: function () {
      return this._posterUrl;
    },
    set: function (value) {
      this._posterUrl = value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MediaPlayer.prototype, "selectedMediaType", {
    get: function () {
      return undefined;
    },
    enumerable: false,
    configurable: true
  });
  return MediaPlayer;
}();
exports.MediaPlayer = MediaPlayer;
var HTML5MediaPlayer = /** @class */function (_super) {
  __extends(HTML5MediaPlayer, _super);
  function HTML5MediaPlayer(owner) {
    var _this = _super.call(this) || this;
    _this.owner = owner;
    _this._selectedSources = [];
    _this._captionSources = [];
    _this.processSources();
    return _this;
  }
  HTML5MediaPlayer.prototype.processSources = function () {
    var _a;
    this._selectedSources = [];
    this._captionSources = [];
    this._selectedMediaType = undefined;
    for (var _i = 0, _b = this.owner.sources; _i < _b.length; _i++) {
      var source = _b[_i];
      var mimeComponents = source.mimeType ? source.mimeType.split("/") : [];
      if (mimeComponents.length === 2) {
        if (!this._selectedMediaType) {
          var index = HTML5MediaPlayer.supportedMediaTypes.indexOf(mimeComponents[0]);
          if (index >= 0) {
            this._selectedMediaType = HTML5MediaPlayer.supportedMediaTypes[index];
          }
        }
        if (mimeComponents[0] === this._selectedMediaType) {
          this._selectedSources.push(source);
        }
      }
    }
    (_a = this._captionSources).push.apply(_a, this.owner.captionSources);
  };
  HTML5MediaPlayer.prototype.canPlay = function () {
    return this._selectedSources.length > 0;
  };
  HTML5MediaPlayer.prototype.fetchVideoDetails = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/];
      });
    });
  };
  HTML5MediaPlayer.prototype.render = function () {
    if (this._selectedMediaType === "video") {
      this._mediaElement = document.createElement("video");
    } else {
      this._mediaElement = document.createElement("audio");
    }
    this._mediaElement.setAttribute("aria-label", this.owner.altText ? this.owner.altText : strings_1.Strings.defaults.mediaPlayerAriaLabel());
    this._mediaElement.setAttribute("webkit-playsinline", "");
    this._mediaElement.setAttribute("playsinline", "");
    // We enable crossorigin for cases where the caption file has a different domain than
    // the video file. If the caption file lives in a different domain than the video file
    // and crossorigin is not set, then the caption file will fail to load.
    this._mediaElement.setAttribute("crossorigin", "");
    this._mediaElement.autoplay = true;
    this._mediaElement.controls = true;
    if (Utils.isMobileOS()) {
      this._mediaElement.muted = true;
    }
    this._mediaElement.preload = "none";
    this._mediaElement.style.width = "100%";
    for (var _i = 0, _a = this.owner.sources; _i < _a.length; _i++) {
      var source = _a[_i];
      var renderedSource = source.render();
      Utils.appendChild(this._mediaElement, renderedSource);
    }
    for (var _b = 0, _c = this.owner.captionSources; _b < _c.length; _b++) {
      var captionSource = _c[_b];
      if (captionSource.mimeType == "vtt") {
        var renderedCaptionSource = captionSource.render();
        Utils.appendChild(this._mediaElement, renderedCaptionSource);
      }
    }
    return this._mediaElement;
  };
  HTML5MediaPlayer.prototype.play = function () {
    if (this._mediaElement) {
      this._mediaElement.play();
    }
  };
  Object.defineProperty(HTML5MediaPlayer.prototype, "selectedMediaType", {
    get: function () {
      return this._selectedMediaType;
    },
    enumerable: false,
    configurable: true
  });
  HTML5MediaPlayer.supportedMediaTypes = ["audio", "video"];
  return HTML5MediaPlayer;
}(MediaPlayer);
exports.HTML5MediaPlayer = HTML5MediaPlayer;
var CustomMediaPlayer = /** @class */function (_super) {
  __extends(CustomMediaPlayer, _super);
  function CustomMediaPlayer(matches) {
    return _super.call(this) || this;
  }
  return CustomMediaPlayer;
}(MediaPlayer);
exports.CustomMediaPlayer = CustomMediaPlayer;
var IFrameMediaMediaPlayer = /** @class */function (_super) {
  __extends(IFrameMediaMediaPlayer, _super);
  function IFrameMediaMediaPlayer(matches, iFrameTitle) {
    var _this = _super.call(this, matches) || this;
    _this.iFrameTitle = iFrameTitle;
    if (matches.length >= 2) {
      _this._videoId = matches[1];
    }
    return _this;
  }
  IFrameMediaMediaPlayer.prototype.canPlay = function () {
    return this._videoId !== undefined;
  };
  IFrameMediaMediaPlayer.prototype.render = function () {
    var container = document.createElement("div");
    container.style.position = "relative";
    container.style.width = "100%";
    container.style.height = "0";
    container.style.paddingBottom = "56.25%";
    var iFrame = document.createElement("iframe");
    iFrame.style.position = "absolute";
    iFrame.style.top = "0";
    iFrame.style.left = "0";
    iFrame.style.width = "100%";
    iFrame.style.height = "100%";
    iFrame.src = this.getEmbedVideoUrl();
    iFrame.frameBorder = "0";
    if (this.iFrameTitle) {
      iFrame.title = this.iFrameTitle;
    }
    iFrame.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    iFrame.allowFullscreen = true;
    container.appendChild(iFrame);
    return container;
  };
  Object.defineProperty(IFrameMediaMediaPlayer.prototype, "videoId", {
    get: function () {
      return this._videoId;
    },
    enumerable: false,
    configurable: true
  });
  return IFrameMediaMediaPlayer;
}(CustomMediaPlayer);
exports.IFrameMediaMediaPlayer = IFrameMediaMediaPlayer;
var VimeoPlayer = /** @class */function (_super) {
  __extends(VimeoPlayer, _super);
  function VimeoPlayer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  VimeoPlayer.prototype.fetchVideoDetails = function () {
    return __awaiter(this, void 0, void 0, function () {
      var oEmbedUrl, response, json;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            oEmbedUrl = "https://vimeo.com/api/oembed.json?url=".concat(this.getEmbedVideoUrl());
            return [4 /*yield*/, fetch(oEmbedUrl)];
          case 1:
            response = _a.sent();
            if (!response.ok) return [3 /*break*/, 3];
            return [4 /*yield*/, response.json()];
          case 2:
            json = _a.sent();
            this.posterUrl = json["thumbnail_url"];
            _a.label = 3;
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
  VimeoPlayer.prototype.getEmbedVideoUrl = function () {
    return "https://player.vimeo.com/video/".concat(this.videoId, "?autoplay=1");
  };
  return VimeoPlayer;
}(IFrameMediaMediaPlayer);
exports.VimeoPlayer = VimeoPlayer;
var DailymotionPlayer = /** @class */function (_super) {
  __extends(DailymotionPlayer, _super);
  function DailymotionPlayer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  DailymotionPlayer.prototype.fetchVideoDetails = function () {
    return __awaiter(this, void 0, void 0, function () {
      var apiUrl, response, json;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            apiUrl = "https://api.dailymotion.com/video/".concat(this.videoId, "?fields=thumbnail_720_url");
            return [4 /*yield*/, fetch(apiUrl)];
          case 1:
            response = _a.sent();
            if (!response.ok) return [3 /*break*/, 3];
            return [4 /*yield*/, response.json()];
          case 2:
            json = _a.sent();
            this.posterUrl = json["thumbnail_720_url"];
            _a.label = 3;
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
  DailymotionPlayer.prototype.getEmbedVideoUrl = function () {
    return "https://www.dailymotion.com/embed/video/".concat(this.videoId, "?autoplay=1");
  };
  return DailymotionPlayer;
}(IFrameMediaMediaPlayer);
exports.DailymotionPlayer = DailymotionPlayer;
var YouTubePlayer = /** @class */function (_super) {
  __extends(YouTubePlayer, _super);
  function YouTubePlayer(matches, iFrameTitle) {
    var _this = _super.call(this, matches, iFrameTitle) || this;
    _this.iFrameTitle = iFrameTitle;
    if (matches.length >= 3 && matches[2] !== undefined) {
      _this._startTimeIndex = parseInt(matches[2]);
    }
    return _this;
  }
  YouTubePlayer.prototype.fetchVideoDetails = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.posterUrl = this.videoId ? "https://img.youtube.com/vi/".concat(this.videoId, "/maxresdefault.jpg") : undefined;
        return [2 /*return*/];
      });
    });
  };
  YouTubePlayer.prototype.getEmbedVideoUrl = function () {
    var url = "https://www.youtube.com/embed/".concat(this.videoId, "?autoplay=1");
    if (this._startTimeIndex !== undefined) {
      url += "&start=".concat(this._startTimeIndex);
    }
    return url;
  };
  return YouTubePlayer;
}(IFrameMediaMediaPlayer);
exports.YouTubePlayer = YouTubePlayer;
var Media = /** @class */function (_super) {
  __extends(Media, _super);
  function Media() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.sources = [];
    _this.captionSources = [];
    return _this;
  }
  Media.prototype.createMediaPlayer = function () {
    for (var _i = 0, _a = Media.customMediaPlayers; _i < _a.length; _i++) {
      var provider = _a[_i];
      for (var _b = 0, _c = this.sources; _b < _c.length; _b++) {
        var source = _c[_b];
        if (source.url) {
          for (var _d = 0, _f = provider.urlPatterns; _d < _f.length; _d++) {
            var pattern = _f[_d];
            var matches = pattern.exec(source.url);
            if (matches !== null) {
              return provider.createMediaPlayer(matches);
            }
          }
        }
      }
    }
    return new HTML5MediaPlayer(this);
  };
  Media.prototype.handlePlayButtonInvoke = function (event) {
    if (this.hostConfig.media.allowInlinePlayback) {
      event.preventDefault();
      event.cancelBubble = true;
      if (this.renderedElement) {
        var mediaPlayerElement = this._mediaPlayer.render();
        clearElement(this.renderedElement);
        this.renderedElement.appendChild(mediaPlayerElement);
        this._mediaPlayer.play();
        mediaPlayerElement.focus();
      }
    } else {
      if (Media.onPlay) {
        event.preventDefault();
        event.cancelBubble = true;
        Media.onPlay(this);
      }
    }
  };
  Media.prototype.displayPoster = function () {
    return __awaiter(this, void 0, void 0, function () {
      var playButtonArrowWidth, playButtonArrowHeight, posterRootElement_1, posterUrl, posterImageElement_1, playButtonOuterElement, playButtonInnerElement, playButtonContainer;
      var _this = this;
      return __generator(this, function (_a) {
        if (this.renderedElement) {
          playButtonArrowWidth = 12;
          playButtonArrowHeight = 15;
          posterRootElement_1 = document.createElement("div");
          posterRootElement_1.className = this.hostConfig.makeCssClassName("ac-media-poster");
          posterRootElement_1.setAttribute("role", "contentinfo");
          posterRootElement_1.setAttribute("aria-label", this.altText ? this.altText : strings_1.Strings.defaults.mediaPlayerAriaLabel());
          posterRootElement_1.style.position = "relative";
          posterRootElement_1.style.display = "flex";
          posterUrl = this.poster ? this.poster : this._mediaPlayer.posterUrl;
          if (!posterUrl) {
            posterUrl = this.hostConfig.media.defaultPoster;
          }
          if (posterUrl) {
            posterImageElement_1 = document.createElement("img");
            posterImageElement_1.style.width = "100%";
            posterImageElement_1.style.height = "100%";
            posterImageElement_1.setAttribute("role", "presentation");
            posterImageElement_1.onerror = function (_e) {
              if (posterImageElement_1.parentNode) {
                posterImageElement_1.parentNode.removeChild(posterImageElement_1);
              }
              posterRootElement_1.classList.add("empty");
              posterRootElement_1.style.minHeight = "150px";
            };
            posterImageElement_1.src = posterUrl;
            posterRootElement_1.appendChild(posterImageElement_1);
          } else {
            posterRootElement_1.classList.add("empty");
            posterRootElement_1.style.minHeight = "150px";
          }
          if (this.hostConfig.supportsInteractivity && this._mediaPlayer.canPlay()) {
            playButtonOuterElement = document.createElement("div");
            playButtonOuterElement.tabIndex = 0;
            playButtonOuterElement.setAttribute("role", "button");
            playButtonOuterElement.setAttribute("aria-label", strings_1.Strings.defaults.mediaPlayerPlayMedia());
            playButtonOuterElement.className = this.hostConfig.makeCssClassName("ac-media-playButton");
            playButtonOuterElement.style.display = "flex";
            playButtonOuterElement.style.alignItems = "center";
            playButtonOuterElement.style.justifyContent = "center";
            playButtonOuterElement.onclick = function (e) {
              _this.handlePlayButtonInvoke(e);
            };
            playButtonOuterElement.onkeypress = function (e) {
              if (e.code === "Enter" || e.code === "Space") {
                // space or enter
                _this.handlePlayButtonInvoke(e);
              }
            };
            playButtonInnerElement = document.createElement("div");
            playButtonInnerElement.className = this.hostConfig.makeCssClassName("ac-media-playButton-arrow");
            playButtonInnerElement.style.width = playButtonArrowWidth + "px";
            playButtonInnerElement.style.height = playButtonArrowHeight + "px";
            playButtonInnerElement.style.borderTopWidth = playButtonArrowHeight / 2 + "px";
            playButtonInnerElement.style.borderBottomWidth = playButtonArrowHeight / 2 + "px";
            playButtonInnerElement.style.borderLeftWidth = playButtonArrowWidth + "px";
            playButtonInnerElement.style.borderRightWidth = "0";
            playButtonInnerElement.style.borderStyle = "solid";
            playButtonInnerElement.style.borderTopColor = "transparent";
            playButtonInnerElement.style.borderRightColor = "transparent";
            playButtonInnerElement.style.borderBottomColor = "transparent";
            playButtonInnerElement.style.transform = "translate(" + playButtonArrowWidth / 10 + "px,0px)";
            playButtonOuterElement.appendChild(playButtonInnerElement);
            playButtonContainer = document.createElement("div");
            playButtonContainer.style.position = "absolute";
            playButtonContainer.style.left = "0";
            playButtonContainer.style.top = "0";
            playButtonContainer.style.width = "100%";
            playButtonContainer.style.height = "100%";
            playButtonContainer.style.display = "flex";
            playButtonContainer.style.justifyContent = "center";
            playButtonContainer.style.alignItems = "center";
            playButtonContainer.appendChild(playButtonOuterElement);
            posterRootElement_1.appendChild(playButtonContainer);
          }
          clearElement(this.renderedElement);
          this.renderedElement.appendChild(posterRootElement_1);
        }
        return [2 /*return*/];
      });
    });
  };
  Media.prototype.internalRender = function () {
    var element = document.createElement("div");
    element.className = this.hostConfig.makeCssClassName("ac-media");
    return element;
  };
  Media.prototype.render = function () {
    var _this = this;
    var result = _super.prototype.render.call(this);
    if (result) {
      this._mediaPlayer = this.createMediaPlayer();
      this._mediaPlayer.fetchVideoDetails().then(function () {
        return _this.displayPoster();
      });
    }
    return result;
  };
  Media.prototype.releaseDOMResources = function () {
    _super.prototype.releaseDOMResources.call(this);
    this.displayPoster();
  };
  Media.prototype.getJsonTypeName = function () {
    return "Media";
  };
  Media.prototype.getResourceInformation = function () {
    var result = [];
    if (this._mediaPlayer) {
      var posterUrl = this.poster ? this.poster : this.hostConfig.media.defaultPoster;
      if (posterUrl) {
        result.push({
          url: posterUrl,
          mimeType: "image"
        });
      }
    }
    for (var _i = 0, _a = this.sources; _i < _a.length; _i++) {
      var mediaSource = _a[_i];
      if (mediaSource.isValid()) {
        result.push({
          /* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- `mediaSource.url` is of type `string | undefined`, but is validated by `isValid()` call */
          url: mediaSource.url,
          mimeType: mediaSource.mimeType
          /* eslint-enable @typescript-eslint/no-unnecessary-type-assertion */
        });
      }
    }
    for (var _b = 0, _c = this.captionSources; _b < _c.length; _b++) {
      var captionSource = _c[_b];
      if (captionSource.isValid()) {
        result.push({
          /* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- `captionSource.url` is of type `string | undefined`, but is validated by `isValid()` call */
          url: captionSource.url,
          mimeType: captionSource.mimeType
          /* eslint-enable @typescript-eslint/no-unnecessary-type-assertion */
        });
      }
    }
    return result;
  };
  Object.defineProperty(Media.prototype, "selectedMediaType", {
    get: function () {
      return this._mediaPlayer.selectedMediaType;
    },
    enumerable: false,
    configurable: true
  });
  Media.customMediaPlayers = [{
    urlPatterns: [/^(?:https?:\/\/)?(?:www.)?youtube.com\/watch\?(?=.*v=([\w\d-_]+))(?=(?:.*t=(\d+))?).*/gi, /^(?:https?:\/\/)?youtu.be\/([\w\d-_]+)(?:\?t=(\d+))?/gi],
    createMediaPlayer: function (matches) {
      return new YouTubePlayer(matches, strings_1.Strings.defaults.youTubeVideoPlayer());
    }
  }, {
    urlPatterns: [/^(?:https?:\/\/)?vimeo.com\/([\w\d-_]+).*/gi],
    createMediaPlayer: function (matches) {
      return new VimeoPlayer(matches, strings_1.Strings.defaults.vimeoVideoPlayer());
    }
  }, {
    urlPatterns: [/^(?:https?:\/\/)?(?:www.)?dailymotion.com\/video\/([\w\d-_]+).*/gi],
    createMediaPlayer: function (matches) {
      return new DailymotionPlayer(matches, strings_1.Strings.defaults.dailymotionVideoPlayer());
    }
  }];
  //#region Schema
  Media.sourcesProperty = new serialization_1.SerializableObjectCollectionProperty(serialization_1.Versions.v1_1, "sources", MediaSource);
  Media.captionSourcesProperty = new serialization_1.SerializableObjectCollectionProperty(serialization_1.Versions.v1_6, "captionSources", CaptionSource);
  Media.posterProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_1, "poster");
  Media.altTextProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_1, "altText");
  __decorate([(0, serialization_1.property)(Media.sourcesProperty)], Media.prototype, "sources", void 0);
  __decorate([(0, serialization_1.property)(Media.captionSourcesProperty)], Media.prototype, "captionSources", void 0);
  __decorate([(0, serialization_1.property)(Media.posterProperty)], Media.prototype, "poster", void 0);
  __decorate([(0, serialization_1.property)(Media.altTextProperty)], Media.prototype, "altText", void 0);
  return Media;
}(CardElement);
exports.Media = Media;
var InputEventType;
(function (InputEventType) {
  InputEventType[InputEventType["InitialRender"] = 0] = "InitialRender";
  InputEventType[InputEventType["MouseEnterOnCard"] = 1] = "MouseEnterOnCard";
  InputEventType[InputEventType["MouseLeaveOnCard"] = 2] = "MouseLeaveOnCard";
  InputEventType[InputEventType["FocusLeave"] = 3] = "FocusLeave";
})(InputEventType || (InputEventType = {}));
var Input = /** @class */function (_super) {
  __extends(Input, _super);
  function Input() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.inputStyle = Enums.InputStyle.Default;
    return _this;
  }
  Input.prototype.getAllLabelIds = function () {
    var labelIds = [];
    if (this.labelledBy) {
      labelIds.push(this.labelledBy);
    }
    if (this._renderedLabelElement) {
      labelIds.push(this._renderedLabelElement.id);
    }
    if (this._renderedErrorMessageElement) {
      labelIds.push(this._renderedErrorMessageElement.id);
    }
    return labelIds;
  };
  Input.prototype.updateInputControlAriaLabelledBy = function () {
    if (this._renderedInputControlElement) {
      var labelIds = this.getAllLabelIds();
      if (labelIds.length > 0) {
        this._renderedInputControlElement.setAttribute("aria-labelledby", labelIds.join(" "));
      } else {
        this._renderedInputControlElement.removeAttribute("aria-labelledby");
      }
    }
  };
  Object.defineProperty(Input.prototype, "isNullable", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Input.prototype, "renderedInputControlElement", {
    get: function () {
      return this._renderedInputControlElement;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Input.prototype, "inputControlContainerElement", {
    get: function () {
      return this._inputControlContainerElement;
    },
    enumerable: false,
    configurable: true
  });
  Input.prototype.overrideInternalRender = function () {
    var _this = this;
    var hostConfig = this.hostConfig;
    this._outerContainerElement = document.createElement("div");
    this._outerContainerElement.style.display = "flex";
    if (this.labelPosition === Enums.InputLabelPosition.Inline) {
      this._outerContainerElement.style.flexDirection = "row";
    } else {
      this._outerContainerElement.style.flexDirection = "column";
    }
    var renderedInputControlId = Utils.generateUniqueId();
    if (this.label) {
      var labelRichTextBlock = new RichTextBlock();
      labelRichTextBlock.setParent(this);
      labelRichTextBlock.forElementId = renderedInputControlId;
      var labelInline = new TextRun(this.label);
      labelRichTextBlock.addInline(labelInline);
      if (this.isRequired) {
        labelInline.init(hostConfig.inputs.label.requiredInputs);
        var isRequiredCueInline = new TextRun(hostConfig.inputs.label.requiredInputs.suffix);
        isRequiredCueInline.color = hostConfig.inputs.label.requiredInputs.suffixColor;
        isRequiredCueInline.ariaHidden = true;
        labelRichTextBlock.addInline(isRequiredCueInline);
      } else {
        labelInline.init(hostConfig.inputs.label.optionalInputs);
      }
      this._renderedLabelElement = labelRichTextBlock.render();
      if (this._renderedLabelElement) {
        this._renderedLabelElement.id = Utils.generateUniqueId();
        if (this.labelPosition === Enums.InputLabelPosition.Inline) {
          // For inline label position: label should be in center of the div and no extra spacing needed
          this._renderedLabelElement.style.alignSelf = "center";
        } else {
          this._renderedLabelElement.style.marginBottom = hostConfig.getEffectiveSpacing(hostConfig.inputs.label.inputSpacing) + "px";
        }
        this._outerContainerElement.appendChild(this._renderedLabelElement);
      }
    }
    this._inputControlContainerElement = document.createElement("div");
    this._inputControlContainerElement.className = hostConfig.makeCssClassName("ac-input-container");
    this._inputControlContainerElement.style.display = "flex";
    if (this.height === "stretch") {
      this._inputControlContainerElement.style.alignItems = "stretch";
      this._inputControlContainerElement.style.flex = "1 1 auto";
    }
    this._renderedInputControlElement = this.internalRender();
    if (this._renderedInputControlElement) {
      this._renderedInputControlElement.id = renderedInputControlId;
      this._renderedInputControlElement.style.minWidth = "0px";
      if (this.isNullable && this.isRequired) {
        this._renderedInputControlElement.setAttribute("aria-required", "true");
        this._renderedInputControlElement.classList.add(hostConfig.makeCssClassName("ac-input-required"));
      }
      this._inputControlContainerElement.appendChild(this._renderedInputControlElement);
      this._outerContainerElement.appendChild(this._inputControlContainerElement);
      if (this._renderedLabelElement && this.labelPosition === Enums.InputLabelPosition.Inline) {
        if (!this.labelWidth) {
          var defaultLabelWidth = hostConfig.inputs.label.width;
          this._renderedLabelElement.style.width = defaultLabelWidth.toString() + "%";
          this._inputControlContainerElement.style.width = 100 - defaultLabelWidth + "%";
        } else if (this.labelWidth.unit == Enums.SizeUnit.Weight) {
          var labelWidthInPercent = this.labelWidth.physicalSize;
          this._renderedLabelElement.style.width = labelWidthInPercent.toString() + "%";
          this._inputControlContainerElement.style.width = (100 - labelWidthInPercent).toString() + "%";
        } else if (this.labelWidth.unit == Enums.SizeUnit.Pixel) {
          var labelWidthInPixel = this.labelWidth.physicalSize;
          this._renderedLabelElement.style.width = labelWidthInPixel.toString() + "px";
        }
      }
      this.updateVisualState(InputEventType.InitialRender);
      if (this._renderedInputControlElement) {
        this._renderedInputControlElement.onblur = function (ev) {
          _this.updateVisualState(InputEventType.FocusLeave);
        };
      }
      this.updateInputControlAriaLabelledBy();
      return this._outerContainerElement;
    }
    this.resetDirtyState();
    return undefined;
  };
  Input.prototype.valueChanged = function () {
    this.getRootElement().updateActionsEnabledState();
    if (this.isValid()) {
      this.resetValidationFailureCue();
    }
    if (this.onValueChanged) {
      this.onValueChanged(this);
    }
    raiseInputValueChangedEvent(this);
  };
  Input.prototype.resetValidationFailureCue = function () {
    if (this.renderedInputControlElement) {
      if (this instanceof ChoiceSetInput && this.isDynamicTypeahead()) {
        this.removeValidationFailureCue();
      } else {
        this.renderedInputControlElement.classList.remove(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
      }
      this.updateInputControlAriaLabelledBy();
      if (this._renderedErrorMessageElement) {
        this._outerContainerElement.removeChild(this._renderedErrorMessageElement);
        this._renderedErrorMessageElement = undefined;
      }
    }
  };
  Input.prototype.showValidationErrorMessage = function () {
    if (this.renderedElement && this.errorMessage && shared_1.GlobalSettings.displayInputValidationErrors) {
      var errorMessageTextBlock = new TextBlock();
      errorMessageTextBlock.setParent(this);
      errorMessageTextBlock.text = this.errorMessage;
      errorMessageTextBlock.wrap = true;
      errorMessageTextBlock.init(this.hostConfig.inputs.errorMessage);
      this._renderedErrorMessageElement = errorMessageTextBlock.render();
      if (this._renderedErrorMessageElement) {
        this._renderedErrorMessageElement.id = Utils.generateUniqueId();
        this._outerContainerElement.appendChild(this._renderedErrorMessageElement);
        this.updateInputControlAriaLabelledBy();
      }
    }
  };
  Object.defineProperty(Input.prototype, "allowRevealOnHoverStyle", {
    get: function () {
      return this.hostConfig.inputs && this.hostConfig.inputs.allowRevealOnHoverStyle;
    },
    enumerable: false,
    configurable: true
  });
  Input.prototype.shouldHideInputAdornersForRevealOnHover = function (input, eventType) {
    // show/hide input adorners (date picker, time picker, select dropdown picker) with inputStyle RevealOnHover
    // 1. intial render of card: hide input adorners
    // 2. mouse hover on the card: show input adorners
    // 3. mouse hover outside the card: hide input adorners unless input is still in focus state
    // 4. input loses focus: hide the input adorners unless mouse is still hovering on the card
    // check if input still has the focus
    var isInputInFocus = input === document.activeElement;
    // check if mouse is still on the card
    var inputHoverClassName = this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover");
    var isMouseOverCard = input.classList.contains(inputHoverClassName);
    var hideInputAdorners = eventType === InputEventType.InitialRender || eventType === InputEventType.FocusLeave && !isMouseOverCard || eventType === InputEventType.MouseLeaveOnCard && !isInputInFocus;
    return hideInputAdorners;
  };
  Input.prototype.updateVisualState = function (eventType) {
    if (!this.allowRevealOnHoverStyle || !this._renderedInputControlElement || this.inputStyle !== Enums.InputStyle.RevealOnHover) {
      return;
    }
    if (eventType === InputEventType.InitialRender) {
      // on initial render, we will show input fields as read only view
      this._renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onrender"));
    } else if (eventType === InputEventType.MouseEnterOnCard) {
      // on hover on the card, we will reveal the inputs by showing borders etc
      // ac-inputStyle-revealOnHover-onhover class is also used to identify if mouse is hovering on the card
      this._renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover"));
    } else if (eventType === InputEventType.MouseLeaveOnCard) {
      this._renderedInputControlElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onhover"));
    }
  };
  Input.prototype.focus = function () {
    if (this._renderedInputControlElement) {
      this._renderedInputControlElement.focus();
    }
  };
  Input.prototype.isValid = function () {
    return true;
  };
  Input.prototype.isDirty = function () {
    return this.value !== this._oldValue;
  };
  Input.prototype.resetDirtyState = function () {
    this._oldValue = this.value;
  };
  Input.prototype.internalValidateProperties = function (context) {
    _super.prototype.internalValidateProperties.call(this, context);
    if (!this.id) {
      context.addFailure(this, Enums.ValidationEvent.PropertyCantBeNull, strings_1.Strings.errors.inputsMustHaveUniqueId());
    }
    if (this.isRequired) {
      if (!this.label) {
        context.addFailure(this, Enums.ValidationEvent.RequiredInputsShouldHaveLabel, "Required inputs should have a label");
      }
      if (!this.errorMessage) {
        context.addFailure(this, Enums.ValidationEvent.RequiredInputsShouldHaveErrorMessage, "Required inputs should have an error message");
      }
    }
  };
  Input.prototype.validateValue = function () {
    this.resetValidationFailureCue();
    var result = this.isRequired ? this.isSet() && this.isValid() : this.isValid();
    if (!result && this.renderedInputControlElement) {
      if (this instanceof ChoiceSetInput && this.isDynamicTypeahead()) {
        this.showValidationFailureCue();
      } else {
        this.renderedInputControlElement.classList.add(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
      }
      this.showValidationErrorMessage();
    }
    return result;
  };
  Input.prototype.getAllInputs = function (processActions) {
    if (processActions === void 0) {
      processActions = true;
    }
    return [this];
  };
  Input.prototype.render = function () {
    var result = _super.prototype.render.call(this);
    this.resetDirtyState();
    return result;
  };
  Object.defineProperty(Input.prototype, "isInteractive", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  //#region Schema
  Input.labelProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_3, "label", true);
  Input.isRequiredProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_3, "isRequired", false);
  Input.errorMessageProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_3, "errorMessage", true);
  Input.inputStyleProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_6, "inputStyle", Enums.InputStyle, Enums.InputStyle.Default, [{
    value: Enums.InputStyle.RevealOnHover
  }, {
    value: Enums.InputStyle.Default
  }]);
  Input.labelWidthProperty = new serialization_1.CustomProperty(serialization_1.Versions.v1_6, "labelWidth", function (sender, prop, source, context) {
    var result = prop.defaultValue;
    var value = source[prop.name];
    var invalidLabelWidth = false;
    if (typeof value === "number" && !isNaN(value)) {
      result = new shared_1.SizeAndUnit(value, Enums.SizeUnit.Weight);
      if (result.physicalSize < 0 || result.physicalSize > 100) {
        invalidLabelWidth = true;
      }
    } else if (typeof value === "string") {
      try {
        result = shared_1.SizeAndUnit.parse(value);
      } catch (e) {
        invalidLabelWidth = true;
      }
    } else {
      invalidLabelWidth = true;
    }
    if (invalidLabelWidth) {
      context.logParseEvent(sender, Enums.ValidationEvent.InvalidPropertyValue, strings_1.Strings.errors.invalidInputLabelWidth());
      result = undefined;
    }
    return result;
  }, function (sender, property, target, value, context) {
    if (value instanceof shared_1.SizeAndUnit) {
      if (value.unit === Enums.SizeUnit.Pixel) {
        context.serializeValue(target, "labelWidth", value.physicalSize + "px");
      } else {
        context.serializeNumber(target, "labelWidth", value.physicalSize);
      }
    }
  }, undefined);
  Input.labelPositionProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_6, "labelPosition", Enums.InputLabelPosition, Enums.InputLabelPosition.Above, [{
    value: Enums.InputLabelPosition.Inline
  }, {
    value: Enums.InputLabelPosition.Above
  }]);
  __decorate([(0, serialization_1.property)(Input.labelProperty)], Input.prototype, "label", void 0);
  __decorate([(0, serialization_1.property)(Input.isRequiredProperty)], Input.prototype, "isRequired", void 0);
  __decorate([(0, serialization_1.property)(Input.errorMessageProperty)], Input.prototype, "errorMessage", void 0);
  __decorate([(0, serialization_1.property)(Input.inputStyleProperty)], Input.prototype, "inputStyle", void 0);
  __decorate([(0, serialization_1.property)(Input.labelWidthProperty)], Input.prototype, "labelWidth", void 0);
  __decorate([(0, serialization_1.property)(Input.labelPositionProperty)], Input.prototype, "labelPosition", void 0);
  return Input;
}(CardElement);
exports.Input = Input;
var TextInput = /** @class */function (_super) {
  __extends(TextInput, _super);
  function TextInput() {
    //#region Schema
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.isMultiline = false;
    _this.style = Enums.InputTextStyle.Text;
    return _this;
  }
  //#endregion
  TextInput.prototype.setupInput = function (input) {
    var _this = this;
    input.style.flex = "1 1 auto";
    input.tabIndex = this.isDesignMode() ? -1 : 0;
    if (this.placeholder) {
      input.placeholder = this.placeholder;
      input.setAttribute("aria-label", this.placeholder);
    }
    if (this.defaultValue) {
      input.value = this.defaultValue;
    }
    if (this.maxLength && this.maxLength > 0) {
      input.maxLength = this.maxLength;
    }
    input.oninput = function () {
      _this.valueChanged();
    };
    input.onkeypress = function (e) {
      // Ctrl+Enter pressed
      if (e.ctrlKey && e.code === "Enter" && _this.inlineAction && _this.inlineAction.isEffectivelyEnabled()) {
        _this.inlineAction.execute();
      }
    };
  };
  TextInput.prototype.internalRender = function () {
    var result;
    if (this.isMultiline && this.style !== Enums.InputTextStyle.Password) {
      result = document.createElement("textarea");
      result.className = this.hostConfig.makeCssClassName("ac-input", "ac-textInput", "ac-multiline");
      if (this.height === "stretch") {
        result.style.height = "initial";
      }
    } else {
      result = document.createElement("input");
      result.className = this.hostConfig.makeCssClassName("ac-input", "ac-textInput");
      result.type = Enums.InputTextStyle[this.style].toLowerCase();
    }
    this.setupInput(result);
    return result;
  };
  TextInput.prototype.overrideInternalRender = function () {
    var _this = this;
    var renderedInputControl = _super.prototype.overrideInternalRender.call(this);
    if (this.inlineAction) {
      var button_1 = document.createElement("button");
      button_1.className = this.hostConfig.makeCssClassName(this.inlineAction.isEffectivelyEnabled() ? "ac-inlineActionButton" : "ac-inlineActionButton-disabled");
      button_1.onclick = function (e) {
        if (_this.inlineAction && _this.inlineAction.isEffectivelyEnabled()) {
          e.preventDefault();
          e.cancelBubble = true;
          _this.inlineAction.execute();
        }
      };
      if (this.inlineAction.iconUrl) {
        button_1.classList.add("iconOnly");
        var icon_1 = document.createElement("img");
        icon_1.style.height = "100%";
        icon_1.setAttribute("role", "presentation");
        // The below trick is necessary as a workaround in Chrome where the icon is initially displayed
        // at its native size then resized to 100% of the button's height. This cfreates an unpleasant
        // flicker. On top of that, Chrome's flex implementation fails to prperly re-layout the button
        // after the image has loaded and been gicven its final size. The below trick also fixes that.
        icon_1.style.display = "none";
        icon_1.onload = function () {
          icon_1.style.removeProperty("display");
        };
        icon_1.onerror = function () {
          button_1.removeChild(icon_1);
          button_1.classList.remove("iconOnly");
          button_1.classList.add("textOnly");
          button_1.textContent = _this.inlineAction && _this.inlineAction.title ? _this.inlineAction.title : strings_1.Strings.defaults.inlineActionTitle();
        };
        icon_1.src = this.inlineAction.iconUrl;
        button_1.appendChild(icon_1);
        button_1.title = this.inlineAction.title ? this.inlineAction.title : strings_1.Strings.defaults.inlineActionTitle();
      } else {
        button_1.classList.add("textOnly");
        button_1.textContent = this.inlineAction.title ? this.inlineAction.title : strings_1.Strings.defaults.inlineActionTitle();
      }
      this.inlineAction.setupElementForAccessibility(button_1, true);
      button_1.style.marginLeft = "8px";
      this.inputControlContainerElement.appendChild(button_1);
    }
    return renderedInputControl;
  };
  TextInput.prototype.updateVisualState = function (eventType) {
    if (!this.allowRevealOnHoverStyle) {
      return;
    }
    if (!(this.inlineAction || this.isMultiline)) {
      _super.prototype.updateVisualState.call(this, eventType);
    }
  };
  TextInput.prototype.getJsonTypeName = function () {
    return "Input.Text";
  };
  TextInput.prototype.getAllActions = function () {
    var result = _super.prototype.getAllActions.call(this);
    if (this.inlineAction) {
      result.push(this.inlineAction);
    }
    return result;
  };
  TextInput.prototype.getActionById = function (id) {
    var result = _super.prototype.getActionById.call(this, id);
    if (!result && this.inlineAction) {
      result = this.inlineAction.getActionById(id);
    }
    return result;
  };
  TextInput.prototype.isSet = function () {
    return this.value ? true : false;
  };
  TextInput.prototype.isValid = function () {
    if (!this.value) {
      return true;
    }
    if (this.regex) {
      return new RegExp(this.regex, "g").test(this.value);
    }
    return true;
  };
  Object.defineProperty(TextInput.prototype, "value", {
    get: function () {
      if (this.renderedInputControlElement) {
        if (this.isMultiline) {
          return this.renderedInputControlElement.value;
        } else {
          return this.renderedInputControlElement.value;
        }
      } else {
        return undefined;
      }
    },
    enumerable: false,
    configurable: true
  });
  TextInput.valueProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "value");
  TextInput.maxLengthProperty = new serialization_1.NumProperty(serialization_1.Versions.v1_0, "maxLength");
  TextInput.isMultilineProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_0, "isMultiline", false);
  TextInput.placeholderProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "placeholder");
  TextInput.styleProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_0, "style", Enums.InputTextStyle, Enums.InputTextStyle.Text, [{
    value: Enums.InputTextStyle.Text
  }, {
    value: Enums.InputTextStyle.Tel
  }, {
    value: Enums.InputTextStyle.Url
  }, {
    value: Enums.InputTextStyle.Email
  }, {
    value: Enums.InputTextStyle.Password,
    targetVersion: serialization_1.Versions.v1_5
  }]);
  TextInput.inlineActionProperty = new ActionProperty(serialization_1.Versions.v1_0, "inlineAction", ["Action.ShowCard"]);
  TextInput.regexProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_3, "regex", true);
  __decorate([(0, serialization_1.property)(TextInput.valueProperty)], TextInput.prototype, "defaultValue", void 0);
  __decorate([(0, serialization_1.property)(TextInput.maxLengthProperty)], TextInput.prototype, "maxLength", void 0);
  __decorate([(0, serialization_1.property)(TextInput.isMultilineProperty)], TextInput.prototype, "isMultiline", void 0);
  __decorate([(0, serialization_1.property)(TextInput.placeholderProperty)], TextInput.prototype, "placeholder", void 0);
  __decorate([(0, serialization_1.property)(TextInput.styleProperty)], TextInput.prototype, "style", void 0);
  __decorate([(0, serialization_1.property)(TextInput.inlineActionProperty)], TextInput.prototype, "inlineAction", void 0);
  __decorate([(0, serialization_1.property)(TextInput.regexProperty)], TextInput.prototype, "regex", void 0);
  return TextInput;
}(Input);
exports.TextInput = TextInput;
var ToggleInput = /** @class */function (_super) {
  __extends(ToggleInput, _super);
  function ToggleInput() {
    //#region Schema
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.valueOn = "true";
    _this.valueOff = "false";
    _this.wrap = false;
    return _this;
  }
  ToggleInput.prototype.updateInputControlAriaLabelledBy = function () {
    if (this._checkboxInputElement) {
      var joinedLabelIds = this.getAllLabelIds().join(" ");
      if (this._checkboxInputLabelElement && this._checkboxInputLabelElement.id) {
        joinedLabelIds += " " + this._checkboxInputLabelElement.id;
      }
      if (joinedLabelIds) {
        this._checkboxInputElement.setAttribute("aria-labelledby", joinedLabelIds);
      } else {
        this._checkboxInputElement.removeAttribute("aria-labelledby");
      }
    }
  };
  ToggleInput.prototype.internalRender = function () {
    var _this = this;
    var element = document.createElement("div");
    element.className = this.hostConfig.makeCssClassName("ac-input", "ac-toggleInput");
    element.style.width = "100%";
    element.style.display = "flex";
    element.style.alignItems = "center";
    this._checkboxInputElement = document.createElement("input");
    this._checkboxInputElement.id = Utils.generateUniqueId();
    this._checkboxInputElement.type = "checkbox";
    this._checkboxInputElement.style.display = "inline-block";
    this._checkboxInputElement.style.verticalAlign = "middle";
    this._checkboxInputElement.style.margin = "0";
    this._checkboxInputElement.style.flex = "0 0 auto";
    if (this.title) {
      this._checkboxInputElement.setAttribute("aria-label", this.title);
    }
    if (this.isRequired) {
      this._checkboxInputElement.setAttribute("aria-required", "true");
    }
    this._checkboxInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
    if (this.defaultValue === this.valueOn) {
      this._checkboxInputElement.checked = true;
    }
    this._oldCheckboxValue = this._checkboxInputElement.checked;
    this._checkboxInputElement.onchange = function () {
      _this.valueChanged();
    };
    Utils.appendChild(element, this._checkboxInputElement);
    if (this.title || this.isDesignMode()) {
      var label = new TextBlock();
      label.setParent(this);
      label.forElementId = this._checkboxInputElement.id;
      label.hostConfig = this.hostConfig;
      label.text = !this.title ? this.getJsonTypeName() : this.title;
      label.useMarkdown = shared_1.GlobalSettings.useMarkdownInRadioButtonAndCheckbox;
      label.wrap = this.wrap;
      this._checkboxInputLabelElement = label.render();
      if (this._checkboxInputLabelElement) {
        this._checkboxInputLabelElement.id = Utils.generateUniqueId();
        this._checkboxInputLabelElement.style.display = "inline-block";
        this._checkboxInputLabelElement.style.flex = "1 1 auto";
        this._checkboxInputLabelElement.style.marginLeft = "6px";
        this._checkboxInputLabelElement.style.verticalAlign = "middle";
        var spacerElement = document.createElement("div");
        spacerElement.style.width = "6px";
        Utils.appendChild(element, spacerElement);
        Utils.appendChild(element, this._checkboxInputLabelElement);
      }
    }
    return element;
  };
  Object.defineProperty(ToggleInput.prototype, "isNullable", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  ToggleInput.prototype.updateVisualState = function (eventType) {};
  ToggleInput.prototype.getJsonTypeName = function () {
    return "Input.Toggle";
  };
  ToggleInput.prototype.focus = function () {
    if (this._checkboxInputElement) {
      this._checkboxInputElement.focus();
    }
  };
  ToggleInput.prototype.isSet = function () {
    if (this.isRequired) {
      return this.value === this.valueOn;
    }
    return this.value ? true : false;
  };
  ToggleInput.prototype.isDirty = function () {
    return this._checkboxInputElement ? this._checkboxInputElement.checked !== this._oldCheckboxValue : false;
  };
  Object.defineProperty(ToggleInput.prototype, "value", {
    get: function () {
      if (this._checkboxInputElement) {
        return this._checkboxInputElement.checked ? this.valueOn : this.valueOff;
      } else {
        return undefined;
      }
    },
    enumerable: false,
    configurable: true
  });
  ToggleInput.valueProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "value");
  ToggleInput.titleProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "title");
  ToggleInput.valueOnProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "valueOn", true, undefined, "true", function (sender) {
    return "true";
  });
  ToggleInput.valueOffProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "valueOff", true, undefined, "false", function (sender) {
    return "false";
  });
  ToggleInput.wrapProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_2, "wrap", false);
  __decorate([(0, serialization_1.property)(ToggleInput.valueProperty)], ToggleInput.prototype, "defaultValue", void 0);
  __decorate([(0, serialization_1.property)(ToggleInput.titleProperty)], ToggleInput.prototype, "title", void 0);
  __decorate([(0, serialization_1.property)(ToggleInput.valueOnProperty)], ToggleInput.prototype, "valueOn", void 0);
  __decorate([(0, serialization_1.property)(ToggleInput.valueOffProperty)], ToggleInput.prototype, "valueOff", void 0);
  __decorate([(0, serialization_1.property)(ToggleInput.wrapProperty)], ToggleInput.prototype, "wrap", void 0);
  return ToggleInput;
}(Input);
exports.ToggleInput = ToggleInput;
var Choice = /** @class */function (_super) {
  __extends(Choice, _super);
  function Choice(title, value) {
    var _this = _super.call(this) || this;
    _this.title = title;
    _this.value = value;
    return _this;
  }
  //#endregion
  Choice.prototype.getSchemaKey = function () {
    return "Choice";
  };
  //#region Schema
  Choice.titleProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "title");
  Choice.valueProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "value");
  __decorate([(0, serialization_1.property)(Choice.titleProperty)], Choice.prototype, "title", void 0);
  __decorate([(0, serialization_1.property)(Choice.valueProperty)], Choice.prototype, "value", void 0);
  return Choice;
}(serialization_1.SerializableObject);
exports.Choice = Choice;
/**
 * DataQuery class is declared later in the file and derives from subsequent base classes
 * Hence, it cannot be used in ChoiceSetInput.
 * Refactor is needed to separate elements and actions in separate files.
 */
var ChoiceSetInputDataQuery = /** @class */function (_super) {
  __extends(ChoiceSetInputDataQuery, _super);
  function ChoiceSetInputDataQuery() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  //#endregion
  ChoiceSetInputDataQuery.prototype.getSchemaKey = function () {
    return "choices.data";
  };
  //#region Schema
  ChoiceSetInputDataQuery.typeProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_6, "type", true, new RegExp("^Data.Query$"));
  ChoiceSetInputDataQuery.datasetProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_6, "dataset");
  ChoiceSetInputDataQuery.countProperty = new serialization_1.NumProperty(serialization_1.Versions.v1_6, "count");
  ChoiceSetInputDataQuery.skipProperty = new serialization_1.NumProperty(serialization_1.Versions.v1_6, "skip");
  __decorate([(0, serialization_1.property)(ChoiceSetInputDataQuery.typeProperty)], ChoiceSetInputDataQuery.prototype, "type", void 0);
  __decorate([(0, serialization_1.property)(ChoiceSetInputDataQuery.datasetProperty)], ChoiceSetInputDataQuery.prototype, "dataset", void 0);
  __decorate([(0, serialization_1.property)(ChoiceSetInputDataQuery.countProperty)], ChoiceSetInputDataQuery.prototype, "count", void 0);
  __decorate([(0, serialization_1.property)(ChoiceSetInputDataQuery.skipProperty)], ChoiceSetInputDataQuery.prototype, "skip", void 0);
  return ChoiceSetInputDataQuery;
}(serialization_1.SerializableObject);
exports.ChoiceSetInputDataQuery = ChoiceSetInputDataQuery;
var ChoiceSetInput = /** @class */function (_super) {
  __extends(ChoiceSetInput, _super);
  function ChoiceSetInput() {
    //#region Schema
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.isMultiSelect = false;
    _this.wrap = false;
    _this.choices = [];
    return _this;
  }
  Object.defineProperty(ChoiceSetInput.prototype, "isCompact", {
    get: function () {
      return !this.style || this.style === "compact";
    },
    set: function (value) {
      this.style = value ? undefined : "expanded";
    },
    enumerable: false,
    configurable: true
  });
  ChoiceSetInput.getUniqueCategoryName = function () {
    var uniqueCategoryName = "__ac-category" + ChoiceSetInput._uniqueCategoryCounter;
    ChoiceSetInput._uniqueCategoryCounter++;
    return uniqueCategoryName;
  };
  ChoiceSetInput.prototype.isDynamicTypeahead = function () {
    return this.hostConfig.inputs.allowDynamicallyFilteredChoiceSet && !!this.choicesData && !!this.choicesData.dataset && this.choicesData.type === "Data.Query";
  };
  ChoiceSetInput.prototype.getFilterForDynamicSearch = function () {
    var _a;
    return (_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value;
  };
  ChoiceSetInput.prototype.getDropdownElement = function () {
    var _a;
    return (_a = this._filteredChoiceSet) === null || _a === void 0 ? void 0 : _a.dropdown;
  };
  ChoiceSetInput.prototype.renderChoices = function (filter, fetchedChoices) {
    var _a;
    (_a = this._filteredChoiceSet) === null || _a === void 0 ? void 0 : _a.processResponse(filter, fetchedChoices);
  };
  ChoiceSetInput.prototype.showLoadingIndicator = function () {
    var _a;
    (_a = this._filteredChoiceSet) === null || _a === void 0 ? void 0 : _a.showLoadingIndicator();
  };
  ChoiceSetInput.prototype.removeLoadingIndicator = function () {
    var _a;
    (_a = this._filteredChoiceSet) === null || _a === void 0 ? void 0 : _a.removeLoadingIndicator();
  };
  ChoiceSetInput.prototype.showErrorIndicator = function (filter, error) {
    var _a;
    (_a = this._filteredChoiceSet) === null || _a === void 0 ? void 0 : _a.showErrorIndicator(filter, error);
  };
  ChoiceSetInput.prototype.showValidationFailureCue = function () {
    var _a;
    (_a = this._textInput) === null || _a === void 0 ? void 0 : _a.classList.add(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
  };
  ChoiceSetInput.prototype.removeValidationFailureCue = function () {
    var _a;
    (_a = this._textInput) === null || _a === void 0 ? void 0 : _a.classList.remove(this.hostConfig.makeCssClassName("ac-input-validation-failed"));
  };
  ChoiceSetInput.prototype.createPlaceholderOptionWhenValueDoesNotExist = function () {
    if (!this.value) {
      var placeholderOption = document.createElement("option");
      placeholderOption.selected = true;
      placeholderOption.disabled = true;
      placeholderOption.hidden = true;
      placeholderOption.value = "";
      if (this.placeholder) {
        placeholderOption.text = this.placeholder;
      }
      return placeholderOption;
    }
    return undefined;
  };
  // Make sure `aria-current` is applied to the currently-selected item
  ChoiceSetInput.prototype.internalApplyAriaCurrent = function () {
    if (this._selectElement) {
      var options = this._selectElement.options;
      if (options) {
        for (var _i = 0, _a = Array.from(options); _i < _a.length; _i++) {
          var option = _a[_i];
          if (option.selected) {
            option.setAttribute("aria-current", "true");
          } else {
            option.removeAttribute("aria-current");
          }
        }
      }
    }
  };
  ChoiceSetInput.prototype.renderCompoundInput = function (cssClassName, type, defaultValues) {
    var _this = this;
    var element = document.createElement("div");
    element.className = this.hostConfig.makeCssClassName("ac-input", cssClassName);
    element.style.width = "100%";
    element.tabIndex = this.isDesignMode() ? -1 : 0;
    this._toggleInputs = [];
    this._labels = [];
    for (var _i = 0, _a = this.choices; _i < _a.length; _i++) {
      var choice = _a[_i];
      var input = document.createElement("input");
      input.id = Utils.generateUniqueId();
      input.type = type;
      input.style.margin = "0";
      input.style.display = "inline-block";
      input.style.verticalAlign = "middle";
      input.style.flex = "0 0 auto";
      input.name = this.id ? this.id : this._uniqueCategoryName;
      if (this.isRequired) {
        input.setAttribute("aria-required", "true");
      }
      input.tabIndex = this.isDesignMode() ? -1 : 0;
      if (choice.value) {
        input.value = choice.value;
      }
      if (choice.title) {
        input.setAttribute("aria-label", choice.title);
      }
      if (defaultValues && choice.value) {
        if (defaultValues.indexOf(choice.value) >= 0) {
          input.checked = true;
        }
      }
      input.onchange = function () {
        _this.valueChanged();
      };
      this._toggleInputs.push(input);
      var compoundInput = document.createElement("div");
      compoundInput.style.display = "flex";
      compoundInput.style.alignItems = "center";
      Utils.appendChild(compoundInput, input);
      var label = new TextBlock();
      label.setParent(this);
      label.forElementId = input.id;
      label.hostConfig = this.hostConfig;
      label.text = choice.title ? choice.title : "Choice " + this._toggleInputs.length;
      label.useMarkdown = shared_1.GlobalSettings.useMarkdownInRadioButtonAndCheckbox;
      label.wrap = this.wrap;
      var labelElement = label.render();
      this._labels.push(labelElement);
      if (labelElement) {
        labelElement.id = Utils.generateUniqueId();
        labelElement.style.display = "inline-block";
        labelElement.style.flex = "1 1 auto";
        labelElement.style.marginLeft = "6px";
        labelElement.style.verticalAlign = "middle";
        var spacerElement = document.createElement("div");
        spacerElement.style.width = "6px";
        Utils.appendChild(compoundInput, spacerElement);
        Utils.appendChild(compoundInput, labelElement);
      }
      Utils.appendChild(element, compoundInput);
    }
    return element;
  };
  ChoiceSetInput.prototype.updateInputControlAriaLabelledBy = function () {
    if ((this.isMultiSelect || this.style === "expanded") && this._toggleInputs && this._labels) {
      var labelIds = this.getAllLabelIds();
      for (var i = 0; i < this._toggleInputs.length; i++) {
        var joinedLabelIds = labelIds.join(" ");
        var label = this._labels[i];
        if (label && label.id) {
          joinedLabelIds += " " + label.id;
        }
        if (joinedLabelIds) {
          this._toggleInputs[i].setAttribute("aria-labelledby", joinedLabelIds);
        } else {
          this._toggleInputs[i].removeAttribute("aria-labelledby");
        }
      }
    } else {
      _super.prototype.updateInputControlAriaLabelledBy.call(this);
    }
  };
  ChoiceSetInput.prototype.internalRender = function () {
    var _this = this;
    this._uniqueCategoryName = ChoiceSetInput.getUniqueCategoryName();
    if (this.isDynamicTypeahead()) {
      var filteredChoiceSet_1 = new FilteredChoiceSet(ChoiceSetInput._uniqueCategoryCounter, this.choices, this.hostConfig);
      filteredChoiceSet_1.render();
      if (filteredChoiceSet_1.textInput) {
        this._textInput = filteredChoiceSet_1.textInput;
        if (this.defaultValue) {
          this._textInput.value = this.defaultValue;
        }
        if (this.placeholder && !this._textInput.value) {
          this._textInput.placeholder = this.placeholder;
          this._textInput.setAttribute("aria-label", this.placeholder);
        }
        this._textInput.tabIndex = this.isDesignMode() ? -1 : 0;
        var onInputChangeEventHandler = Utils.debounce(function () {
          filteredChoiceSet_1.processChoices();
          _this.valueChanged();
          if (_this._textInput) {
            // Remove aria-label when value is not empty so narration software doesn't
            // read the placeholder
            if (_this.value) {
              _this._textInput.removeAttribute("placeholder");
              _this._textInput.removeAttribute("aria-label");
            } else if (_this.placeholder) {
              _this._textInput.placeholder = _this.placeholder;
              _this._textInput.setAttribute("aria-label", _this.placeholder);
            }
          }
        }, this.hostConfig.inputs.debounceTimeInMilliSeconds);
        this._textInput.onclick = onInputChangeEventHandler;
        this._textInput.oninput = onInputChangeEventHandler;
      }
      filteredChoiceSet_1.parent = this;
      this._filteredChoiceSet = filteredChoiceSet_1;
      return filteredChoiceSet_1.renderedElement;
    } else if (this.isMultiSelect) {
      // Render as a list of toggle inputs
      return this.renderCompoundInput("ac-choiceSetInput-multiSelect", "checkbox", this.defaultValue ? this.defaultValue.split(this.hostConfig.choiceSetInputValueSeparator) : undefined);
    } else {
      if (this.style === "expanded") {
        // Render as a series of radio buttons
        return this.renderCompoundInput("ac-choiceSetInput-expanded", "radio", this.defaultValue ? [this.defaultValue] : undefined);
      } else if (this.style === "filtered") {
        // Render as a text input coupled with a datalist
        var inputContainer = document.createElement("div");
        inputContainer.style.width = "100%";
        this._textInput = document.createElement("input");
        this._textInput.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-filtered");
        this._textInput.type = "text";
        this._textInput.style.width = "100%";
        this._textInput.oninput = function () {
          _this.valueChanged();
          if (_this._textInput) {
            // Remove aria-label when value is not empty so narration software doesn't
            // read the placeholder
            if (_this.value) {
              _this._textInput.removeAttribute("placeholder");
              _this._textInput.removeAttribute("aria-label");
            } else if (_this.placeholder) {
              _this._textInput.placeholder = _this.placeholder;
              _this._textInput.setAttribute("aria-label", _this.placeholder);
            }
          }
        };
        if (this.defaultValue) {
          this._textInput.value = this.defaultValue;
        }
        if (this.placeholder && !this._textInput.value) {
          this._textInput.placeholder = this.placeholder;
          this._textInput.setAttribute("aria-label", this.placeholder);
        }
        this._textInput.tabIndex = this.isDesignMode() ? -1 : 0;
        var dataList = document.createElement("datalist");
        dataList.id = Utils.generateUniqueId();
        for (var _i = 0, _a = this.choices; _i < _a.length; _i++) {
          var choice = _a[_i];
          var option = document.createElement("option");
          // To fix https://stackoverflow.com/questions/29882361/show-datalist-labels-but-submit-the-actual-value
          // value is mapped to choice.title other than choice.value
          if (choice.title) {
            option.value = choice.title;
            option.setAttribute("aria-label", choice.title);
          }
          option.tabIndex = this.isDesignMode() ? -1 : 0;
          dataList.appendChild(option);
        }
        this._textInput.setAttribute("list", dataList.id);
        inputContainer.append(this._textInput, dataList);
        return inputContainer;
      } else {
        // Render as a combo box
        this._selectElement = document.createElement("select");
        this._selectElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-multichoiceInput", "ac-choiceSetInput-compact");
        this._selectElement.style.width = "100%";
        this._selectElement.tabIndex = this.isDesignMode() ? -1 : 0;
        var placeholderOption = this.createPlaceholderOptionWhenValueDoesNotExist();
        Utils.appendChild(this._selectElement, placeholderOption);
        for (var _b = 0, _c = this.choices; _b < _c.length; _b++) {
          var choice = _c[_b];
          var option = document.createElement("option");
          option.value = choice.value;
          if (choice.title) {
            option.text = choice.title;
            option.setAttribute("aria-label", choice.title);
          }
          option.tabIndex = this.isDesignMode() ? -1 : 0;
          if (choice.value === this.defaultValue) {
            option.selected = true;
          }
          Utils.appendChild(this._selectElement, option);
        }
        this._selectElement.onchange = function () {
          _this.internalApplyAriaCurrent();
          _this.valueChanged();
        };
        this.internalApplyAriaCurrent();
        return this._selectElement;
      }
    }
  };
  ChoiceSetInput.prototype.updateVisualState = function (eventType) {
    if (!this.allowRevealOnHoverStyle) {
      return;
    }
    if (!this.isMultiSelect && this.isCompact) {
      _super.prototype.updateVisualState.call(this, eventType);
      if (this._selectElement && this.inputStyle === Enums.InputStyle.RevealOnHover) {
        var hideDropDownPicker = this.shouldHideInputAdornersForRevealOnHover(this._selectElement, eventType);
        if (hideDropDownPicker) {
          this._selectElement.style.appearance = "none";
          this._selectElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
        } else {
          this._selectElement.style.appearance = "auto";
          this._selectElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
        }
      }
    }
  };
  ChoiceSetInput.prototype.getJsonTypeName = function () {
    return "Input.ChoiceSet";
  };
  ChoiceSetInput.prototype.focus = function () {
    if (this._toggleInputs && (this.isMultiSelect || this.style === "expanded")) {
      if (this._toggleInputs.length > 0) {
        this._toggleInputs[0].focus();
      }
    } else if (this._textInput) {
      this._textInput.focus();
    } else {
      _super.prototype.focus.call(this);
    }
  };
  ChoiceSetInput.prototype.internalValidateProperties = function (context) {
    _super.prototype.internalValidateProperties.call(this, context);
    if (this.choices.length === 0) {
      context.addFailure(this, Enums.ValidationEvent.CollectionCantBeEmpty, strings_1.Strings.errors.choiceSetMustHaveAtLeastOneChoice());
    }
    for (var _i = 0, _a = this.choices; _i < _a.length; _i++) {
      var choice = _a[_i];
      if (!choice.title || !choice.value) {
        context.addFailure(this, Enums.ValidationEvent.PropertyCantBeNull, strings_1.Strings.errors.choiceSetChoicesMustHaveTitleAndValue());
      }
    }
  };
  ChoiceSetInput.prototype.isSet = function () {
    return this.value ? true : false;
  };
  ChoiceSetInput.prototype.isValid = function () {
    if (this._textInput) {
      if (this.value === "" || this.value === this.placeholder) {
        return true;
      }
      for (var _i = 0, _a = this.choices; _i < _a.length; _i++) {
        var choice = _a[_i];
        if (this.value === choice.value) {
          return true;
        }
      }
      if (this.dynamicChoices) {
        for (var _b = 0, _c = this.dynamicChoices; _b < _c.length; _b++) {
          var choice = _c[_b];
          if (this.value === choice) {
            return true;
          }
        }
      }
      return false;
    }
    return _super.prototype.isValid.call(this);
  };
  Object.defineProperty(ChoiceSetInput.prototype, "value", {
    get: function () {
      if (!this.isMultiSelect) {
        if (this._selectElement) {
          return this._selectElement.selectedIndex > 0 ? this._selectElement.value : undefined;
        } else if (this._textInput) {
          for (var _i = 0, _a = this.choices; _i < _a.length; _i++) {
            var choice = _a[_i];
            if (choice.title && this._textInput.value === choice.title) {
              return choice.value;
            }
          }
          return this._textInput.value;
        } else if (this._toggleInputs && this._toggleInputs.length > 0) {
          for (var _b = 0, _c = this._toggleInputs; _b < _c.length; _b++) {
            var toggleInput = _c[_b];
            if (toggleInput.checked) {
              return toggleInput.value;
            }
          }
        }
        return undefined;
      } else {
        if (!this._toggleInputs || this._toggleInputs.length === 0) {
          return undefined;
        }
        var result = "";
        for (var _d = 0, _f = this._toggleInputs; _d < _f.length; _d++) {
          var toggleInput = _f[_d];
          if (toggleInput.checked) {
            if (result !== "") {
              result += this.hostConfig.choiceSetInputValueSeparator;
            }
            result += toggleInput.value;
          }
        }
        return result ? result : undefined;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ChoiceSetInput.prototype, "dynamicChoices", {
    get: function () {
      var _a;
      return (_a = this._filteredChoiceSet) === null || _a === void 0 ? void 0 : _a.dynamicChoices;
    },
    enumerable: false,
    configurable: true
  });
  ChoiceSetInput.valueProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "value");
  ChoiceSetInput.choicesProperty = new serialization_1.SerializableObjectCollectionProperty(serialization_1.Versions.v1_0, "choices", Choice);
  ChoiceSetInput.choicesDataProperty = new serialization_1.SerializableObjectProperty(serialization_1.Versions.v1_6, "choices.data", ChoiceSetInputDataQuery);
  ChoiceSetInput.styleProperty = new serialization_1.ValueSetProperty(serialization_1.Versions.v1_0, "style", [{
    value: "compact"
  }, {
    value: "expanded"
  }, {
    value: "filtered",
    targetVersion: serialization_1.Versions.v1_5
  }], "compact");
  ChoiceSetInput.isMultiSelectProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_0, "isMultiSelect", false);
  ChoiceSetInput.placeholderProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "placeholder");
  ChoiceSetInput.wrapProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_2, "wrap", false);
  //#endregion
  ChoiceSetInput._uniqueCategoryCounter = 0;
  __decorate([(0, serialization_1.property)(ChoiceSetInput.valueProperty)], ChoiceSetInput.prototype, "defaultValue", void 0);
  __decorate([(0, serialization_1.property)(ChoiceSetInput.styleProperty)], ChoiceSetInput.prototype, "style", void 0);
  __decorate([(0, serialization_1.property)(ChoiceSetInput.isMultiSelectProperty)], ChoiceSetInput.prototype, "isMultiSelect", void 0);
  __decorate([(0, serialization_1.property)(ChoiceSetInput.placeholderProperty)], ChoiceSetInput.prototype, "placeholder", void 0);
  __decorate([(0, serialization_1.property)(ChoiceSetInput.wrapProperty)], ChoiceSetInput.prototype, "wrap", void 0);
  __decorate([(0, serialization_1.property)(ChoiceSetInput.choicesProperty)], ChoiceSetInput.prototype, "choices", void 0);
  __decorate([(0, serialization_1.property)(ChoiceSetInput.choicesDataProperty)], ChoiceSetInput.prototype, "choicesData", void 0);
  return ChoiceSetInput;
}(Input);
exports.ChoiceSetInput = ChoiceSetInput;
var FilteredChoiceSet = /** @class */function () {
  function FilteredChoiceSet(choiceSetId, choices, hostConfig) {
    this._choiceSetId = choiceSetId;
    this._choices = choices;
    this._dynamicChoices = [];
    this._visibleChoiceCount = 0;
    this._highlightedChoiceId = -1;
    this._hostConfig = hostConfig;
  }
  FilteredChoiceSet.prototype.render = function () {
    var _this = this;
    var choiceSetContainer = document.createElement("div");
    choiceSetContainer.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-filtered-container");
    this._textInput = document.createElement("input");
    this._textInput.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-filtered-textbox");
    this._textInput.type = "text";
    this._textInput.onkeydown = function (event) {
      if (event.key === "ArrowDown") {
        event.preventDefault();
        _this.highlightChoice(_this._highlightedChoiceId + 1);
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        _this.highlightChoice(_this._highlightedChoiceId - 1);
      } else if (event.key === "Enter") {
        var choice = document.getElementById("ac-choiceSetInput-".concat(_this._choiceSetId, "-choice-").concat(_this._highlightedChoiceId));
        choice === null || choice === void 0 ? void 0 : choice.click();
      }
    };
    this._dropdown = document.createElement("div");
    this._dropdown.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-filtered-dropdown");
    choiceSetContainer.append(this._textInput, this._dropdown);
    this._renderedElement = choiceSetContainer;
  };
  FilteredChoiceSet.prototype.createChoice = function (value, filter, id) {
    var _this = this;
    var choice = document.createElement("span");
    choice.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-choice");
    choice.id = "ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(id);
    choice.innerHTML = value.replace(filter, "<b>".concat(filter, "</b>"));
    choice.tabIndex = -1;
    choice.onclick = function () {
      choice.classList.remove(_this.hostConfig.makeCssClassName("ac-choiceSetInput-choice-highlighted"));
      _this._highlightedChoiceId = -1;
      if (_this._textInput) {
        _this._textInput.value = choice.innerText;
        _this._textInput.focus();
      }
      if (_this._dropdown) {
        _this._dropdown.classList.remove(_this.hostConfig.makeCssClassName("ac-choiceSetInput-filtered-dropdown-open"));
      }
    };
    choice.onmousemove = function () {
      if (_this._highlightedChoiceId !== id) {
        _this.highlightChoice(id, false);
      }
    };
    return choice;
  };
  FilteredChoiceSet.prototype.highlightChoice = function (id, scrollIntoView) {
    if (scrollIntoView === void 0) {
      scrollIntoView = true;
    }
    if (this._visibleChoiceCount > 0) {
      var currentHighlightedChoice = document.getElementById("ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(this._highlightedChoiceId));
      var nextHighlightedChoice = document.getElementById("ac-choiceSetInput-".concat(this._choiceSetId, "-choice-").concat(id));
      if (nextHighlightedChoice) {
        currentHighlightedChoice === null || currentHighlightedChoice === void 0 ? void 0 : currentHighlightedChoice.classList.remove(this.hostConfig.makeCssClassName("ac-choiceSetInput-choice-highlighted"));
        nextHighlightedChoice.classList.add(this.hostConfig.makeCssClassName("ac-choiceSetInput-choice-highlighted"));
        if (scrollIntoView) {
          nextHighlightedChoice.scrollIntoView();
        }
        this._highlightedChoiceId = id;
      } else if (currentHighlightedChoice && this._highlightedChoiceId !== 0) {
        this.highlightChoice(0);
      } else {
        this.highlightChoice(this._visibleChoiceCount - 1);
      }
    }
  };
  FilteredChoiceSet.prototype.filterChoices = function () {
    var _a, _b;
    var filter = ((_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value.toLowerCase().trim()) || "";
    var choices = __spreadArray(__spreadArray([], this._choices, true), this._dynamicChoices, true);
    for (var _i = 0, choices_1 = choices; _i < choices_1.length; _i++) {
      var choice = choices_1[_i];
      if (choice.title) {
        var matchIndex = choice.title.toLowerCase().indexOf(filter);
        if (matchIndex !== -1) {
          var matchedText = choice.title.substring(matchIndex, matchIndex + filter.length);
          var choiceContainer = this.createChoice(choice.title, matchedText, this._visibleChoiceCount++);
          (_b = this._dropdown) === null || _b === void 0 ? void 0 : _b.appendChild(choiceContainer);
        }
      }
    }
  };
  FilteredChoiceSet.prototype.getStatusIndicator = function (error) {
    if (error) {
      if (!this._errorIndicator) {
        var errorIndicator = document.createElement("div");
        errorIndicator.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-statusIndicator", "ac-choiceSetInput-errorIndicator");
        this._errorIndicator = errorIndicator;
      }
      this._errorIndicator.innerText = error;
      return this._errorIndicator;
    } else {
      if (!this._loadingIndicator) {
        var loadingIndicator = document.createElement("div");
        loadingIndicator.className = this.hostConfig.makeCssClassName("ac-input", "ac-choiceSetInput-statusIndicator");
        this._loadingIndicator = loadingIndicator;
      }
      this._loadingIndicator.innerText = this._visibleChoiceCount === 0 ? "Loading..." : "Loading more...";
      return this._loadingIndicator;
    }
  };
  FilteredChoiceSet.prototype.resetDropdown = function () {
    if (this._dropdown) {
      Utils.clearElementChildren(this._dropdown);
      this._visibleChoiceCount = 0;
      this._highlightedChoiceId = -1;
    }
  };
  FilteredChoiceSet.prototype.showDropdown = function () {
    var _a;
    if ((_a = this._dropdown) === null || _a === void 0 ? void 0 : _a.hasChildNodes()) {
      this._dropdown.classList.add(this.hostConfig.makeCssClassName("ac-choiceSetInput-filtered-dropdown-open"));
    }
  };
  FilteredChoiceSet.prototype.processChoices = function () {
    this.resetDropdown();
    this.filterChoices();
    this.showDropdown();
  };
  FilteredChoiceSet.prototype.processResponse = function (filter, fetchedChoices) {
    var _a;
    if (filter === ((_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value)) {
      this.resetDropdown();
      this._dynamicChoices = fetchedChoices;
      this.filterChoices();
      if (this._visibleChoiceCount === 0) {
        this.showErrorIndicator(filter, "No results found");
      }
    }
  };
  FilteredChoiceSet.prototype.showLoadingIndicator = function () {
    var _a;
    var loadingIndicator = this.getStatusIndicator();
    (_a = this._dropdown) === null || _a === void 0 ? void 0 : _a.appendChild(loadingIndicator);
    this.showDropdown();
  };
  FilteredChoiceSet.prototype.removeLoadingIndicator = function () {
    var _a, _b;
    if (this._loadingIndicator && ((_a = this._dropdown) === null || _a === void 0 ? void 0 : _a.contains(this._loadingIndicator))) {
      (_b = this._dropdown) === null || _b === void 0 ? void 0 : _b.removeChild(this._loadingIndicator);
    }
  };
  FilteredChoiceSet.prototype.showErrorIndicator = function (filter, error) {
    var _a, _b;
    if (filter === ((_a = this._textInput) === null || _a === void 0 ? void 0 : _a.value)) {
      this.processChoices();
      var errorIndicator = this.getStatusIndicator(error);
      (_b = this._dropdown) === null || _b === void 0 ? void 0 : _b.appendChild(errorIndicator);
      errorIndicator.scrollIntoView();
    }
  };
  Object.defineProperty(FilteredChoiceSet.prototype, "dynamicChoices", {
    get: function () {
      var _a;
      return (_a = this._dynamicChoices) === null || _a === void 0 ? void 0 : _a.map(function (choice) {
        return choice.title;
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FilteredChoiceSet.prototype, "hostConfig", {
    get: function () {
      if (this._hostConfig) {
        return this._hostConfig;
      } else {
        if (this.parent) {
          return this.parent.hostConfig;
        } else {
          return host_config_1.defaultHostConfig;
        }
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FilteredChoiceSet.prototype, "parent", {
    get: function () {
      return this._parent;
    },
    set: function (value) {
      this._parent = value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FilteredChoiceSet.prototype, "renderedElement", {
    get: function () {
      return this._renderedElement;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FilteredChoiceSet.prototype, "textInput", {
    get: function () {
      return this._textInput;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FilteredChoiceSet.prototype, "dropdown", {
    get: function () {
      return this._dropdown;
    },
    enumerable: false,
    configurable: true
  });
  return FilteredChoiceSet;
}();
exports.FilteredChoiceSet = FilteredChoiceSet;
var NumberInput = /** @class */function (_super) {
  __extends(NumberInput, _super);
  function NumberInput() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  NumberInput.prototype.internalRender = function () {
    var _this = this;
    this._numberInputElement = document.createElement("input");
    this._numberInputElement.setAttribute("type", "number");
    if (this.min !== undefined) {
      this._numberInputElement.setAttribute("min", this.min.toString());
    }
    if (this.max !== undefined) {
      this._numberInputElement.setAttribute("max", this.max.toString());
    }
    this._numberInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-numberInput");
    this._numberInputElement.style.width = "100%";
    this._numberInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
    if (this.defaultValue !== undefined) {
      this._numberInputElement.valueAsNumber = this.defaultValue;
    }
    if (this.placeholder) {
      this._numberInputElement.placeholder = this.placeholder;
      this._numberInputElement.setAttribute("aria-label", this.placeholder);
    }
    this._numberInputElement.oninput = function () {
      _this.valueChanged();
    };
    return this._numberInputElement;
  };
  NumberInput.prototype.getJsonTypeName = function () {
    return "Input.Number";
  };
  NumberInput.prototype.isSet = function () {
    return this.value !== undefined && !isNaN(this.value);
  };
  NumberInput.prototype.isValid = function () {
    if (this.value === undefined) {
      return !this.isRequired;
    }
    var result = true;
    if (this.min !== undefined) {
      result = result && this.value >= this.min;
    }
    if (this.max !== undefined) {
      result = result && this.value <= this.max;
    }
    return result;
  };
  Object.defineProperty(NumberInput.prototype, "value", {
    get: function () {
      return this._numberInputElement ? this._numberInputElement.valueAsNumber : undefined;
    },
    set: function (value) {
      if (value && this._numberInputElement) {
        this._numberInputElement.value = value.toString();
      }
    },
    enumerable: false,
    configurable: true
  });
  //#region Schema
  NumberInput.valueProperty = new serialization_1.NumProperty(serialization_1.Versions.v1_0, "value");
  NumberInput.placeholderProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "placeholder");
  NumberInput.minProperty = new serialization_1.NumProperty(serialization_1.Versions.v1_0, "min");
  NumberInput.maxProperty = new serialization_1.NumProperty(serialization_1.Versions.v1_0, "max");
  __decorate([(0, serialization_1.property)(NumberInput.valueProperty)], NumberInput.prototype, "defaultValue", void 0);
  __decorate([(0, serialization_1.property)(NumberInput.minProperty)], NumberInput.prototype, "min", void 0);
  __decorate([(0, serialization_1.property)(NumberInput.maxProperty)], NumberInput.prototype, "max", void 0);
  __decorate([(0, serialization_1.property)(NumberInput.placeholderProperty)], NumberInput.prototype, "placeholder", void 0);
  return NumberInput;
}(Input);
exports.NumberInput = NumberInput;
var DateInput = /** @class */function (_super) {
  __extends(DateInput, _super);
  function DateInput() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  DateInput.prototype.internalRender = function () {
    var _this = this;
    this._dateInputElement = document.createElement("input");
    this._dateInputElement.setAttribute("type", "date");
    if (this.min) {
      this._dateInputElement.setAttribute("min", this.min);
    }
    if (this.max) {
      this._dateInputElement.setAttribute("max", this.max);
    }
    if (this.placeholder) {
      this._dateInputElement.placeholder = this.placeholder;
      this._dateInputElement.setAttribute("aria-label", this.placeholder);
    }
    this._dateInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
    this._dateInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-dateInput");
    this._dateInputElement.style.width = "100%";
    this._dateInputElement.oninput = function () {
      _this.valueChanged();
    };
    if (this.defaultValue) {
      this._dateInputElement.value = this.defaultValue;
    }
    return this._dateInputElement;
  };
  DateInput.prototype.updateVisualState = function (eventType) {
    if (!this.allowRevealOnHoverStyle) {
      return;
    }
    _super.prototype.updateVisualState.call(this, eventType);
    if (this._dateInputElement && this.inputStyle === Enums.InputStyle.RevealOnHover) {
      var hideDatePicker = this.shouldHideInputAdornersForRevealOnHover(this._dateInputElement, eventType);
      if (hideDatePicker) {
        this._dateInputElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
      } else {
        this._dateInputElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
      }
      updateInputAdornersVisibility(this._dateInputElement, hideDatePicker /*hide*/);
    }
  };
  DateInput.prototype.getJsonTypeName = function () {
    return "Input.Date";
  };
  DateInput.prototype.isSet = function () {
    return this.value ? true : false;
  };
  DateInput.prototype.isValid = function () {
    if (!this.value) {
      return !this.isRequired;
    }
    var valueAsDate = new Date(this.value);
    var result = true;
    if (this.min) {
      var minDate = new Date(this.min);
      result = result && valueAsDate >= minDate;
    }
    if (this.max) {
      var maxDate = new Date(this.max);
      result = result && valueAsDate <= maxDate;
    }
    return result;
  };
  Object.defineProperty(DateInput.prototype, "value", {
    get: function () {
      return this._dateInputElement ? this._dateInputElement.value : undefined;
    },
    enumerable: false,
    configurable: true
  });
  //#region Schema
  DateInput.valueProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "value");
  DateInput.placeholderProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "placeholder");
  DateInput.minProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "min");
  DateInput.maxProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "max");
  __decorate([(0, serialization_1.property)(DateInput.valueProperty)], DateInput.prototype, "defaultValue", void 0);
  __decorate([(0, serialization_1.property)(DateInput.minProperty)], DateInput.prototype, "min", void 0);
  __decorate([(0, serialization_1.property)(DateInput.maxProperty)], DateInput.prototype, "max", void 0);
  __decorate([(0, serialization_1.property)(DateInput.placeholderProperty)], DateInput.prototype, "placeholder", void 0);
  return DateInput;
}(Input);
exports.DateInput = DateInput;
var TimeProperty = /** @class */function (_super) {
  __extends(TimeProperty, _super);
  function TimeProperty(targetVersion, name) {
    var _this = _super.call(this, targetVersion, name, function (sender, prop, source, context) {
      var value = source[prop.name];
      if (typeof value === "string" && value && /^[0-9]{2}:[0-9]{2}$/.test(value)) {
        return value;
      }
      return undefined;
    }, function (sender, prop, target, value, context) {
      context.serializeValue(target, prop.name, value);
    }) || this;
    _this.targetVersion = targetVersion;
    _this.name = name;
    return _this;
  }
  return TimeProperty;
}(serialization_1.CustomProperty);
exports.TimeProperty = TimeProperty;
var TimeInput = /** @class */function (_super) {
  __extends(TimeInput, _super);
  function TimeInput() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  TimeInput.convertTimeStringToDate = function (timeString) {
    return new Date("1973-09-04T" + timeString + ":00Z");
  };
  TimeInput.prototype.internalRender = function () {
    var _this = this;
    this._timeInputElement = document.createElement("input");
    this._timeInputElement.setAttribute("type", "time");
    if (this.min) {
      this._timeInputElement.setAttribute("min", this.min);
    }
    if (this.max) {
      this._timeInputElement.setAttribute("max", this.max);
    }
    this._timeInputElement.className = this.hostConfig.makeCssClassName("ac-input", "ac-timeInput");
    this._timeInputElement.style.width = "100%";
    this._timeInputElement.oninput = function () {
      _this.valueChanged();
    };
    if (this.placeholder) {
      this._timeInputElement.placeholder = this.placeholder;
      this._timeInputElement.setAttribute("aria-label", this.placeholder);
    }
    this._timeInputElement.tabIndex = this.isDesignMode() ? -1 : 0;
    if (this.defaultValue) {
      this._timeInputElement.value = this.defaultValue;
    }
    return this._timeInputElement;
  };
  TimeInput.prototype.updateVisualState = function (eventType) {
    if (!this.allowRevealOnHoverStyle) {
      return;
    }
    _super.prototype.updateVisualState.call(this, eventType);
    if (this._timeInputElement && this.inputStyle === Enums.InputStyle.RevealOnHover) {
      var hideTimePicker = this.shouldHideInputAdornersForRevealOnHover(this._timeInputElement, eventType);
      if (hideTimePicker) {
        this._timeInputElement.classList.remove(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
      } else {
        this._timeInputElement.classList.add(this.hostConfig.makeCssClassName("ac-inputStyle-revealOnHover-onfocus"));
      }
      updateInputAdornersVisibility(this._timeInputElement, hideTimePicker /*hide*/);
    }
  };
  TimeInput.prototype.getJsonTypeName = function () {
    return "Input.Time";
  };
  TimeInput.prototype.isSet = function () {
    return this.value ? true : false;
  };
  TimeInput.prototype.isValid = function () {
    if (!this.value) {
      return !this.isRequired;
    }
    var valueAsDate = TimeInput.convertTimeStringToDate(this.value);
    var result = true;
    if (this.min) {
      var minDate = TimeInput.convertTimeStringToDate(this.min);
      result = result && valueAsDate >= minDate;
    }
    if (this.max) {
      var maxDate = TimeInput.convertTimeStringToDate(this.max);
      result = result && valueAsDate <= maxDate;
    }
    return result;
  };
  Object.defineProperty(TimeInput.prototype, "value", {
    get: function () {
      return this._timeInputElement ? this._timeInputElement.value : undefined;
    },
    enumerable: false,
    configurable: true
  });
  //#region Schema
  TimeInput.valueProperty = new TimeProperty(serialization_1.Versions.v1_0, "value");
  TimeInput.placeholderProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "placeholder");
  TimeInput.minProperty = new TimeProperty(serialization_1.Versions.v1_0, "min");
  TimeInput.maxProperty = new TimeProperty(serialization_1.Versions.v1_0, "max");
  __decorate([(0, serialization_1.property)(TimeInput.valueProperty)], TimeInput.prototype, "defaultValue", void 0);
  __decorate([(0, serialization_1.property)(TimeInput.minProperty)], TimeInput.prototype, "min", void 0);
  __decorate([(0, serialization_1.property)(TimeInput.maxProperty)], TimeInput.prototype, "max", void 0);
  __decorate([(0, serialization_1.property)(TimeInput.placeholderProperty)], TimeInput.prototype, "placeholder", void 0);
  return TimeInput;
}(Input);
exports.TimeInput = TimeInput;
var Action = /** @class */function (_super) {
  __extends(Action, _super);
  function Action() {
    //#region Schema
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.style = Enums.ActionStyle.Default;
    _this.mode = Enums.ActionMode.Primary;
    _this._state = 0 /* Normal */;
    _this._isFocusable = true;
    return _this;
  }
  //#endregion
  Action.prototype.renderButtonContent = function () {
    if (this.renderedElement) {
      // Cache hostConfig for perf
      var hostConfig = this.hostConfig;
      var titleElement = document.createElement("div");
      titleElement.style.overflow = "hidden";
      titleElement.style.textOverflow = "ellipsis";
      if (!(hostConfig.actions.iconPlacement === Enums.ActionIconPlacement.AboveTitle || hostConfig.actions.allowTitleToWrap)) {
        titleElement.style.whiteSpace = "nowrap";
      }
      if (this.title) {
        titleElement.innerText = this.title;
      }
      if (!this.iconUrl) {
        this.renderedElement.classList.add("noIcon");
        this.renderedElement.appendChild(titleElement);
      } else {
        var iconElement = document.createElement("img");
        iconElement.src = this.iconUrl;
        iconElement.style.width = hostConfig.actions.iconSize + "px";
        iconElement.style.height = hostConfig.actions.iconSize + "px";
        iconElement.style.flex = "0 0 auto";
        if (hostConfig.actions.iconPlacement === Enums.ActionIconPlacement.AboveTitle) {
          this.renderedElement.classList.add("iconAbove");
          this.renderedElement.style.flexDirection = "column";
          if (this.title) {
            iconElement.style.marginBottom = "6px";
          }
        } else {
          this.renderedElement.classList.add("iconLeft");
          iconElement.style.maxHeight = "100%";
          if (this.title) {
            iconElement.style.marginRight = "6px";
          }
        }
        this.renderedElement.appendChild(iconElement);
        this.renderedElement.appendChild(titleElement);
      }
    }
  };
  Action.prototype.getParentContainer = function () {
    if (this.parent instanceof Container) {
      return this.parent;
    }
    return this.parent ? this.parent.getParentContainer() : undefined;
  };
  Action.prototype.isDesignMode = function () {
    var rootElement = this.getRootObject();
    return rootElement instanceof CardElement && rootElement.isDesignMode();
  };
  Action.prototype.updateCssClasses = function () {
    var _a, _b;
    if (this.parent && this.renderedElement) {
      var hostConfig = this.parent.hostConfig;
      this.renderedElement.className = hostConfig.makeCssClassName(this.isEffectivelyEnabled() ? "ac-pushButton" : "ac-pushButton-disabled");
      var parentContainer = this.getParentContainer();
      if (parentContainer) {
        var parentContainerStyle = parentContainer.getEffectiveStyle();
        if (parentContainerStyle) {
          this.renderedElement.classList.add("style-" + parentContainerStyle);
        }
      }
      this.renderedElement.tabIndex = !this.isDesignMode() && this.isFocusable ? 0 : -1;
      switch (this._state) {
        case 0 /* Normal */:
          // No additional classes needed
          break;
        case 1 /* Expanded */:
          this.renderedElement.classList.add(hostConfig.makeCssClassName("expanded"));
          break;
        case 2 /* Subdued */:
          this.renderedElement.classList.add(hostConfig.makeCssClassName("subdued"));
          break;
      }
      if (this.style && this.isEffectivelyEnabled()) {
        if (this.style === Enums.ActionStyle.Positive) {
          (_a = this.renderedElement.classList).add.apply(_a, hostConfig.makeCssClassNames("primary", "style-positive"));
        } else {
          (_b = this.renderedElement.classList).add.apply(_b, hostConfig.makeCssClassNames("style-" + this.style.toLowerCase()));
        }
      }
    }
  };
  Action.prototype.getDefaultSerializationContext = function () {
    return new SerializationContext();
  };
  Action.prototype.internalGetReferencedInputs = function () {
    return {};
  };
  Action.prototype.internalPrepareForExecution = function (_inputs) {
    // Do nothing in base implementation
  };
  Action.prototype.internalValidateInputs = function (referencedInputs) {
    var result = [];
    if (referencedInputs) {
      for (var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++) {
        var key = _a[_i];
        var input = referencedInputs[key];
        if (!input.validateValue()) {
          result.push(input);
        }
      }
    }
    return result;
  };
  Action.prototype.shouldSerialize = function (context) {
    return context.actionRegistry.findByName(this.getJsonTypeName()) !== undefined;
  };
  Action.prototype.raiseExecuteActionEvent = function () {
    if (this.onExecute) {
      this.onExecute(this);
    }
    raiseExecuteActionEvent(this);
  };
  Action.prototype.internalAfterExecute = function () {
    var rootObject = this.getRootObject();
    if (rootObject instanceof CardElement) {
      rootObject.updateActionsEnabledState();
    }
  };
  Action.prototype.getHref = function () {
    return "";
  };
  Action.prototype.getAriaRole = function () {
    var ariaRole = this.getAriaRoleFromEnum();
    return ariaRole !== null && ariaRole !== void 0 ? ariaRole : "button";
  };
  Action.prototype.getAriaRoleFromEnum = function () {
    switch (this.role) {
      case Enums.ActionRole.Button:
        return "button";
      case Enums.ActionRole.Link:
        return "link";
      case Enums.ActionRole.Menu:
        return "menu";
      case Enums.ActionRole.MenuItem:
        return "menuitem";
      case Enums.ActionRole.Tab:
        return "tab";
      default:
        return undefined;
    }
  };
  Action.prototype.setupElementForAccessibility = function (element, promoteTooltipToLabel) {
    if (promoteTooltipToLabel === void 0) {
      promoteTooltipToLabel = false;
    }
    element.tabIndex = this.isEffectivelyEnabled() && !this.isDesignMode() ? 0 : -1;
    element.setAttribute("role", this.getAriaRole());
    if (element instanceof HTMLButtonElement) {
      element.disabled = !this.isEffectivelyEnabled();
    }
    if (!this.isEffectivelyEnabled()) {
      element.setAttribute("aria-disabled", "true");
    } else {
      element.removeAttribute("aria-disabled");
      element.classList.add(this.hostConfig.makeCssClassName("ac-selectable"));
    }
    if (this.title) {
      element.setAttribute("aria-label", this.title);
      element.title = this.title;
    } else {
      element.removeAttribute("aria-label");
      element.removeAttribute("title");
    }
    if (this.tooltip) {
      if (promoteTooltipToLabel && !this.title) {
        element.setAttribute("aria-label", this.tooltip);
      }
      element.title = this.tooltip;
    }
  };
  Action.prototype.parse = function (source, context) {
    return _super.prototype.parse.call(this, source, context ? context : new SerializationContext());
  };
  Action.prototype.render = function () {
    var _this = this;
    var buttonElement = document.createElement("button");
    buttonElement.type = "button";
    buttonElement.style.display = "flex";
    buttonElement.style.alignItems = "center";
    buttonElement.style.justifyContent = "center";
    buttonElement.onclick = function (e) {
      if (_this.isEffectivelyEnabled()) {
        e.preventDefault();
        e.cancelBubble = true;
        _this.execute();
      }
    };
    this._renderedElement = buttonElement;
    this.renderButtonContent();
    this.updateCssClasses();
    this.setupElementForAccessibility(buttonElement);
  };
  Action.prototype.execute = function () {
    if (this._actionCollection) {
      this._actionCollection.actionExecuted(this);
    }
    this.raiseExecuteActionEvent();
    this.internalAfterExecute();
  };
  Action.prototype.prepareForExecution = function () {
    var referencedInputs = this.getReferencedInputs();
    var invalidInputs = this.internalValidateInputs(referencedInputs);
    if (invalidInputs.length > 0) {
      invalidInputs[0].focus();
      return false;
    }
    this.internalPrepareForExecution(referencedInputs);
    return true;
  };
  Action.prototype.remove = function () {
    if (this._actionCollection) {
      return this._actionCollection.removeAction(this);
    }
    return false;
  };
  Action.prototype.getAllInputs = function (processActions) {
    if (processActions === void 0) {
      processActions = true;
    }
    return [];
  };
  Action.prototype.getAllActions = function () {
    return [this];
  };
  Action.prototype.getResourceInformation = function () {
    return this.iconUrl ? [{
      url: this.iconUrl,
      mimeType: "image"
    }] : [];
  };
  Action.prototype.getActionById = function (id) {
    return this.id === id ? this : undefined;
  };
  Action.prototype.getReferencedInputs = function () {
    return this.internalGetReferencedInputs();
  };
  /**
   * Validates the inputs associated with this action.
   *
   * @returns A list of inputs that failed validation, or an empty array if no input failed validation.
   */
  Action.prototype.validateInputs = function () {
    return this.internalValidateInputs(this.getReferencedInputs());
  };
  Action.prototype.updateEnabledState = function () {
    // Do nothing in base implementation
  };
  Action.prototype.isEffectivelyEnabled = function () {
    return this.isEnabled;
  };
  Object.defineProperty(Action.prototype, "isPrimary", {
    get: function () {
      return this.style === Enums.ActionStyle.Positive;
    },
    set: function (value) {
      if (value) {
        this.style = Enums.ActionStyle.Positive;
      } else {
        if (this.style === Enums.ActionStyle.Positive) {
          this.style = Enums.ActionStyle.Default;
        }
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Action.prototype, "hostConfig", {
    get: function () {
      return this.parent ? this.parent.hostConfig : host_config_1.defaultHostConfig;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Action.prototype, "parent", {
    get: function () {
      return this._parent;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Action.prototype, "state", {
    get: function () {
      return this._state;
    },
    set: function (value) {
      if (this._state !== value) {
        this._state = value;
        this.updateCssClasses();
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Action.prototype, "isFocusable", {
    get: function () {
      return this._isFocusable;
    },
    set: function (value) {
      if (this._isFocusable !== value) {
        this._isFocusable = value;
        this.updateCssClasses();
      }
    },
    enumerable: false,
    configurable: true
  });
  Action.titleProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "title");
  Action.iconUrlProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_1, "iconUrl");
  Action.styleProperty = new serialization_1.ValueSetProperty(serialization_1.Versions.v1_2, "style", [{
    value: Enums.ActionStyle.Default
  }, {
    value: Enums.ActionStyle.Positive
  }, {
    value: Enums.ActionStyle.Destructive
  }], Enums.ActionStyle.Default);
  Action.modeProperty = new serialization_1.ValueSetProperty(serialization_1.Versions.v1_5, "mode", [{
    value: Enums.ActionMode.Primary
  }, {
    value: Enums.ActionMode.Secondary
  }], Enums.ActionMode.Primary);
  Action.tooltipProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_5, "tooltip");
  Action.isEnabledProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_5, "isEnabled", true);
  Action.roleProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_6, "role", Enums.ActionRole);
  __decorate([(0, serialization_1.property)(Action.titleProperty)], Action.prototype, "title", void 0);
  __decorate([(0, serialization_1.property)(Action.iconUrlProperty)], Action.prototype, "iconUrl", void 0);
  __decorate([(0, serialization_1.property)(Action.styleProperty)], Action.prototype, "style", void 0);
  __decorate([(0, serialization_1.property)(Action.modeProperty)], Action.prototype, "mode", void 0);
  __decorate([(0, serialization_1.property)(Action.tooltipProperty)], Action.prototype, "tooltip", void 0);
  __decorate([(0, serialization_1.property)(Action.isEnabledProperty)], Action.prototype, "isEnabled", void 0);
  __decorate([(0, serialization_1.property)(Action.roleProperty)], Action.prototype, "role", void 0);
  return Action;
}(card_object_1.CardObject);
exports.Action = Action;
var SubmitActionBase = /** @class */function (_super) {
  __extends(SubmitActionBase, _super);
  function SubmitActionBase() {
    //#region Schema
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.disabledUnlessAssociatedInputsChange = false;
    //#endregion
    _this._isPrepared = false;
    _this._areReferencedInputsDirty = false;
    return _this;
  }
  SubmitActionBase.prototype.internalGetReferencedInputs = function () {
    var result = {};
    if (this.associatedInputs !== "none") {
      var current = this.parent;
      var inputs = [];
      while (current) {
        inputs.push.apply(inputs, current.getAllInputs(false));
        current = current.parent;
      }
      for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
        var input = inputs_1[_i];
        if (input.id) {
          result[input.id] = input;
        }
      }
    }
    return result;
  };
  SubmitActionBase.prototype.internalPrepareForExecution = function (inputs) {
    if (this._originalData) {
      this._processedData = JSON.parse(JSON.stringify(this._originalData));
    } else {
      this._processedData = {};
    }
    if (this._processedData && inputs) {
      for (var _i = 0, _a = Object.keys(inputs); _i < _a.length; _i++) {
        var key = _a[_i];
        var input = inputs[key];
        if (input.id && input.isSet()) {
          this._processedData[input.id] = typeof input.value === "string" ? input.value : input.value.toString();
        }
      }
    }
    this._isPrepared = true;
  };
  SubmitActionBase.prototype.internalAfterExecute = function () {
    if (shared_1.GlobalSettings.resetInputsDirtyStateAfterActionExecution) {
      this.resetReferencedInputsDirtyState();
    }
  };
  SubmitActionBase.prototype.resetReferencedInputsDirtyState = function () {
    var referencedInputs = this.getReferencedInputs();
    this._areReferencedInputsDirty = false;
    if (referencedInputs) {
      for (var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++) {
        var key = _a[_i];
        var input = referencedInputs[key];
        input.resetDirtyState();
      }
    }
  };
  SubmitActionBase.prototype.updateEnabledState = function () {
    this._areReferencedInputsDirty = false;
    var referencedInputs = this.getReferencedInputs();
    if (referencedInputs) {
      for (var _i = 0, _a = Object.keys(referencedInputs); _i < _a.length; _i++) {
        var key = _a[_i];
        var input = referencedInputs[key];
        if (input.isDirty()) {
          this._areReferencedInputsDirty = true;
          break;
        }
      }
    }
    this.updateCssClasses();
    if (this._renderedElement) {
      this.setupElementForAccessibility(this._renderedElement);
    }
  };
  SubmitActionBase.prototype.isEffectivelyEnabled = function () {
    var result = _super.prototype.isEffectivelyEnabled.call(this);
    return this.disabledUnlessAssociatedInputsChange ? result && this._areReferencedInputsDirty : result;
  };
  Object.defineProperty(SubmitActionBase.prototype, "data", {
    get: function () {
      return this._isPrepared ? this._processedData : this._originalData;
    },
    set: function (value) {
      this._originalData = value;
      this._isPrepared = false;
    },
    enumerable: false,
    configurable: true
  });
  SubmitActionBase.dataProperty = new serialization_1.PropertyDefinition(serialization_1.Versions.v1_0, "data");
  SubmitActionBase.associatedInputsProperty = new serialization_1.CustomProperty(serialization_1.Versions.v1_3, "associatedInputs", function (sender, prop, source, context) {
    var value = source[prop.name];
    if (value !== undefined && typeof value === "string") {
      return value.toLowerCase() === "none" ? "none" : "auto";
    }
    return undefined;
  }, function (sender, prop, target, value, context) {
    context.serializeValue(target, prop.name, value);
  });
  SubmitActionBase.disabledUnlessAssociatedInputsChangeProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_6, "disabledUnlessAssociatedInputsChange", false);
  __decorate([(0, serialization_1.property)(SubmitActionBase.dataProperty)], SubmitActionBase.prototype, "_originalData", void 0);
  __decorate([(0, serialization_1.property)(SubmitActionBase.associatedInputsProperty)], SubmitActionBase.prototype, "associatedInputs", void 0);
  __decorate([(0, serialization_1.property)(SubmitActionBase.disabledUnlessAssociatedInputsChangeProperty)], SubmitActionBase.prototype, "disabledUnlessAssociatedInputsChange", void 0);
  return SubmitActionBase;
}(Action);
exports.SubmitActionBase = SubmitActionBase;
var SubmitAction = /** @class */function (_super) {
  __extends(SubmitAction, _super);
  function SubmitAction() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SubmitAction.prototype.getJsonTypeName = function () {
    return SubmitAction.JsonTypeName;
  };
  // Note the "weird" way this field is declared is to work around a breaking
  // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
  SubmitAction.JsonTypeName = "Action.Submit";
  return SubmitAction;
}(SubmitActionBase);
exports.SubmitAction = SubmitAction;
var UniversalAction = /** @class */function (_super) {
  __extends(UniversalAction, _super);
  function UniversalAction() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return UniversalAction;
}(SubmitActionBase);
exports.UniversalAction = UniversalAction;
var ExecuteAction = /** @class */function (_super) {
  __extends(ExecuteAction, _super);
  function ExecuteAction() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  //#endregion
  ExecuteAction.prototype.getJsonTypeName = function () {
    return ExecuteAction.JsonTypeName;
  };
  // Note the "weird" way this field is declared is to work around a breaking
  // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
  ExecuteAction.JsonTypeName = "Action.Execute";
  //#region Schema
  ExecuteAction.verbProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_4, "verb");
  __decorate([(0, serialization_1.property)(ExecuteAction.verbProperty)], ExecuteAction.prototype, "verb", void 0);
  return ExecuteAction;
}(UniversalAction);
exports.ExecuteAction = ExecuteAction;
var DataQuery = /** @class */function (_super) {
  __extends(DataQuery, _super);
  function DataQuery() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  //#endregion
  DataQuery.prototype.getJsonTypeName = function () {
    return DataQuery.JsonTypeName;
  };
  Object.defineProperty(DataQuery.prototype, "isStandalone", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  // Note the "weird" way this field is declared is to work around a breaking
  // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
  DataQuery.JsonTypeName = "Data.Query";
  //#region Schema
  DataQuery.datasetProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_6, "dataset");
  DataQuery.filterProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_6, "filter");
  DataQuery.countProperty = new serialization_1.NumProperty(serialization_1.Versions.v1_6, "count");
  DataQuery.skipProperty = new serialization_1.NumProperty(serialization_1.Versions.v1_6, "skip");
  __decorate([(0, serialization_1.property)(DataQuery.datasetProperty)], DataQuery.prototype, "dataset", void 0);
  __decorate([(0, serialization_1.property)(DataQuery.filterProperty)], DataQuery.prototype, "filter", void 0);
  __decorate([(0, serialization_1.property)(DataQuery.countProperty)], DataQuery.prototype, "count", void 0);
  __decorate([(0, serialization_1.property)(DataQuery.skipProperty)], DataQuery.prototype, "skip", void 0);
  return DataQuery;
}(UniversalAction);
exports.DataQuery = DataQuery;
var OpenUrlAction = /** @class */function (_super) {
  __extends(OpenUrlAction, _super);
  function OpenUrlAction() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  OpenUrlAction.prototype.getJsonTypeName = function () {
    return OpenUrlAction.JsonTypeName;
  };
  OpenUrlAction.prototype.getAriaRole = function () {
    var ariaRole = this.getAriaRoleFromEnum();
    return ariaRole !== null && ariaRole !== void 0 ? ariaRole : "link";
  };
  OpenUrlAction.prototype.internalValidateProperties = function (context) {
    _super.prototype.internalValidateProperties.call(this, context);
    if (!this.url) {
      context.addFailure(this, Enums.ValidationEvent.PropertyCantBeNull, strings_1.Strings.errors.propertyMustBeSet("url"));
    }
  };
  OpenUrlAction.prototype.getHref = function () {
    return this.url;
  };
  //#region Schema
  OpenUrlAction.urlProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "url");
  //#endregion
  // Note the "weird" way this field is declared is to work around a breaking
  // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
  OpenUrlAction.JsonTypeName = "Action.OpenUrl";
  __decorate([(0, serialization_1.property)(OpenUrlAction.urlProperty)], OpenUrlAction.prototype, "url", void 0);
  return OpenUrlAction;
}(Action);
exports.OpenUrlAction = OpenUrlAction;
var ToggleVisibilityAction = /** @class */function (_super) {
  __extends(ToggleVisibilityAction, _super);
  function ToggleVisibilityAction() {
    //#region Schema
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.targetElements = {};
    return _this;
  }
  ToggleVisibilityAction.prototype.updateAriaControlsAttribute = function () {
    // apply aria labels to make it clear which elements this action will toggle
    if (this.targetElements) {
      var elementIds = Object.keys(this.targetElements);
      if (this._renderedElement) {
        if (elementIds.length > 0) {
          this._renderedElement.setAttribute("aria-controls", elementIds.join(" "));
        } else {
          this._renderedElement.removeAttribute("aria-controls");
        }
      }
    }
  };
  ToggleVisibilityAction.prototype.internalValidateProperties = function (context) {
    _super.prototype.internalValidateProperties.call(this, context);
    if (!this.targetElements) {
      context.addFailure(this, Enums.ValidationEvent.PropertyCantBeNull, strings_1.Strings.errors.propertyMustBeSet("targetElements"));
    }
  };
  ToggleVisibilityAction.prototype.getJsonTypeName = function () {
    return ToggleVisibilityAction.JsonTypeName;
  };
  ToggleVisibilityAction.prototype.render = function () {
    _super.prototype.render.call(this);
    this.updateAriaControlsAttribute();
  };
  ToggleVisibilityAction.prototype.execute = function () {
    _super.prototype.execute.call(this);
    if (this.parent) {
      for (var _i = 0, _a = Object.keys(this.targetElements); _i < _a.length; _i++) {
        var elementId = _a[_i];
        var targetElement = this.parent.getRootElement().getElementById(elementId);
        if (targetElement) {
          if (typeof this.targetElements[elementId] === "boolean") {
            targetElement.isVisible = this.targetElements[elementId];
          } else {
            targetElement.isVisible = !targetElement.isVisible;
          }
        }
      }
    }
  };
  ToggleVisibilityAction.prototype.addTargetElement = function (elementId, isVisible) {
    if (isVisible === void 0) {
      isVisible = undefined;
    }
    this.targetElements[elementId] = isVisible;
    this.updateAriaControlsAttribute();
  };
  ToggleVisibilityAction.prototype.removeTargetElement = function (elementId) {
    delete this.targetElements[elementId];
    this.updateAriaControlsAttribute();
  };
  ToggleVisibilityAction.targetElementsProperty = new serialization_1.CustomProperty(serialization_1.Versions.v1_2, "targetElements", function (sender, prop, source, context) {
    var result = {};
    if (Array.isArray(source[prop.name])) {
      for (var _i = 0, _a = source[prop.name]; _i < _a.length; _i++) {
        var item = _a[_i];
        if (typeof item === "string") {
          result[item] = undefined;
        } else if (typeof item === "object") {
          var elementId = item["elementId"];
          if (typeof elementId === "string") {
            result[elementId] = Utils.parseBool(item["isVisible"]);
          }
        }
      }
    }
    return result;
  }, function (sender, prop, target, value, context) {
    var targetElements = [];
    for (var _i = 0, _a = Object.keys(value); _i < _a.length; _i++) {
      var id = _a[_i];
      if (typeof value[id] === "boolean") {
        targetElements.push({
          elementId: id,
          isVisible: value[id]
        });
      } else {
        targetElements.push(id);
      }
    }
    context.serializeArray(target, prop.name, targetElements);
  }, {}, function (sender) {
    return {};
  });
  //#endregion
  // Note the "weird" way this field is declared is to work around a breaking
  // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
  ToggleVisibilityAction.JsonTypeName = "Action.ToggleVisibility";
  __decorate([(0, serialization_1.property)(ToggleVisibilityAction.targetElementsProperty)], ToggleVisibilityAction.prototype, "targetElements", void 0);
  return ToggleVisibilityAction;
}(Action);
exports.ToggleVisibilityAction = ToggleVisibilityAction;
var StringWithSubstitutionProperty = /** @class */function (_super) {
  __extends(StringWithSubstitutionProperty, _super);
  function StringWithSubstitutionProperty(targetVersion, name) {
    var _this = _super.call(this, targetVersion, name, undefined, function () {
      return new shared_1.StringWithSubstitutions();
    }) || this;
    _this.targetVersion = targetVersion;
    _this.name = name;
    return _this;
  }
  StringWithSubstitutionProperty.prototype.parse = function (sender, source, context) {
    var result = new shared_1.StringWithSubstitutions();
    result.set(Utils.parseString(source[this.name]));
    return result;
  };
  StringWithSubstitutionProperty.prototype.toJSON = function (sender, target, value, context) {
    context.serializeValue(target, this.name, value.getOriginal());
  };
  return StringWithSubstitutionProperty;
}(serialization_1.PropertyDefinition);
var HttpHeader = /** @class */function (_super) {
  __extends(HttpHeader, _super);
  //#endregion
  function HttpHeader(name, value) {
    if (name === void 0) {
      name = "";
    }
    if (value === void 0) {
      value = "";
    }
    var _this = _super.call(this) || this;
    _this.name = name;
    _this.value = value;
    return _this;
  }
  HttpHeader.prototype.getSchemaKey = function () {
    return "HttpHeader";
  };
  HttpHeader.prototype.getReferencedInputs = function (inputs, referencedInputs) {
    this._value.getReferencedInputs(inputs, referencedInputs);
  };
  HttpHeader.prototype.prepareForExecution = function (inputs) {
    this._value.substituteInputValues(inputs, shared_1.ContentTypes.applicationXWwwFormUrlencoded);
  };
  Object.defineProperty(HttpHeader.prototype, "value", {
    get: function () {
      return this._value.get();
    },
    set: function (newValue) {
      this._value.set(newValue);
    },
    enumerable: false,
    configurable: true
  });
  //#region Schema
  HttpHeader.nameProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "name");
  HttpHeader.valueProperty = new StringWithSubstitutionProperty(serialization_1.Versions.v1_0, "value");
  __decorate([(0, serialization_1.property)(HttpHeader.nameProperty)], HttpHeader.prototype, "name", void 0);
  __decorate([(0, serialization_1.property)(HttpHeader.valueProperty)], HttpHeader.prototype, "_value", void 0);
  return HttpHeader;
}(serialization_1.SerializableObject);
exports.HttpHeader = HttpHeader;
var HttpAction = /** @class */function (_super) {
  __extends(HttpAction, _super);
  function HttpAction() {
    //#region Schema
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._ignoreInputValidation = false;
    return _this;
  }
  HttpAction.prototype.internalGetReferencedInputs = function () {
    var allInputs = this.parent ? this.parent.getRootElement().getAllInputs() : [];
    var result = {};
    this._url.getReferencedInputs(allInputs, result);
    for (var _i = 0, _a = this.headers; _i < _a.length; _i++) {
      var header = _a[_i];
      header.getReferencedInputs(allInputs, result);
    }
    this._body.getReferencedInputs(allInputs, result);
    return result;
  };
  HttpAction.prototype.internalPrepareForExecution = function (inputs) {
    if (inputs) {
      this._url.substituteInputValues(inputs, shared_1.ContentTypes.applicationXWwwFormUrlencoded);
      var contentType = shared_1.ContentTypes.applicationJson;
      for (var _i = 0, _a = this.headers; _i < _a.length; _i++) {
        var header = _a[_i];
        header.prepareForExecution(inputs);
        if (header.name && header.name.toLowerCase() === "content-type") {
          contentType = header.value;
        }
      }
      this._body.substituteInputValues(inputs, contentType);
    }
  };
  HttpAction.prototype.getJsonTypeName = function () {
    return HttpAction.JsonTypeName;
  };
  HttpAction.prototype.internalValidateProperties = function (context) {
    _super.prototype.internalValidateProperties.call(this, context);
    if (!this.url) {
      context.addFailure(this, Enums.ValidationEvent.PropertyCantBeNull, strings_1.Strings.errors.propertyMustBeSet("url"));
    }
    if (this.headers.length > 0) {
      for (var _i = 0, _a = this.headers; _i < _a.length; _i++) {
        var header = _a[_i];
        if (!header.name) {
          context.addFailure(this, Enums.ValidationEvent.PropertyCantBeNull, strings_1.Strings.errors.actionHttpHeadersMustHaveNameAndValue());
        }
      }
    }
  };
  Object.defineProperty(HttpAction.prototype, "ignoreInputValidation", {
    get: function () {
      return this._ignoreInputValidation;
    },
    set: function (value) {
      this._ignoreInputValidation = value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(HttpAction.prototype, "url", {
    get: function () {
      return this._url.get();
    },
    set: function (value) {
      this._url.set(value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(HttpAction.prototype, "body", {
    get: function () {
      return this._body.get();
    },
    set: function (value) {
      this._body.set(value);
    },
    enumerable: false,
    configurable: true
  });
  HttpAction.urlProperty = new StringWithSubstitutionProperty(serialization_1.Versions.v1_0, "url");
  HttpAction.bodyProperty = new StringWithSubstitutionProperty(serialization_1.Versions.v1_0, "body");
  HttpAction.methodProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "method");
  HttpAction.headersProperty = new serialization_1.SerializableObjectCollectionProperty(serialization_1.Versions.v1_0, "headers", HttpHeader);
  HttpAction.ignoreInputValidationProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_3, "ignoreInputValidation", false);
  //#endregion
  // Note the "weird" way this field is declared is to work around a breaking
  // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
  HttpAction.JsonTypeName = "Action.Http";
  __decorate([(0, serialization_1.property)(HttpAction.urlProperty)], HttpAction.prototype, "_url", void 0);
  __decorate([(0, serialization_1.property)(HttpAction.bodyProperty)], HttpAction.prototype, "_body", void 0);
  __decorate([(0, serialization_1.property)(HttpAction.methodProperty)], HttpAction.prototype, "method", void 0);
  __decorate([(0, serialization_1.property)(HttpAction.headersProperty)], HttpAction.prototype, "headers", void 0);
  __decorate([(0, serialization_1.property)(HttpAction.ignoreInputValidationProperty)], HttpAction.prototype, "_ignoreInputValidation", void 0);
  return HttpAction;
}(Action);
exports.HttpAction = HttpAction;
var ShowCardAction = /** @class */function (_super) {
  __extends(ShowCardAction, _super);
  function ShowCardAction() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.card = new InlineAdaptiveCard();
    return _this;
  }
  ShowCardAction.prototype.updateCssClasses = function () {
    _super.prototype.updateCssClasses.call(this);
    if (this.renderedElement) {
      var effectiveHostConfig = this.parent ? this.parent.hostConfig : host_config_1.defaultHostConfig;
      this.renderedElement.classList.add(effectiveHostConfig.makeCssClassName("expandable"));
      this.renderedElement.setAttribute("aria-expanded", (this.state === 1 /* Expanded */).toString());
    }
  };
  ShowCardAction.prototype.internalParse = function (source, context) {
    _super.prototype.internalParse.call(this, source, context);
    var jsonCard = source["card"];
    if (jsonCard) {
      this.card.parse(jsonCard, context);
    } else {
      context.logParseEvent(this, Enums.ValidationEvent.PropertyCantBeNull, strings_1.Strings.errors.showCardMustHaveCard());
    }
  };
  ShowCardAction.prototype.internalToJSON = function (target, context) {
    _super.prototype.internalToJSON.call(this, target, context);
    if (this.card) {
      context.serializeValue(target, "card", this.card.toJSON(context));
    }
  };
  ShowCardAction.prototype.raiseExecuteActionEvent = function () {
    if (this.hostConfig.actions.showCard.actionMode === Enums.ShowCardActionMode.Popup) {
      // Only raise the event in Popup mode.
      _super.prototype.raiseExecuteActionEvent.call(this);
    }
  };
  ShowCardAction.prototype.releaseDOMResources = function () {
    _super.prototype.releaseDOMResources.call(this);
    this.card.releaseDOMResources();
  };
  ShowCardAction.prototype.getJsonTypeName = function () {
    return ShowCardAction.JsonTypeName;
  };
  ShowCardAction.prototype.internalValidateProperties = function (context) {
    _super.prototype.internalValidateProperties.call(this, context);
    this.card.internalValidateProperties(context);
  };
  ShowCardAction.prototype.setParent = function (value) {
    _super.prototype.setParent.call(this, value);
    this.card.setParent(value);
  };
  ShowCardAction.prototype.getAllInputs = function (processActions) {
    if (processActions === void 0) {
      processActions = true;
    }
    return this.card.getAllInputs(processActions);
  };
  ShowCardAction.prototype.getAllActions = function () {
    var result = _super.prototype.getAllActions.call(this);
    result.push.apply(result, this.card.getAllActions());
    return result;
  };
  ShowCardAction.prototype.getResourceInformation = function () {
    var result = _super.prototype.getResourceInformation.call(this);
    result.push.apply(result, this.card.getResourceInformation());
    return result;
  };
  ShowCardAction.prototype.getActionById = function (id) {
    var result = _super.prototype.getActionById.call(this, id);
    if (!result) {
      result = this.card.getActionById(id);
    }
    return result;
  };
  // Note the "weird" way this field is declared is to work around a breaking
  // change introduced in TS 3.1 wrt d.ts generation. DO NOT CHANGE
  ShowCardAction.JsonTypeName = "Action.ShowCard";
  return ShowCardAction;
}(Action);
exports.ShowCardAction = ShowCardAction;
var OverflowAction = /** @class */function (_super) {
  __extends(OverflowAction, _super);
  function OverflowAction(actions) {
    var _this = _super.call(this) || this;
    _this._actions = actions;
    _this.title = strings_1.Strings.defaults.overflowButtonText();
    _this.tooltip = strings_1.Strings.defaults.overflowButtonTooltip();
    return _this;
  }
  OverflowAction.prototype.getActions = function () {
    return this._actions;
  };
  OverflowAction.prototype.getAllActions = function () {
    var result = _super.prototype.getAllActions.call(this);
    result.push.apply(result, this._actions);
    return result;
  };
  OverflowAction.prototype.getJsonTypeName = function () {
    return ShowCardAction.JsonTypeName;
  };
  OverflowAction.prototype.execute = function () {
    var _this = this;
    var _a;
    var shouldDisplayPopupMenu = !raiseDisplayOverflowActionMenuEvent(this, this.renderedElement);
    if (shouldDisplayPopupMenu && this.renderedElement) {
      var contextMenu_1 = new controls_1.PopupMenu();
      contextMenu_1.hostConfig = this.hostConfig;
      var _loop_2 = function (i) {
        var menuItem = new controls_1.MenuItem(i.toString(), (_a = this_1._actions[i].title) !== null && _a !== void 0 ? _a : "");
        menuItem.isEnabled = this_1._actions[i].isEnabled;
        menuItem.onClick = function () {
          var actionToExecute = _this._actions[i];
          contextMenu_1.closePopup(false);
          if (actionToExecute.isEnabled) {
            actionToExecute.execute();
          }
        };
        contextMenu_1.items.add(menuItem);
      };
      var this_1 = this;
      for (var i = 0; i < this._actions.length; i++) {
        _loop_2(i);
      }
      contextMenu_1.onClose = function () {
        var _a, _b;
        (_a = _this.renderedElement) === null || _a === void 0 ? void 0 : _a.focus();
        (_b = _this.renderedElement) === null || _b === void 0 ? void 0 : _b.setAttribute("aria-expanded", "false");
      };
      this.renderedElement.setAttribute("aria-expanded", "true");
      contextMenu_1.popup(this.renderedElement);
      contextMenu_1.selectedIndex = 0;
    }
  };
  OverflowAction.prototype.setupElementForAccessibility = function (element, promoteTooltipToLabel) {
    if (promoteTooltipToLabel === void 0) {
      promoteTooltipToLabel = false;
    }
    _super.prototype.setupElementForAccessibility.call(this, element, promoteTooltipToLabel);
    element.setAttribute("aria-label", strings_1.Strings.defaults.overflowButtonTooltip());
    element.setAttribute("aria-expanded", "false");
  };
  OverflowAction.JsonTypeName = "Action.Overflow";
  return OverflowAction;
}(Action);
var ActionCollection = /** @class */function () {
  function ActionCollection(owner) {
    this._items = [];
    this._renderedActions = [];
    this._owner = owner;
  }
  ActionCollection.prototype.isActionAllowed = function (action) {
    var forbiddenTypes = this._owner.getForbiddenActionTypes();
    if (forbiddenTypes) {
      for (var _i = 0, forbiddenTypes_1 = forbiddenTypes; _i < forbiddenTypes_1.length; _i++) {
        var forbiddenType = forbiddenTypes_1[_i];
        if (action.constructor === forbiddenType) {
          return false;
        }
      }
    }
    return true;
  };
  ActionCollection.prototype.refreshContainer = function () {
    clearElement(this._actionCardContainer);
    if (!this._actionCard) {
      this._actionCardContainer.style.marginTop = "0px";
      return;
    }
    this._actionCardContainer.style.marginTop = this.renderedActionCount > 0 ? this._owner.hostConfig.actions.showCard.inlineTopMargin + "px" : "0px";
    var padding = this._owner.getEffectivePadding();
    this._owner.getImmediateSurroundingPadding(padding);
    var physicalPadding = this._owner.hostConfig.paddingDefinitionToSpacingDefinition(padding);
    if (this._actionCard) {
      this._actionCard.style.paddingLeft = physicalPadding.left + "px";
      this._actionCard.style.paddingRight = physicalPadding.right + "px";
      this._actionCard.style.marginLeft = "-" + physicalPadding.left + "px";
      this._actionCard.style.marginRight = "-" + physicalPadding.right + "px";
      if (physicalPadding.bottom !== 0 && !this._owner.isDesignMode()) {
        this._actionCard.style.paddingBottom = physicalPadding.bottom + "px";
        this._actionCard.style.marginBottom = "-" + physicalPadding.bottom + "px";
      }
      Utils.appendChild(this._actionCardContainer, this._actionCard);
    }
  };
  ActionCollection.prototype.layoutChanged = function () {
    this._owner.getRootElement().updateLayout();
  };
  ActionCollection.prototype.showActionCard = function (action, suppressStyle, raiseEvent) {
    if (suppressStyle === void 0) {
      suppressStyle = false;
    }
    if (raiseEvent === void 0) {
      raiseEvent = true;
    }
    action.card.suppressStyle = suppressStyle;
    // Always re-render a ShowCard action in design mode; reuse already rendered ShowCard (if available) otherwise
    var renderedCard = action.card.renderedElement && !this._owner.isDesignMode() ? action.card.renderedElement : action.card.render();
    this._actionCard = renderedCard;
    this._expandedAction = action;
    this.refreshContainer();
    if (raiseEvent) {
      this.layoutChanged();
      raiseInlineCardExpandedEvent(action, true);
    }
  };
  ActionCollection.prototype.collapseExpandedAction = function () {
    for (var _i = 0, _a = this._renderedActions; _i < _a.length; _i++) {
      var action = _a[_i];
      action.state = 0 /* Normal */;
    }
    var previouslyExpandedAction = this._expandedAction;
    this._expandedAction = undefined;
    this._actionCard = undefined;
    this.refreshContainer();
    if (previouslyExpandedAction) {
      this.layoutChanged();
      raiseInlineCardExpandedEvent(previouslyExpandedAction, false);
    }
  };
  ActionCollection.prototype.expandShowCardAction = function (action, raiseEvent) {
    var _this = this;
    var afterSelectedAction = false;
    for (var _i = 0, _a = this._renderedActions; _i < _a.length; _i++) {
      var renderedAction = _a[_i];
      // Remove actions after selected action from tabOrder if the actions are oriented horizontally, to skip focus directly to expanded card
      if (this._owner.hostConfig.actions.actionsOrientation == Enums.Orientation.Horizontal && afterSelectedAction) {
        renderedAction.isFocusable = false;
      }
      if (renderedAction !== action) {
        renderedAction.state = 2 /* Subdued */;
      } else {
        renderedAction.state = 1 /* Expanded */;
        afterSelectedAction = true;
        if (renderedAction.renderedElement) {
          renderedAction.renderedElement.onblur = function (_e) {
            for (var _i = 0, _a = _this._renderedActions; _i < _a.length; _i++) {
              var ra = _a[_i];
              ra.isFocusable = true;
            }
          };
        }
      }
    }
    this.showActionCard(action, !(this._owner.isAtTheVeryLeft() && this._owner.isAtTheVeryRight()), raiseEvent);
  };
  ActionCollection.prototype.releaseDOMResources = function () {
    for (var _i = 0, _a = this._renderedActions; _i < _a.length; _i++) {
      var action = _a[_i];
      action.releaseDOMResources();
    }
  };
  ActionCollection.prototype.actionExecuted = function (action) {
    if (!(action instanceof ShowCardAction)) {
      this.collapseExpandedAction();
    } else {
      if (action === this._expandedAction) {
        this.collapseExpandedAction();
      } else if (this._owner.hostConfig.actions.showCard.actionMode === Enums.ShowCardActionMode.Inline) {
        this.expandShowCardAction(action, true);
      }
    }
  };
  ActionCollection.prototype.parse = function (source, context) {
    this.clear();
    if (Array.isArray(source)) {
      for (var _i = 0, source_1 = source; _i < source_1.length; _i++) {
        var jsonAction = source_1[_i];
        var forbiddenActions = [];
        // If the action owner is a ContainerWithActions, we should check for forbidden actions
        if (this._owner instanceof ContainerWithActions) {
          forbiddenActions = this._owner.getForbiddenActionNames();
        }
        var action = context.parseAction(this._owner, jsonAction, forbiddenActions, !this._owner.isDesignMode());
        if (action) {
          this.addAction(action);
        }
      }
    }
  };
  ActionCollection.prototype.toJSON = function (target, propertyName, context) {
    context.serializeArray(target, propertyName, this._items);
  };
  ActionCollection.prototype.getActionAt = function (id) {
    return this._items[id];
  };
  ActionCollection.prototype.getActionCount = function () {
    return this._items.length;
  };
  ActionCollection.prototype.getActionById = function (id) {
    var result = undefined;
    for (var _i = 0, _a = this._items; _i < _a.length; _i++) {
      var item = _a[_i];
      result = item.getActionById(id);
      if (result) {
        break;
      }
    }
    return result;
  };
  ActionCollection.prototype.validateProperties = function (context) {
    if (this._owner.hostConfig.actions.maxActions && this._items.length > this._owner.hostConfig.actions.maxActions) {
      context.addFailure(this._owner, Enums.ValidationEvent.TooManyActions, strings_1.Strings.errors.tooManyActions(this._owner.hostConfig.actions.maxActions));
    }
    if (this._items.length > 0 && !this._owner.hostConfig.supportsInteractivity) {
      context.addFailure(this._owner, Enums.ValidationEvent.InteractivityNotAllowed, strings_1.Strings.errors.interactivityNotAllowed());
    }
    for (var _i = 0, _a = this._items; _i < _a.length; _i++) {
      var item = _a[_i];
      if (!this.isActionAllowed(item)) {
        context.addFailure(this._owner, Enums.ValidationEvent.ActionTypeNotAllowed, strings_1.Strings.errors.actionTypeNotAllowed(item.getJsonTypeName()));
      }
      item.internalValidateProperties(context);
    }
  };
  ActionCollection.prototype.render = function (orientation) {
    // Cache hostConfig for better perf
    var hostConfig = this._owner.hostConfig;
    if (!hostConfig.supportsInteractivity) {
      return undefined;
    }
    var element = document.createElement("div");
    var maxActions = hostConfig.actions.maxActions ? Math.min(hostConfig.actions.maxActions, this._items.length) : this._items.length;
    this._actionCardContainer = document.createElement("div");
    this._renderedActions = [];
    if (hostConfig.actions.preExpandSingleShowCardAction && maxActions === 1 && this._items[0] instanceof ShowCardAction && this.isActionAllowed(this._items[0])) {
      this.showActionCard(this._items[0], true);
      this._renderedActions.push(this._items[0]);
    } else {
      var buttonStrip = document.createElement("div");
      buttonStrip.className = hostConfig.makeCssClassName("ac-actionSet");
      buttonStrip.style.display = "flex";
      if (orientation === Enums.Orientation.Horizontal) {
        buttonStrip.style.flexDirection = "row";
        if (this._owner.horizontalAlignment && hostConfig.actions.actionAlignment !== Enums.ActionAlignment.Stretch) {
          switch (this._owner.horizontalAlignment) {
            case Enums.HorizontalAlignment.Center:
              buttonStrip.style.justifyContent = "center";
              break;
            case Enums.HorizontalAlignment.Right:
              buttonStrip.style.justifyContent = "flex-end";
              break;
            default:
              buttonStrip.style.justifyContent = "flex-start";
              break;
          }
        } else {
          switch (hostConfig.actions.actionAlignment) {
            case Enums.ActionAlignment.Center:
              buttonStrip.style.justifyContent = "center";
              break;
            case Enums.ActionAlignment.Right:
              buttonStrip.style.justifyContent = "flex-end";
              break;
            default:
              buttonStrip.style.justifyContent = "flex-start";
              break;
          }
        }
      } else {
        buttonStrip.style.flexDirection = "column";
        if (this._owner.horizontalAlignment && hostConfig.actions.actionAlignment !== Enums.ActionAlignment.Stretch) {
          switch (this._owner.horizontalAlignment) {
            case Enums.HorizontalAlignment.Center:
              buttonStrip.style.alignItems = "center";
              break;
            case Enums.HorizontalAlignment.Right:
              buttonStrip.style.alignItems = "flex-end";
              break;
            default:
              buttonStrip.style.alignItems = "flex-start";
              break;
          }
        } else {
          switch (hostConfig.actions.actionAlignment) {
            case Enums.ActionAlignment.Center:
              buttonStrip.style.alignItems = "center";
              break;
            case Enums.ActionAlignment.Right:
              buttonStrip.style.alignItems = "flex-end";
              break;
            case Enums.ActionAlignment.Stretch:
              buttonStrip.style.alignItems = "stretch";
              break;
            default:
              buttonStrip.style.alignItems = "flex-start";
              break;
          }
        }
      }
      var allowedActions = this._items.filter(this.isActionAllowed.bind(this));
      var primaryActions_1 = [];
      var secondaryActions_1 = [];
      if (!this._owner.isDesignMode()) {
        allowedActions.forEach(function (action) {
          return action.mode === Enums.ActionMode.Secondary ? secondaryActions_1.push(action) : primaryActions_1.push(action);
        });
        // If primaryActions.length > maxActions, extra actions are moved to overflow
        var overflowPrimaryActions = primaryActions_1.splice(hostConfig.actions.maxActions);
        if (shared_1.GlobalSettings.allowMoreThanMaxActionsInOverflowMenu) {
          secondaryActions_1.push.apply(secondaryActions_1, overflowPrimaryActions);
        }
        var shouldRenderOverflowActionButton = true;
        if (secondaryActions_1.length > 0) {
          if (!this._overflowAction) {
            this._overflowAction = new OverflowAction(secondaryActions_1);
            this._overflowAction.setParent(this._owner);
            this._overflowAction["_actionCollection"] = this;
          }
          var isRootAction = this._owner instanceof AdaptiveCard && !this._owner.parent;
          shouldRenderOverflowActionButton = !raiseRenderOverflowActionsEvent(this._overflowAction, isRootAction);
        }
        if (this._overflowAction && shouldRenderOverflowActionButton) {
          primaryActions_1.push(this._overflowAction);
        }
      } else {
        primaryActions_1 = allowedActions;
      }
      for (var i = 0; i < primaryActions_1.length; i++) {
        var action = primaryActions_1[i];
        action.render();
        if (action.renderedElement) {
          if (hostConfig.actions.actionsOrientation === Enums.Orientation.Horizontal && hostConfig.actions.actionAlignment === Enums.ActionAlignment.Stretch) {
            action.renderedElement.style.flex = "0 1 100%";
          } else {
            action.renderedElement.style.flex = "0 1 auto";
          }
          buttonStrip.appendChild(action.renderedElement);
          this._renderedActions.push(action);
          if (i < primaryActions_1.length - 1 && hostConfig.actions.buttonSpacing > 0) {
            var spacer = document.createElement("div");
            if (orientation === Enums.Orientation.Horizontal) {
              spacer.style.flex = "0 0 auto";
              spacer.style.width = hostConfig.actions.buttonSpacing + "px";
            } else {
              spacer.style.height = hostConfig.actions.buttonSpacing + "px";
            }
            Utils.appendChild(buttonStrip, spacer);
          }
        }
      }
      var buttonStripContainer = document.createElement("div");
      buttonStripContainer.style.overflow = "hidden";
      buttonStripContainer.appendChild(buttonStrip);
      Utils.appendChild(element, buttonStripContainer);
    }
    Utils.appendChild(element, this._actionCardContainer);
    for (var _i = 0, _a = this._renderedActions; _i < _a.length; _i++) {
      var renderedAction = _a[_i];
      if (renderedAction.state === 1 /* Expanded */) {
        this.expandShowCardAction(renderedAction, false);
        break;
      }
    }
    return this._renderedActions.length > 0 ? element : undefined;
  };
  ActionCollection.prototype.addAction = function (action) {
    if (!action) {
      throw new Error("The action parameter cannot be null.");
    }
    if ((!action.parent || action.parent === this._owner) && this._items.indexOf(action) < 0) {
      this._items.push(action);
      if (!action.parent) {
        action.setParent(this._owner);
      }
      action["_actionCollection"] = this;
    } else {
      throw new Error(strings_1.Strings.errors.actionAlreadyParented());
    }
  };
  ActionCollection.prototype.removeAction = function (action) {
    if (this.expandedAction && this._expandedAction === action) {
      this.collapseExpandedAction();
    }
    var actionIndex = this._items.indexOf(action);
    if (actionIndex >= 0) {
      this._items.splice(actionIndex, 1);
      action.setParent(undefined);
      action["_actionCollection"] = undefined;
      for (var i = 0; i < this._renderedActions.length; i++) {
        if (this._renderedActions[i] === action) {
          this._renderedActions.splice(i, 1);
          break;
        }
      }
      return true;
    }
    return false;
  };
  ActionCollection.prototype.clear = function () {
    this._items = [];
    this._renderedActions = [];
    this._expandedAction = undefined;
  };
  ActionCollection.prototype.getAllInputs = function (processActions) {
    if (processActions === void 0) {
      processActions = true;
    }
    var result = [];
    if (processActions) {
      for (var _i = 0, _a = this._items; _i < _a.length; _i++) {
        var action = _a[_i];
        result.push.apply(result, action.getAllInputs());
      }
    }
    return result;
  };
  ActionCollection.prototype.getResourceInformation = function () {
    var result = [];
    for (var _i = 0, _a = this._items; _i < _a.length; _i++) {
      var action = _a[_i];
      result.push.apply(result, action.getResourceInformation());
    }
    return result;
  };
  Object.defineProperty(ActionCollection.prototype, "renderedActionCount", {
    get: function () {
      return this._renderedActions.length;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ActionCollection.prototype, "expandedAction", {
    get: function () {
      return this._expandedAction;
    },
    enumerable: false,
    configurable: true
  });
  return ActionCollection;
}();
var ActionSet = /** @class */function (_super) {
  __extends(ActionSet, _super);
  function ActionSet() {
    var _this = _super.call(this) || this;
    _this._actionCollection = new ActionCollection(_this);
    return _this;
  }
  ActionSet.prototype.internalParse = function (source, context) {
    _super.prototype.internalParse.call(this, source, context);
    this._actionCollection.parse(source["actions"], context);
  };
  ActionSet.prototype.internalToJSON = function (target, context) {
    _super.prototype.internalToJSON.call(this, target, context);
    this._actionCollection.toJSON(target, "actions", context);
  };
  ActionSet.prototype.internalRender = function () {
    return this._actionCollection.render(this.orientation !== undefined ? this.orientation : this.hostConfig.actions.actionsOrientation);
  };
  ActionSet.prototype.releaseDOMResources = function () {
    _super.prototype.releaseDOMResources.call(this);
    this._actionCollection.releaseDOMResources();
  };
  ActionSet.prototype.isBleedingAtBottom = function () {
    if (this._actionCollection.renderedActionCount === 0) {
      return _super.prototype.isBleedingAtBottom.call(this);
    } else {
      if (this._actionCollection.getActionCount() === 1) {
        return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
      } else {
        return this._actionCollection.expandedAction !== undefined;
      }
    }
  };
  ActionSet.prototype.getJsonTypeName = function () {
    return "ActionSet";
  };
  ActionSet.prototype.getActionCount = function () {
    return this._actionCollection.getActionCount();
  };
  ActionSet.prototype.getActionAt = function (index) {
    if (index >= 0 && index < this.getActionCount()) {
      return this._actionCollection.getActionAt(index);
    } else {
      return _super.prototype.getActionAt.call(this, index);
    }
  };
  ActionSet.prototype.getActionById = function (id) {
    var result = this._actionCollection.getActionById(id);
    return result ? result : _super.prototype.getActionById.call(this, id);
  };
  ActionSet.prototype.getAllActions = function () {
    var result = _super.prototype.getAllActions.call(this);
    for (var i = 0; i < this.getActionCount(); i++) {
      var action = this.getActionAt(i);
      if (action) {
        result.push(action);
      }
    }
    return result;
  };
  ActionSet.prototype.internalValidateProperties = function (context) {
    _super.prototype.internalValidateProperties.call(this, context);
    this._actionCollection.validateProperties(context);
  };
  ActionSet.prototype.addAction = function (action) {
    this._actionCollection.addAction(action);
  };
  ActionSet.prototype.getAllInputs = function (processActions) {
    if (processActions === void 0) {
      processActions = true;
    }
    return processActions ? this._actionCollection.getAllInputs() : [];
  };
  ActionSet.prototype.getResourceInformation = function () {
    return this._actionCollection.getResourceInformation();
  };
  /**
   * @inheritdoc
   */
  ActionSet.prototype.findDOMNodeOwner = function (node) {
    var target = undefined;
    for (var i = 0; i < this.getActionCount(); i++) {
      var action = this.getActionAt(i);
      if (action) {
        // recur through each Action
        target = action.findDOMNodeOwner(node);
        if (target) {
          return target;
        }
      }
    }
    // if not found in any Action, defer to parent implementation
    return _super.prototype.findDOMNodeOwner.call(this, node);
  };
  ActionSet.prototype.getElementById = function (id) {
    var result = _super.prototype.getElementById.call(this, id);
    if (!result) {
      result = this.getElementByIdFromAction(id);
    }
    return result;
  };
  Object.defineProperty(ActionSet.prototype, "isInteractive", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  //#region Schema
  ActionSet.orientationProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_1, "orientation", Enums.Orientation);
  __decorate([(0, serialization_1.property)(ActionSet.orientationProperty)], ActionSet.prototype, "orientation", void 0);
  return ActionSet;
}(CardElement);
exports.ActionSet = ActionSet;
var ContainerStyleProperty = /** @class */function (_super) {
  __extends(ContainerStyleProperty, _super);
  function ContainerStyleProperty(targetVersion, name, defaultValue, onGetInitialValue) {
    var _this = _super.call(this, targetVersion, name, [{
      value: Enums.ContainerStyle.Default
    }, {
      value: Enums.ContainerStyle.Emphasis
    }, {
      targetVersion: serialization_1.Versions.v1_2,
      value: Enums.ContainerStyle.Accent
    }, {
      targetVersion: serialization_1.Versions.v1_2,
      value: Enums.ContainerStyle.Good
    }, {
      targetVersion: serialization_1.Versions.v1_2,
      value: Enums.ContainerStyle.Attention
    }, {
      targetVersion: serialization_1.Versions.v1_2,
      value: Enums.ContainerStyle.Warning
    }], defaultValue, onGetInitialValue) || this;
    _this.targetVersion = targetVersion;
    _this.name = name;
    _this.defaultValue = defaultValue;
    _this.onGetInitialValue = onGetInitialValue;
    return _this;
  }
  return ContainerStyleProperty;
}(serialization_1.ValueSetProperty);
exports.ContainerStyleProperty = ContainerStyleProperty;
var StylableCardElementContainer = /** @class */function (_super) {
  __extends(StylableCardElementContainer, _super);
  function StylableCardElementContainer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(StylableCardElementContainer.prototype, "style", {
    get: function () {
      if (this.allowCustomStyle) {
        var style = this.getValue(StylableCardElementContainer.styleProperty);
        if (style && this.hostConfig.containerStyles.getStyleByName(style)) {
          return style;
        }
      }
      return undefined;
    },
    set: function (value) {
      this.setValue(StylableCardElementContainer.styleProperty, value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StylableCardElementContainer.prototype, "allowCustomStyle", {
    //#endregion
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StylableCardElementContainer.prototype, "hasExplicitStyle", {
    get: function () {
      return this.getValue(StylableCardElementContainer.styleProperty) !== undefined;
    },
    enumerable: false,
    configurable: true
  });
  StylableCardElementContainer.prototype.applyBorder = function () {
    // No border in base implementation
  };
  StylableCardElementContainer.prototype.applyBackground = function () {
    if (this.renderedElement) {
      var styleDefinition = this.hostConfig.containerStyles.getStyleByName(this.style, this.hostConfig.containerStyles.getStyleByName(this.defaultStyle));
      if (styleDefinition.backgroundColor) {
        var bgColor = Utils.stringToCssColor(styleDefinition.backgroundColor);
        if (bgColor) {
          this.renderedElement.style.backgroundColor = bgColor;
        }
      }
    }
  };
  StylableCardElementContainer.prototype.applyPadding = function () {
    _super.prototype.applyPadding.call(this);
    if (!this.renderedElement) {
      return;
    }
    var physicalPadding = new shared_1.SpacingDefinition();
    if (this.getEffectivePadding()) {
      physicalPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(this.getEffectivePadding());
    }
    this.renderedElement.style.paddingTop = physicalPadding.top + "px";
    this.renderedElement.style.paddingRight = physicalPadding.right + "px";
    this.renderedElement.style.paddingBottom = physicalPadding.bottom + "px";
    this.renderedElement.style.paddingLeft = physicalPadding.left + "px";
    if (this.isBleeding()) {
      // Bleed into the first parent that does have padding
      var padding = new shared_1.PaddingDefinition();
      this.getImmediateSurroundingPadding(padding);
      var surroundingPadding = this.hostConfig.paddingDefinitionToSpacingDefinition(padding);
      this.renderedElement.style.marginRight = "-" + surroundingPadding.right + "px";
      this.renderedElement.style.marginLeft = "-" + surroundingPadding.left + "px";
      if (!this.isDesignMode()) {
        this.renderedElement.style.marginTop = "-" + surroundingPadding.top + "px";
        this.renderedElement.style.marginBottom = "-" + surroundingPadding.bottom + "px";
      }
      if (this.separatorElement && this.separatorOrientation === Enums.Orientation.Horizontal) {
        this.separatorElement.style.marginLeft = "-" + surroundingPadding.left + "px";
        this.separatorElement.style.marginRight = "-" + surroundingPadding.right + "px";
      }
    } else {
      this.renderedElement.style.marginRight = "0";
      this.renderedElement.style.marginLeft = "0";
      this.renderedElement.style.marginTop = "0";
      this.renderedElement.style.marginBottom = "0";
      if (this.separatorElement && this.separatorOrientation === Enums.Orientation.Horizontal) {
        this.separatorElement.style.marginRight = "0";
        this.separatorElement.style.marginLeft = "0";
      }
    }
  };
  StylableCardElementContainer.prototype.getHasBackground = function (ignoreBackgroundImages) {
    if (ignoreBackgroundImages === void 0) {
      ignoreBackgroundImages = false;
    }
    var currentElement = this.parent;
    while (currentElement) {
      var currentElementHasBackgroundImage = false;
      if (ignoreBackgroundImages) {
        currentElementHasBackgroundImage = false;
      } else {
        currentElementHasBackgroundImage = currentElement instanceof Container ? currentElement.backgroundImage.isValid() : false;
      }
      if (currentElement instanceof StylableCardElementContainer) {
        if (this.hasExplicitStyle && (currentElement.getEffectiveStyle() !== this.getEffectiveStyle() || currentElementHasBackgroundImage)) {
          return true;
        }
      }
      currentElement = currentElement.parent;
    }
    return false;
  };
  StylableCardElementContainer.prototype.getDefaultPadding = function () {
    return this.getHasBackground() || this.getHasBorder() ? new shared_1.PaddingDefinition(Enums.Spacing.Padding, Enums.Spacing.Padding, Enums.Spacing.Padding, Enums.Spacing.Padding) : _super.prototype.getDefaultPadding.call(this);
  };
  StylableCardElementContainer.prototype.internalValidateProperties = function (context) {
    _super.prototype.internalValidateProperties.call(this, context);
    var explicitStyle = this.getValue(StylableCardElementContainer.styleProperty);
    if (explicitStyle !== undefined) {
      var styleDefinition = this.hostConfig.containerStyles.getStyleByName(explicitStyle);
      if (!styleDefinition) {
        context.addFailure(this, Enums.ValidationEvent.InvalidPropertyValue, strings_1.Strings.errors.invalidPropertyValue(explicitStyle, "style"));
      }
    }
  };
  StylableCardElementContainer.prototype.render = function () {
    var renderedElement = _super.prototype.render.call(this);
    if (renderedElement && this.getHasBackground()) {
      this.applyBackground();
    }
    this.applyBorder();
    return renderedElement;
  };
  StylableCardElementContainer.prototype.getEffectiveStyle = function () {
    var effectiveStyle = this.style;
    return effectiveStyle ? effectiveStyle : _super.prototype.getEffectiveStyle.call(this);
  };
  //#region Schema
  StylableCardElementContainer.styleProperty = new ContainerStyleProperty(serialization_1.Versions.v1_0, "style");
  __decorate([(0, serialization_1.property)(StylableCardElementContainer.styleProperty)], StylableCardElementContainer.prototype, "style", null);
  return StylableCardElementContainer;
}(CardElementContainer);
exports.StylableCardElementContainer = StylableCardElementContainer;
var ContainerBase = /** @class */function (_super) {
  __extends(ContainerBase, _super);
  function ContainerBase() {
    //#region Schema
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._bleed = false;
    return _this;
  }
  //#endregion
  ContainerBase.prototype.adjustRenderedElementSize = function (renderedElement) {
    _super.prototype.adjustRenderedElementSize.call(this, renderedElement);
    if (this.minPixelHeight) {
      renderedElement.style.minHeight = this.minPixelHeight + "px";
    }
  };
  ContainerBase.prototype.getHasExpandedAction = function () {
    return false;
  };
  ContainerBase.prototype.getBleed = function () {
    return this._bleed;
  };
  ContainerBase.prototype.setBleed = function (value) {
    this._bleed = value;
  };
  Object.defineProperty(ContainerBase.prototype, "renderedActionCount", {
    get: function () {
      return 0;
    },
    enumerable: false,
    configurable: true
  });
  ContainerBase.prototype.isBleeding = function () {
    return (this.getHasBackground() || this.hostConfig.alwaysAllowBleed) && this.getBleed();
  };
  ContainerBase.bleedProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_2, "bleed", false);
  ContainerBase.minHeightProperty = new serialization_1.PixelSizeProperty(serialization_1.Versions.v1_2, "minHeight");
  __decorate([(0, serialization_1.property)(ContainerBase.bleedProperty)], ContainerBase.prototype, "_bleed", void 0);
  __decorate([(0, serialization_1.property)(ContainerBase.minHeightProperty)], ContainerBase.prototype, "minPixelHeight", void 0);
  return ContainerBase;
}(StylableCardElementContainer);
exports.ContainerBase = ContainerBase;
var BackgroundImage = /** @class */function (_super) {
  __extends(BackgroundImage, _super);
  function BackgroundImage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  //#endregion
  BackgroundImage.prototype.getSchemaKey = function () {
    return "BackgroundImage";
  };
  BackgroundImage.prototype.internalParse = function (source, context) {
    if (typeof source === "string") {
      this.resetDefaultValues();
      this.url = source;
    } else {
      return _super.prototype.internalParse.call(this, source, context);
    }
  };
  BackgroundImage.prototype.apply = function (element) {
    if (this.url && element.renderedElement) {
      element.renderedElement.style.backgroundImage = "url('" + element.preProcessPropertyValue(BackgroundImage.urlProperty, this.url) + "')";
      switch (this.fillMode) {
        case Enums.FillMode.Repeat:
          element.renderedElement.style.backgroundRepeat = "repeat";
          break;
        case Enums.FillMode.RepeatHorizontally:
          element.renderedElement.style.backgroundRepeat = "repeat-x";
          break;
        case Enums.FillMode.RepeatVertically:
          element.renderedElement.style.backgroundRepeat = "repeat-y";
          break;
        case Enums.FillMode.Cover:
        default:
          element.renderedElement.style.backgroundRepeat = "no-repeat";
          element.renderedElement.style.backgroundSize = "cover";
          break;
      }
      switch (this.horizontalAlignment) {
        case Enums.HorizontalAlignment.Left:
          break;
        case Enums.HorizontalAlignment.Center:
          element.renderedElement.style.backgroundPositionX = "center";
          break;
        case Enums.HorizontalAlignment.Right:
          element.renderedElement.style.backgroundPositionX = "right";
          break;
      }
      switch (this.verticalAlignment) {
        case Enums.VerticalAlignment.Top:
          break;
        case Enums.VerticalAlignment.Center:
          element.renderedElement.style.backgroundPositionY = "center";
          break;
        case Enums.VerticalAlignment.Bottom:
          element.renderedElement.style.backgroundPositionY = "bottom";
          break;
      }
    }
  };
  BackgroundImage.prototype.isValid = function () {
    return this.url ? true : false;
  };
  //#region Schema
  BackgroundImage.urlProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "url");
  BackgroundImage.fillModeProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_2, "fillMode", Enums.FillMode, Enums.FillMode.Cover);
  BackgroundImage.horizontalAlignmentProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_2, "horizontalAlignment", Enums.HorizontalAlignment, Enums.HorizontalAlignment.Left);
  BackgroundImage.verticalAlignmentProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_2, "verticalAlignment", Enums.VerticalAlignment, Enums.VerticalAlignment.Top);
  __decorate([(0, serialization_1.property)(BackgroundImage.urlProperty)], BackgroundImage.prototype, "url", void 0);
  __decorate([(0, serialization_1.property)(BackgroundImage.fillModeProperty)], BackgroundImage.prototype, "fillMode", void 0);
  __decorate([(0, serialization_1.property)(BackgroundImage.horizontalAlignmentProperty)], BackgroundImage.prototype, "horizontalAlignment", void 0);
  __decorate([(0, serialization_1.property)(BackgroundImage.verticalAlignmentProperty)], BackgroundImage.prototype, "verticalAlignment", void 0);
  return BackgroundImage;
}(serialization_1.SerializableObject);
exports.BackgroundImage = BackgroundImage;
var Container = /** @class */function (_super) {
  __extends(Container, _super);
  function Container() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    //#endregion
    _this._items = [];
    _this._renderedItems = [];
    return _this;
  }
  Object.defineProperty(Container.prototype, "backgroundImage", {
    get: function () {
      return this.getValue(Container.backgroundImageProperty);
    },
    enumerable: false,
    configurable: true
  });
  Container.prototype.insertItemAt = function (item, index, forceInsert) {
    if (!item.parent || forceInsert) {
      if (item.isStandalone) {
        if (index < 0 || index >= this._items.length) {
          this._items.push(item);
        } else {
          this._items.splice(index, 0, item);
        }
        item.setParent(this);
      } else {
        throw new Error(strings_1.Strings.errors.elementTypeNotStandalone(item.getJsonTypeName()));
      }
    } else {
      throw new Error(strings_1.Strings.errors.elementAlreadyParented());
    }
  };
  Container.prototype.getItemsCollectionPropertyName = function () {
    return "items";
  };
  Container.prototype.applyBackground = function () {
    if (this.backgroundImage.isValid() && this.renderedElement) {
      this.backgroundImage.apply(this);
    }
    _super.prototype.applyBackground.call(this);
  };
  Container.prototype.applyRTL = function (element) {
    if (this.rtl !== undefined) {
      element.dir = this.rtl ? "rtl" : "ltr";
    }
  };
  Container.prototype.internalRender = function () {
    this._renderedItems = [];
    // Cache hostConfig to avoid walking the parent hierarchy several times
    var hostConfig = this.hostConfig;
    var element = document.createElement("div");
    this.applyRTL(element);
    element.classList.add(hostConfig.makeCssClassName("ac-container"));
    element.style.display = "flex";
    element.style.flexDirection = "column";
    if (shared_1.GlobalSettings.useAdvancedCardBottomTruncation) {
      // Forces the container to be at least as tall as its content.
      //
      // Fixes a quirk in Chrome where, for nested flex elements, the
      // inner element's height would never exceed the outer element's
      // height. This caused overflow truncation to break -- containers
      // would always be measured as not overflowing, since their heights
      // were constrained by their parents as opposed to truly reflecting
      // the height of their content.
      //
      // See the "Browser Rendering Notes" section of this answer:
      // https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
      element.style.minHeight = "-webkit-min-content";
    }
    switch (this.getEffectiveVerticalContentAlignment()) {
      case Enums.VerticalAlignment.Center:
        element.style.justifyContent = "center";
        break;
      case Enums.VerticalAlignment.Bottom:
        element.style.justifyContent = "flex-end";
        break;
      default:
        element.style.justifyContent = "flex-start";
        break;
    }
    if (this._items.length > 0) {
      for (var _i = 0, _a = this._items; _i < _a.length; _i++) {
        var item = _a[_i];
        var renderedItem = this.isElementAllowed(item) ? item.render() : undefined;
        if (renderedItem) {
          if (this._renderedItems.length > 0 && item.separatorElement) {
            item.separatorElement.style.flex = "0 0 auto";
            Utils.appendChild(element, item.separatorElement);
          }
          Utils.appendChild(element, renderedItem);
          this._renderedItems.push(item);
        }
      }
    } else {
      if (this.isDesignMode()) {
        var placeholderElement = this.createPlaceholderElement();
        placeholderElement.style.width = "100%";
        placeholderElement.style.height = "100%";
        element.appendChild(placeholderElement);
      }
    }
    return element;
  };
  Container.prototype.truncateOverflow = function (maxHeight) {
    if (this.renderedElement) {
      // Add 1 to account for rounding differences between browsers
      var boundary_1 = this.renderedElement.offsetTop + maxHeight + 1;
      var handleElement_1 = function (cardElement) {
        var elt = cardElement.renderedElement;
        if (elt) {
          switch (Utils.getFitStatus(elt, boundary_1)) {
            case Enums.ContainerFitStatus.FullyInContainer:
              var sizeChanged = cardElement["resetOverflow"]();
              // If the element's size changed after resetting content,
              // we have to check if it still fits fully in the card
              if (sizeChanged) {
                handleElement_1(cardElement);
              }
              break;
            case Enums.ContainerFitStatus.Overflowing:
              var containerMaxHeight = boundary_1 - elt.offsetTop;
              cardElement["handleOverflow"](containerMaxHeight);
              break;
            case Enums.ContainerFitStatus.FullyOutOfContainer:
              cardElement["handleOverflow"](0);
              break;
          }
        }
      };
      for (var _i = 0, _a = this._items; _i < _a.length; _i++) {
        var item = _a[_i];
        handleElement_1(item);
      }
      return true;
    }
    return false;
  };
  Container.prototype.undoOverflowTruncation = function () {
    for (var _i = 0, _a = this._items; _i < _a.length; _i++) {
      var item = _a[_i];
      item["resetOverflow"]();
    }
  };
  Container.prototype.getHasBackground = function (ignoreBackgroundImages) {
    if (ignoreBackgroundImages === void 0) {
      ignoreBackgroundImages = false;
    }
    var result = ignoreBackgroundImages ? false : this.backgroundImage.isValid();
    return result || _super.prototype.getHasBackground.call(this, ignoreBackgroundImages);
  };
  Container.prototype.internalParse = function (source, context) {
    _super.prototype.internalParse.call(this, source, context);
    this.clear();
    this.setShouldFallback(false);
    var jsonItems = source[this.getItemsCollectionPropertyName()];
    if (Array.isArray(jsonItems)) {
      for (var _i = 0, jsonItems_1 = jsonItems; _i < jsonItems_1.length; _i++) {
        var item = jsonItems_1[_i];
        var element = context.parseElement(this, item, this.forbiddenChildElements(), !this.isDesignMode());
        if (element) {
          this.insertItemAt(element, -1, true);
        }
      }
    }
  };
  Container.prototype.internalToJSON = function (target, context) {
    _super.prototype.internalToJSON.call(this, target, context);
    var collectionPropertyName = this.getItemsCollectionPropertyName();
    context.serializeArray(target, collectionPropertyName, this._items);
  };
  Object.defineProperty(Container.prototype, "isSelectable", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  Container.prototype.getEffectivePadding = function () {
    if (shared_1.GlobalSettings.removePaddingFromContainersWithBackgroundImage && !this.getHasBackground(true)) {
      return new shared_1.PaddingDefinition();
    }
    return _super.prototype.getEffectivePadding.call(this);
  };
  Container.prototype.getEffectiveVerticalContentAlignment = function () {
    if (this.verticalContentAlignment !== undefined) {
      return this.verticalContentAlignment;
    }
    var parentContainer = this.getParentContainer();
    return parentContainer ? parentContainer.getEffectiveVerticalContentAlignment() : Enums.VerticalAlignment.Top;
  };
  Container.prototype.getItemCount = function () {
    return this._items.length;
  };
  Container.prototype.getItemAt = function (index) {
    return this._items[index];
  };
  Container.prototype.getFirstVisibleRenderedItem = function () {
    if (this.renderedElement && this._renderedItems && this._renderedItems.length > 0) {
      for (var _i = 0, _a = this._renderedItems; _i < _a.length; _i++) {
        var item = _a[_i];
        if (item.isVisible) {
          return item;
        }
      }
    }
    return undefined;
  };
  Container.prototype.getLastVisibleRenderedItem = function () {
    if (this.renderedElement && this._renderedItems && this._renderedItems.length > 0) {
      for (var i = this._renderedItems.length - 1; i >= 0; i--) {
        if (this._renderedItems[i].isVisible) {
          return this._renderedItems[i];
        }
      }
    }
    return undefined;
  };
  Container.prototype.getJsonTypeName = function () {
    return "Container";
  };
  Container.prototype.isFirstElement = function (element) {
    var designMode = this.isDesignMode();
    for (var _i = 0, _a = this._items; _i < _a.length; _i++) {
      var item = _a[_i];
      if (item.isVisible || designMode) {
        return item === element;
      }
    }
    return false;
  };
  Container.prototype.isLastElement = function (element) {
    var designMode = this.isDesignMode();
    for (var i = this._items.length - 1; i >= 0; i--) {
      if (this._items[i].isVisible || designMode) {
        return this._items[i] === element;
      }
    }
    return false;
  };
  Container.prototype.isRtl = function () {
    if (this.rtl !== undefined) {
      return this.rtl;
    } else {
      var parentContainer = this.getParentContainer();
      return parentContainer ? parentContainer.isRtl() : false;
    }
  };
  Container.prototype.isBleedingAtTop = function () {
    var firstRenderedItem = this.getFirstVisibleRenderedItem();
    return this.isBleeding() || (firstRenderedItem ? firstRenderedItem.isBleedingAtTop() : false);
  };
  Container.prototype.isBleedingAtBottom = function () {
    var lastRenderedItem = this.getLastVisibleRenderedItem();
    return this.isBleeding() || (lastRenderedItem ? lastRenderedItem.isBleedingAtBottom() && lastRenderedItem.getEffectiveStyle() === this.getEffectiveStyle() : false);
  };
  Container.prototype.indexOf = function (cardElement) {
    return this._items.indexOf(cardElement);
  };
  Container.prototype.addItem = function (item) {
    this.insertItemAt(item, -1, false);
  };
  Container.prototype.insertItemBefore = function (item, insertBefore) {
    this.insertItemAt(item, this._items.indexOf(insertBefore), false);
  };
  Container.prototype.insertItemAfter = function (item, insertAfter) {
    this.insertItemAt(item, this._items.indexOf(insertAfter) + 1, false);
  };
  Container.prototype.removeItem = function (item) {
    var itemIndex = this._items.indexOf(item);
    if (itemIndex >= 0) {
      this._items.splice(itemIndex, 1);
      item.setParent(undefined);
      this.updateLayout();
      return true;
    }
    return false;
  };
  Container.prototype.clear = function () {
    this._items = [];
    this._renderedItems = [];
  };
  Container.prototype.getResourceInformation = function () {
    var result = _super.prototype.getResourceInformation.call(this);
    if (this.backgroundImage.isValid()) {
      result.push({
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- validated by `isValid()`
        url: this.backgroundImage.url,
        mimeType: "image"
      });
    }
    return result;
  };
  Container.prototype.getActionById = function (id) {
    var result = _super.prototype.getActionById.call(this, id);
    if (!result) {
      if (this.selectAction) {
        result = this.selectAction.getActionById(id);
      }
      if (!result) {
        for (var _i = 0, _a = this._items; _i < _a.length; _i++) {
          var item = _a[_i];
          result = item.getActionById(id);
          if (result) {
            break;
          }
        }
      }
    }
    return result;
  };
  Object.defineProperty(Container.prototype, "padding", {
    get: function () {
      return this.getPadding();
    },
    set: function (value) {
      this.setPadding(value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Container.prototype, "selectAction", {
    get: function () {
      return this._selectAction;
    },
    set: function (value) {
      this._selectAction = value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Container.prototype, "bleed", {
    get: function () {
      return this.getBleed();
    },
    set: function (value) {
      this.setBleed(value);
    },
    enumerable: false,
    configurable: true
  });
  //#region Schema
  Container.backgroundImageProperty = new serialization_1.SerializableObjectProperty(serialization_1.Versions.v1_0, "backgroundImage", BackgroundImage);
  Container.verticalContentAlignmentProperty = new serialization_1.EnumProperty(serialization_1.Versions.v1_1, "verticalContentAlignment", Enums.VerticalAlignment);
  Container.rtlProperty = new serialization_1.BoolProperty(serialization_1.Versions.v1_0, "rtl");
  __decorate([(0, serialization_1.property)(Container.backgroundImageProperty)], Container.prototype, "backgroundImage", null);
  __decorate([(0, serialization_1.property)(Container.verticalContentAlignmentProperty)], Container.prototype, "verticalContentAlignment", void 0);
  __decorate([(0, serialization_1.property)(Container.rtlProperty)], Container.prototype, "rtl", void 0);
  return Container;
}(ContainerBase);
exports.Container = Container;
var Column = /** @class */function (_super) {
  __extends(Column, _super);
  function Column(width) {
    if (width === void 0) {
      width = "stretch";
    }
    var _this = _super.call(this) || this;
    _this.width = "stretch";
    //#endregion
    _this._computedWeight = 0;
    _this.width = width;
    return _this;
  }
  Column.prototype.adjustRenderedElementSize = function (renderedElement) {
    var minDesignTimeColumnHeight = 20;
    if (this.isDesignMode()) {
      renderedElement.style.minWidth = "20px";
      renderedElement.style.minHeight = (!this.minPixelHeight ? minDesignTimeColumnHeight : Math.max(this.minPixelHeight, minDesignTimeColumnHeight)) + "px";
    } else {
      renderedElement.style.minWidth = "0";
      if (this.minPixelHeight) {
        renderedElement.style.minHeight = this.minPixelHeight + "px";
      }
    }
    if (this.width === "auto") {
      renderedElement.style.flex = "0 1 auto";
    } else if (this.width === "stretch") {
      renderedElement.style.flex = "1 1 50px";
    } else if (this.width instanceof shared_1.SizeAndUnit) {
      if (this.width.unit === Enums.SizeUnit.Pixel) {
        renderedElement.style.flex = "0 0 auto";
        renderedElement.style.width = this.width.physicalSize + "px";
      } else {
        renderedElement.style.flex = "1 1 " + (this._computedWeight > 0 ? this._computedWeight : this.width.physicalSize) + "%";
      }
    }
  };
  Column.prototype.shouldSerialize = function (_context) {
    return true;
  };
  Object.defineProperty(Column.prototype, "separatorOrientation", {
    get: function () {
      return Enums.Orientation.Vertical;
    },
    enumerable: false,
    configurable: true
  });
  Column.prototype.getJsonTypeName = function () {
    return "Column";
  };
  Object.defineProperty(Column.prototype, "hasVisibleSeparator", {
    get: function () {
      if (this.parent && this.parent instanceof ColumnSet) {
        return this.separatorElement !== undefined && !this.parent.isLeftMostElement(this);
      } else {
        return false;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Column.prototype, "isStandalone", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  //#region Schema
  Column.widthProperty = new serialization_1.CustomProperty(serialization_1.Versions.v1_0, "width", function (sender, prop, source, context) {
    var result = prop.defaultValue;
    var value = source[prop.name];
    var invalidWidth = false;
    if (typeof value === "number" && !isNaN(value)) {
      result = new shared_1.SizeAndUnit(value, Enums.SizeUnit.Weight);
    } else if (value === "auto" || value === "stretch") {
      result = value;
    } else if (typeof value === "string") {
      try {
        result = shared_1.SizeAndUnit.parse(value);
        if (result.unit === Enums.SizeUnit.Pixel && prop.targetVersion.compareTo(context.targetVersion) > 0) {
          invalidWidth = true;
        }
      } catch (e) {
        invalidWidth = true;
      }
    } else {
      invalidWidth = true;
    }
    if (invalidWidth) {
      context.logParseEvent(sender, Enums.ValidationEvent.InvalidPropertyValue, strings_1.Strings.errors.invalidColumnWidth(value));
      result = "auto";
    }
    return result;
  }, function (sender, property, target, value, context) {
    if (value instanceof shared_1.SizeAndUnit) {
      if (value.unit === Enums.SizeUnit.Pixel) {
        context.serializeValue(target, "width", value.physicalSize + "px");
      } else {
        context.serializeNumber(target, "width", value.physicalSize);
      }
    } else {
      context.serializeValue(target, "width", value);
    }
  }, "stretch");
  __decorate([(0, serialization_1.property)(Column.widthProperty)], Column.prototype, "width", void 0);
  return Column;
}(Container);
exports.Column = Column;
var ColumnSet = /** @class */function (_super) {
  __extends(ColumnSet, _super);
  function ColumnSet() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._columns = [];
    return _this;
  }
  ColumnSet.prototype.createColumnInstance = function (source, context) {
    return context.parseCardObject(this, source, [], !this.isDesignMode(), function (typeName) {
      return !typeName || typeName === "Column" ? new Column() : undefined;
    }, function (typeName, _errorType) {
      context.logParseEvent(undefined, Enums.ValidationEvent.ElementTypeNotAllowed, strings_1.Strings.errors.elementTypeNotAllowed(typeName));
    });
  };
  ColumnSet.prototype.internalRender = function () {
    this._renderedColumns = [];
    if (this._columns.length > 0) {
      // Cache hostConfig to avoid walking the parent hierarchy several times
      var hostConfig = this.hostConfig;
      var element = document.createElement("div");
      element.className = hostConfig.makeCssClassName("ac-columnSet");
      element.style.display = "flex";
      if (shared_1.GlobalSettings.useAdvancedCardBottomTruncation) {
        // See comment in Container.internalRender()
        element.style.minHeight = "-webkit-min-content";
      }
      switch (this.getEffectiveHorizontalAlignment()) {
        case Enums.HorizontalAlignment.Center:
          element.style.justifyContent = "center";
          break;
        case Enums.HorizontalAlignment.Right:
          element.style.justifyContent = "flex-end";
          break;
        default:
          element.style.justifyContent = "flex-start";
          break;
      }
      var totalWeight = 0;
      for (var _i = 0, _a = this._columns; _i < _a.length; _i++) {
        var column = _a[_i];
        if (column.width instanceof shared_1.SizeAndUnit && column.width.unit === Enums.SizeUnit.Weight) {
          totalWeight += column.width.physicalSize;
        }
      }
      for (var _b = 0, _c = this._columns; _b < _c.length; _b++) {
        var column = _c[_b];
        if (column.width instanceof shared_1.SizeAndUnit && column.width.unit === Enums.SizeUnit.Weight && totalWeight > 0) {
          var computedWeight = 100 / totalWeight * column.width.physicalSize;
          // Best way to emulate "internal" access I know of
          column["_computedWeight"] = computedWeight;
        }
        var renderedColumn = column.render();
        if (renderedColumn) {
          if (this._renderedColumns.length > 0 && column.separatorElement) {
            column.separatorElement.style.flex = "0 0 auto";
            Utils.appendChild(element, column.separatorElement);
          }
          Utils.appendChild(element, renderedColumn);
          this._renderedColumns.push(column);
        }
      }
      return this._renderedColumns.length > 0 ? element : undefined;
    } else {
      return undefined;
    }
  };
  ColumnSet.prototype.truncateOverflow = function (maxHeight) {
    for (var _i = 0, _a = this._columns; _i < _a.length; _i++) {
      var column = _a[_i];
      column["handleOverflow"](maxHeight);
    }
    return true;
  };
  ColumnSet.prototype.undoOverflowTruncation = function () {
    for (var _i = 0, _a = this._columns; _i < _a.length; _i++) {
      var column = _a[_i];
      column["resetOverflow"]();
    }
  };
  Object.defineProperty(ColumnSet.prototype, "isSelectable", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  ColumnSet.prototype.internalParse = function (source, context) {
    _super.prototype.internalParse.call(this, source, context);
    this._columns = [];
    this._renderedColumns = [];
    var jsonColumns = source["columns"];
    if (Array.isArray(jsonColumns)) {
      for (var _i = 0, jsonColumns_1 = jsonColumns; _i < jsonColumns_1.length; _i++) {
        var item = jsonColumns_1[_i];
        var column = this.createColumnInstance(item, context);
        if (column) {
          this._columns.push(column);
        }
      }
    }
  };
  ColumnSet.prototype.internalToJSON = function (target, context) {
    _super.prototype.internalToJSON.call(this, target, context);
    context.serializeArray(target, "columns", this._columns);
  };
  ColumnSet.prototype.isFirstElement = function (element) {
    for (var _i = 0, _a = this._columns; _i < _a.length; _i++) {
      var column = _a[_i];
      if (column.isVisible) {
        return column === element;
      }
    }
    return false;
  };
  ColumnSet.prototype.isBleedingAtTop = function () {
    if (this.isBleeding()) {
      return true;
    }
    if (this._renderedColumns && this._renderedColumns.length > 0) {
      for (var _i = 0, _a = this._columns; _i < _a.length; _i++) {
        var column = _a[_i];
        if (column.isBleedingAtTop()) {
          return true;
        }
      }
    }
    return false;
  };
  ColumnSet.prototype.isBleedingAtBottom = function () {
    if (this.isBleeding()) {
      return true;
    }
    if (this._renderedColumns && this._renderedColumns.length > 0) {
      for (var _i = 0, _a = this._columns; _i < _a.length; _i++) {
        var column = _a[_i];
        if (column.isBleedingAtBottom()) {
          return true;
        }
      }
    }
    return false;
  };
  ColumnSet.prototype.getItemCount = function () {
    return this._columns.length;
  };
  ColumnSet.prototype.getFirstVisibleRenderedItem = function () {
    if (this.renderedElement && this._renderedColumns && this._renderedColumns.length > 0) {
      return this._renderedColumns[0];
    } else {
      return undefined;
    }
  };
  ColumnSet.prototype.getLastVisibleRenderedItem = function () {
    if (this.renderedElement && this._renderedColumns && this._renderedColumns.length > 0) {
      return this._renderedColumns[this._renderedColumns.length - 1];
    } else {
      return undefined;
    }
  };
  ColumnSet.prototype.getColumnAt = function (index) {
    return this._columns[index];
  };
  ColumnSet.prototype.getItemAt = function (index) {
    return this.getColumnAt(index);
  };
  ColumnSet.prototype.getJsonTypeName = function () {
    return "ColumnSet";
  };
  ColumnSet.prototype.internalValidateProperties = function (context) {
    _super.prototype.internalValidateProperties.call(this, context);
    var weightedColumns = 0;
    var stretchedColumns = 0;
    for (var _i = 0, _a = this._columns; _i < _a.length; _i++) {
      var column = _a[_i];
      if (typeof column.width === "number") {
        weightedColumns++;
      } else if (column.width === "stretch") {
        stretchedColumns++;
      }
    }
    if (weightedColumns > 0 && stretchedColumns > 0) {
      context.addFailure(this, Enums.ValidationEvent.Hint, strings_1.Strings.hints.dontUseWeightedAndStrecthedColumnsInSameSet());
    }
  };
  ColumnSet.prototype.addColumn = function (column) {
    if (!column.parent) {
      this._columns.push(column);
      column.setParent(this);
    } else {
      throw new Error(strings_1.Strings.errors.columnAlreadyBelongsToAnotherSet());
    }
  };
  ColumnSet.prototype.removeItem = function (item) {
    if (item instanceof Column) {
      var itemIndex = this._columns.indexOf(item);
      if (itemIndex >= 0) {
        this._columns.splice(itemIndex, 1);
        item.setParent(undefined);
        this.updateLayout();
        return true;
      }
    }
    return false;
  };
  ColumnSet.prototype.indexOf = function (cardElement) {
    return cardElement instanceof Column ? this._columns.indexOf(cardElement) : -1;
  };
  ColumnSet.prototype.isLeftMostElement = function (element) {
    return this._columns.indexOf(element) === 0;
  };
  ColumnSet.prototype.isRightMostElement = function (element) {
    return this._columns.indexOf(element) === this._columns.length - 1;
  };
  ColumnSet.prototype.isTopElement = function (element) {
    return this._columns.indexOf(element) >= 0;
  };
  ColumnSet.prototype.isBottomElement = function (element) {
    return this._columns.indexOf(element) >= 0;
  };
  ColumnSet.prototype.getActionById = function (id) {
    var result = undefined;
    for (var _i = 0, _a = this._columns; _i < _a.length; _i++) {
      var column = _a[_i];
      result = column.getActionById(id);
      if (result) {
        break;
      }
    }
    return result;
  };
  Object.defineProperty(ColumnSet.prototype, "bleed", {
    get: function () {
      return this.getBleed();
    },
    set: function (value) {
      this.setBleed(value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ColumnSet.prototype, "padding", {
    get: function () {
      return this.getPadding();
    },
    set: function (value) {
      this.setPadding(value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ColumnSet.prototype, "selectAction", {
    get: function () {
      return this._selectAction;
    },
    set: function (value) {
      this._selectAction = value;
    },
    enumerable: false,
    configurable: true
  });
  return ColumnSet;
}(ContainerBase);
exports.ColumnSet = ColumnSet;
function raiseImageLoadedEvent(image) {
  var card = image.getRootElement();
  var onImageLoadedHandler = card && card.onImageLoaded ? card.onImageLoaded : AdaptiveCard.onImageLoaded;
  if (onImageLoadedHandler) {
    onImageLoadedHandler(image);
  }
}
function raiseAnchorClickedEvent(element, anchor, ev) {
  var card = element.getRootElement();
  var onAnchorClickedHandler = card && card.onAnchorClicked ? card.onAnchorClicked : AdaptiveCard.onAnchorClicked;
  return onAnchorClickedHandler !== undefined ? onAnchorClickedHandler(element, anchor, ev) : false;
}
function raiseExecuteActionEvent(action) {
  var card = action.parent ? action.parent.getRootElement() : undefined;
  var onExecuteActionHandler = card && card.onExecuteAction ? card.onExecuteAction : AdaptiveCard.onExecuteAction;
  if (action.prepareForExecution() && onExecuteActionHandler) {
    onExecuteActionHandler(action);
  }
}
function raiseInlineCardExpandedEvent(action, isExpanded) {
  var card = action.parent ? action.parent.getRootElement() : undefined;
  var onInlineCardExpandedHandler = card && card.onInlineCardExpanded ? card.onInlineCardExpanded : AdaptiveCard.onInlineCardExpanded;
  if (onInlineCardExpandedHandler) {
    onInlineCardExpandedHandler(action, isExpanded);
  }
}
function raiseInputValueChangedEvent(input) {
  var card = input.getRootElement();
  var onInputValueChangedHandler = card && card.onInputValueChanged ? card.onInputValueChanged : AdaptiveCard.onInputValueChanged;
  if (onInputValueChangedHandler) {
    onInputValueChangedHandler(input);
  }
}
function raiseElementVisibilityChangedEvent(element, shouldUpdateLayout) {
  if (shouldUpdateLayout === void 0) {
    shouldUpdateLayout = true;
  }
  var rootElement = element.getRootElement();
  if (shouldUpdateLayout) {
    rootElement.updateLayout();
  }
  var card = rootElement;
  var onElementVisibilityChangedHandler = card && card.onElementVisibilityChanged ? card.onElementVisibilityChanged : AdaptiveCard.onElementVisibilityChanged;
  if (onElementVisibilityChangedHandler !== undefined) {
    onElementVisibilityChangedHandler(element);
  }
}
function updateInputAdornersVisibility(input, hide) {
  if (!!hide) {
    // hides the time/date picker icon
    input.readOnly = true;
    // hides the cross button icon
    input.required = true;
  } else {
    // shows the time/date picker icon
    input.readOnly = false;
    // shows the cross button icon
    input.required = false;
  }
}
/**
 * @returns return false to continue with default context menu; return true to skip SDK default context menu
 */
function raiseDisplayOverflowActionMenuEvent(action, target) {
  var card = action.parent ? action.parent.getRootElement() : undefined;
  var onDisplayOverflowActionMenuHandler = card && card.onDisplayOverflowActionMenu ? card.onDisplayOverflowActionMenu : AdaptiveCard.onDisplayOverflowActionMenu;
  return onDisplayOverflowActionMenuHandler !== undefined ? onDisplayOverflowActionMenuHandler(action.getActions(), target) : false;
}
/**
 * @returns return false to continue with default action button; return true to skip SDK default action button
 */
function raiseRenderOverflowActionsEvent(action, isAtRootLevelActions) {
  var card = action.parent ? action.parent.getRootElement() : undefined;
  var onRenderOverflowActionsHandler = card && card.onRenderOverflowActions ? card.onRenderOverflowActions : AdaptiveCard.onRenderOverflowActions;
  return onRenderOverflowActionsHandler !== undefined ? onRenderOverflowActionsHandler(action.getActions(), isAtRootLevelActions) : false;
}
var ContainerWithActions = /** @class */function (_super) {
  __extends(ContainerWithActions, _super);
  function ContainerWithActions() {
    var _this = _super.call(this) || this;
    _this._actionCollection = new ActionCollection(_this);
    return _this;
  }
  ContainerWithActions.prototype.internalParse = function (source, context) {
    _super.prototype.internalParse.call(this, source, context);
    this.parseActions(source, context);
  };
  ContainerWithActions.prototype.parseActions = function (source, context) {
    this._actionCollection.parse(source["actions"], context);
  };
  ContainerWithActions.prototype.internalToJSON = function (target, context) {
    _super.prototype.internalToJSON.call(this, target, context);
    this._actionCollection.toJSON(target, "actions", context);
  };
  ContainerWithActions.prototype.internalRender = function () {
    var element = _super.prototype.internalRender.call(this);
    if (element) {
      var renderedActions = this._actionCollection.render(this.hostConfig.actions.actionsOrientation);
      if (renderedActions) {
        Utils.appendChild(element, renderSeparation(this.hostConfig, {
          spacing: this.hostConfig.getEffectiveSpacing(this.hostConfig.actions.spacing)
        }, Enums.Orientation.Horizontal));
        Utils.appendChild(element, renderedActions);
      }
      if (this.renderIfEmpty) {
        return element;
      } else {
        return element.children.length > 0 ? element : undefined;
      }
    } else {
      return undefined;
    }
  };
  ContainerWithActions.prototype.getHasExpandedAction = function () {
    if (this.renderedActionCount === 0) {
      return false;
    } else if (this.renderedActionCount === 1) {
      return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
    } else {
      return this._actionCollection.expandedAction !== undefined;
    }
  };
  Object.defineProperty(ContainerWithActions.prototype, "renderedActionCount", {
    get: function () {
      return this._actionCollection.renderedActionCount;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ContainerWithActions.prototype, "renderIfEmpty", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  ContainerWithActions.prototype.releaseDOMResources = function () {
    _super.prototype.releaseDOMResources.call(this);
    this._actionCollection.releaseDOMResources();
  };
  ContainerWithActions.prototype.getActionCount = function () {
    return this._actionCollection.getActionCount();
  };
  ContainerWithActions.prototype.getActionAt = function (index) {
    if (index >= 0 && index < this.getActionCount()) {
      return this._actionCollection.getActionAt(index);
    } else {
      return _super.prototype.getActionAt.call(this, index);
    }
  };
  ContainerWithActions.prototype.getActionById = function (id) {
    var result = this._actionCollection.getActionById(id);
    return result ? result : _super.prototype.getActionById.call(this, id);
  };
  ContainerWithActions.prototype.internalValidateProperties = function (context) {
    _super.prototype.internalValidateProperties.call(this, context);
    if (this._actionCollection) {
      this._actionCollection.validateProperties(context);
    }
  };
  ContainerWithActions.prototype.isLastElement = function (element) {
    return _super.prototype.isLastElement.call(this, element) && this._actionCollection.getActionCount() === 0;
  };
  ContainerWithActions.prototype.addAction = function (action) {
    this._actionCollection.addAction(action);
  };
  ContainerWithActions.prototype.clear = function () {
    _super.prototype.clear.call(this);
    this._actionCollection.clear();
  };
  ContainerWithActions.prototype.getAllInputs = function (processActions) {
    if (processActions === void 0) {
      processActions = true;
    }
    var result = _super.prototype.getAllInputs.call(this, processActions);
    if (processActions) {
      result.push.apply(result, this._actionCollection.getAllInputs(processActions));
    }
    return result;
  };
  ContainerWithActions.prototype.getResourceInformation = function () {
    var result = _super.prototype.getResourceInformation.call(this);
    result.push.apply(result, this._actionCollection.getResourceInformation());
    return result;
  };
  ContainerWithActions.prototype.isBleedingAtBottom = function () {
    if (this._actionCollection.renderedActionCount === 0) {
      return _super.prototype.isBleedingAtBottom.call(this);
    } else {
      if (this._actionCollection.getActionCount() === 1) {
        return this._actionCollection.expandedAction !== undefined && !this.hostConfig.actions.preExpandSingleShowCardAction;
      } else {
        return this._actionCollection.expandedAction !== undefined;
      }
    }
  };
  ContainerWithActions.prototype.getForbiddenActionNames = function () {
    return [];
  };
  ContainerWithActions.prototype.getElementById = function (id) {
    var result = _super.prototype.getElementById.call(this, id);
    if (!result) {
      result = this.getElementByIdFromAction(id);
    }
    return result;
  };
  Object.defineProperty(ContainerWithActions.prototype, "isStandalone", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  return ContainerWithActions;
}(Container);
exports.ContainerWithActions = ContainerWithActions;
var RefreshActionProperty = /** @class */function (_super) {
  __extends(RefreshActionProperty, _super);
  function RefreshActionProperty(targetVersion, name) {
    var _this = _super.call(this, targetVersion, name, undefined) || this;
    _this.targetVersion = targetVersion;
    _this.name = name;
    return _this;
  }
  RefreshActionProperty.prototype.parse = function (sender, source, context) {
    var action = context.parseAction(sender.parent, source[this.name], [], false);
    if (action !== undefined) {
      if (action instanceof ExecuteAction) {
        return action;
      }
      context.logParseEvent(sender, Enums.ValidationEvent.ActionTypeNotAllowed, strings_1.Strings.errors.actionTypeNotAllowed(action.getJsonTypeName()));
    }
    context.logParseEvent(sender, Enums.ValidationEvent.PropertyCantBeNull, strings_1.Strings.errors.propertyMustBeSet("action"));
    return undefined;
  };
  RefreshActionProperty.prototype.toJSON = function (sender, target, value, context) {
    context.serializeValue(target, this.name, value ? value.toJSON(context) : undefined, undefined, true);
  };
  return RefreshActionProperty;
}(serialization_1.PropertyDefinition);
exports.RefreshActionProperty = RefreshActionProperty;
var RefreshDefinition = /** @class */function (_super) {
  __extends(RefreshDefinition, _super);
  function RefreshDefinition() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(RefreshDefinition.prototype, "action", {
    get: function () {
      return this.getValue(RefreshDefinition.actionProperty);
    },
    set: function (value) {
      this.setValue(RefreshDefinition.actionProperty, value);
      if (value) {
        value.setParent(this.parent);
      }
    },
    enumerable: false,
    configurable: true
  });
  RefreshDefinition.prototype.getSchemaKey = function () {
    return "RefreshDefinition";
  };
  //#region Schema
  RefreshDefinition.actionProperty = new RefreshActionProperty(serialization_1.Versions.v1_4, "action");
  RefreshDefinition.userIdsProperty = new serialization_1.StringArrayProperty(serialization_1.Versions.v1_4, "userIds");
  __decorate([(0, serialization_1.property)(RefreshDefinition.actionProperty)], RefreshDefinition.prototype, "action", null);
  __decorate([(0, serialization_1.property)(RefreshDefinition.userIdsProperty)], RefreshDefinition.prototype, "userIds", void 0);
  return RefreshDefinition;
}(serialization_1.SerializableObject);
exports.RefreshDefinition = RefreshDefinition;
var AuthCardButton = /** @class */function (_super) {
  __extends(AuthCardButton, _super);
  function AuthCardButton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AuthCardButton.prototype.getSchemaKey = function () {
    return "AuthCardButton";
  };
  //#region Schema
  AuthCardButton.typeProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_4, "type");
  AuthCardButton.titleProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_4, "title");
  AuthCardButton.imageProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_4, "image");
  AuthCardButton.valueProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_4, "value");
  __decorate([(0, serialization_1.property)(AuthCardButton.typeProperty)], AuthCardButton.prototype, "type", void 0);
  __decorate([(0, serialization_1.property)(AuthCardButton.titleProperty)], AuthCardButton.prototype, "title", void 0);
  __decorate([(0, serialization_1.property)(AuthCardButton.imageProperty)], AuthCardButton.prototype, "image", void 0);
  __decorate([(0, serialization_1.property)(AuthCardButton.valueProperty)], AuthCardButton.prototype, "value", void 0);
  return AuthCardButton;
}(serialization_1.SerializableObject);
exports.AuthCardButton = AuthCardButton;
var TokenExchangeResource = /** @class */function (_super) {
  __extends(TokenExchangeResource, _super);
  function TokenExchangeResource() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  TokenExchangeResource.prototype.getSchemaKey = function () {
    return "TokenExchangeResource";
  };
  //#region Schema
  TokenExchangeResource.idProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_4, "id");
  TokenExchangeResource.uriProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_4, "uri");
  TokenExchangeResource.providerIdProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_4, "providerId");
  __decorate([(0, serialization_1.property)(TokenExchangeResource.idProperty)], TokenExchangeResource.prototype, "id", void 0);
  __decorate([(0, serialization_1.property)(TokenExchangeResource.uriProperty)], TokenExchangeResource.prototype, "uri", void 0);
  __decorate([(0, serialization_1.property)(TokenExchangeResource.providerIdProperty)], TokenExchangeResource.prototype, "providerId", void 0);
  return TokenExchangeResource;
}(serialization_1.SerializableObject);
exports.TokenExchangeResource = TokenExchangeResource;
var Authentication = /** @class */function (_super) {
  __extends(Authentication, _super);
  function Authentication() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Authentication.prototype.getSchemaKey = function () {
    return "Authentication";
  };
  //#region Schema
  Authentication.textProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_4, "text");
  Authentication.connectionNameProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_4, "connectionName");
  Authentication.buttonsProperty = new serialization_1.SerializableObjectCollectionProperty(serialization_1.Versions.v1_4, "buttons", AuthCardButton);
  Authentication.tokenExchangeResourceProperty = new serialization_1.SerializableObjectProperty(serialization_1.Versions.v1_4, "tokenExchangeResource", TokenExchangeResource, true);
  __decorate([(0, serialization_1.property)(Authentication.textProperty)], Authentication.prototype, "text", void 0);
  __decorate([(0, serialization_1.property)(Authentication.connectionNameProperty)], Authentication.prototype, "connectionName", void 0);
  __decorate([(0, serialization_1.property)(Authentication.buttonsProperty)], Authentication.prototype, "buttons", void 0);
  __decorate([(0, serialization_1.property)(Authentication.tokenExchangeResourceProperty)], Authentication.prototype, "tokenExchangeResource", void 0);
  return Authentication;
}(serialization_1.SerializableObject);
exports.Authentication = Authentication;
// @dynamic
var AdaptiveCard = /** @class */function (_super) {
  __extends(AdaptiveCard, _super);
  function AdaptiveCard() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.designMode = false;
    return _this;
  }
  Object.defineProperty(AdaptiveCard.prototype, "refresh", {
    get: function () {
      return this.getValue(AdaptiveCard.refreshProperty);
    },
    set: function (value) {
      this.setValue(AdaptiveCard.refreshProperty, value);
      if (value) {
        value.parent = this;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AdaptiveCard, "processMarkdown", {
    get: function () {
      throw new Error(strings_1.Strings.errors.processMarkdownEventRemoved());
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    set: function (_value) {
      throw new Error(strings_1.Strings.errors.processMarkdownEventRemoved());
    },
    enumerable: false,
    configurable: true
  });
  AdaptiveCard.applyMarkdown = function (text) {
    var result = {
      didProcess: false
    };
    if (AdaptiveCard.onProcessMarkdown) {
      AdaptiveCard.onProcessMarkdown(text, result);
    } else if (window.markdownit) {
      // Check for markdownit
      var markdownIt = window.markdownit;
      result.outputHtml = markdownIt().render(text);
      result.didProcess = true;
    } else if (!AdaptiveCard._haveWarnedAboutNoMarkdownProcessing) {
      // eslint-disable-next-line no-console
      console.warn(strings_1.Strings.errors.markdownProcessingNotEnabled);
      AdaptiveCard._haveWarnedAboutNoMarkdownProcessing = true;
    }
    return result;
  };
  AdaptiveCard.prototype.isVersionSupported = function () {
    if (this.bypassVersionCheck) {
      return true;
    } else {
      var unsupportedVersion = !this.version || !this.version.isValid || this.maxVersion.major < this.version.major || this.maxVersion.major === this.version.major && this.maxVersion.minor < this.version.minor;
      return !unsupportedVersion;
    }
  };
  AdaptiveCard.prototype.getDefaultSerializationContext = function () {
    return new SerializationContext(this.version);
  };
  AdaptiveCard.prototype.getItemsCollectionPropertyName = function () {
    return "body";
  };
  AdaptiveCard.prototype.internalParse = function (source, context) {
    this._fallbackCard = undefined;
    var fallbackElement = context.parseElement(undefined, source["fallback"], this.forbiddenChildElements(), !this.isDesignMode());
    if (fallbackElement) {
      this._fallbackCard = new AdaptiveCard();
      this._fallbackCard.addItem(fallbackElement);
    }
    _super.prototype.internalParse.call(this, source, context);
  };
  AdaptiveCard.prototype.internalToJSON = function (target, context) {
    this.setValue(AdaptiveCard.versionProperty, context.targetVersion);
    _super.prototype.internalToJSON.call(this, target, context);
  };
  AdaptiveCard.prototype.internalRender = function () {
    var renderedElement = _super.prototype.internalRender.call(this);
    if (shared_1.GlobalSettings.useAdvancedCardBottomTruncation && renderedElement) {
      // Unlike containers, the root card element should be allowed to
      // be shorter than its content (otherwise the overflow truncation
      // logic would never get triggered)
      renderedElement.style.removeProperty("minHeight");
    }
    return renderedElement;
  };
  AdaptiveCard.prototype.getHasBackground = function (ignoreBackgroundImages) {
    if (ignoreBackgroundImages === void 0) {
      ignoreBackgroundImages = false;
    }
    return true;
  };
  AdaptiveCard.prototype.getDefaultPadding = function () {
    return new shared_1.PaddingDefinition(Enums.Spacing.Padding, Enums.Spacing.Padding, Enums.Spacing.Padding, Enums.Spacing.Padding);
  };
  AdaptiveCard.prototype.shouldSerialize = function (_context) {
    return true;
  };
  Object.defineProperty(AdaptiveCard.prototype, "renderIfEmpty", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AdaptiveCard.prototype, "bypassVersionCheck", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AdaptiveCard.prototype, "allowCustomStyle", {
    get: function () {
      return this.hostConfig.adaptiveCard && this.hostConfig.adaptiveCard.allowCustomStyle;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AdaptiveCard.prototype, "hasBackground", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  AdaptiveCard.prototype.getJsonTypeName = function () {
    return "AdaptiveCard";
  };
  AdaptiveCard.prototype.internalValidateProperties = function (context) {
    _super.prototype.internalValidateProperties.call(this, context);
    if (this.getValue(CardElement.typeNameProperty) !== "AdaptiveCard") {
      context.addFailure(this, Enums.ValidationEvent.MissingCardType, strings_1.Strings.errors.invalidCardType());
    }
    if (!this.bypassVersionCheck && !this.version) {
      context.addFailure(this, Enums.ValidationEvent.PropertyCantBeNull, strings_1.Strings.errors.propertyMustBeSet("version"));
    } else if (!this.isVersionSupported()) {
      context.addFailure(this, Enums.ValidationEvent.UnsupportedCardVersion, strings_1.Strings.errors.unsupportedCardVersion(this.version.toString(), this.maxVersion.toString()));
    }
  };
  AdaptiveCard.prototype.render = function (target) {
    var _this = this;
    var renderedCard;
    if (this.shouldFallback() && this._fallbackCard) {
      this._fallbackCard.hostConfig = this.hostConfig;
      renderedCard = this._fallbackCard.render();
    } else {
      renderedCard = _super.prototype.render.call(this);
      if (renderedCard) {
        renderedCard.classList.add(this.hostConfig.makeCssClassName("ac-adaptiveCard"));
        // Having a tabIndex on the root container for a card can mess up accessibility in some scenarios.
        // However, we've shipped this behavior before, and so can't just turn it off in a point release. For
        // now, to unblock accessibility scenarios for our customers, we've got an option to turn it off. In a
        // future release, we should strongly consider flipping the default such that we *don't* emit a tabIndex
        // by default.
        if (shared_1.GlobalSettings.setTabIndexAtCardRoot) {
          renderedCard.tabIndex = 0;
        }
        if (this.speak) {
          renderedCard.setAttribute("aria-label", this.speak);
        }
        renderedCard.onmouseenter = function (ev) {
          _this.updateInputsVisualState(true /* hover */);
        };
        renderedCard.onmouseleave = function (ev) {
          _this.updateInputsVisualState(false /* hover */);
        };
        this.getRootElement().updateActionsEnabledState();
      }
    }
    if (target) {
      Utils.appendChild(target, renderedCard);
      this.updateLayout();
    }
    var inputElements = this.getAllInputs();
    document.onclick = function (event) {
      inputElements.forEach(function (input) {
        var _a, _b;
        if (input instanceof ChoiceSetInput && !((_a = input.renderedElement) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
          (_b = input.getDropdownElement()) === null || _b === void 0 ? void 0 : _b.classList.remove(_this.hostConfig.makeCssClassName("ac-choiceSetInput-filtered-dropdown-open"));
        }
      });
    };
    return renderedCard;
  };
  AdaptiveCard.prototype.updateLayout = function (processChildren) {
    if (processChildren === void 0) {
      processChildren = true;
    }
    _super.prototype.updateLayout.call(this, processChildren);
    if (shared_1.GlobalSettings.useAdvancedCardBottomTruncation && this.isDisplayed()) {
      var padding = this.hostConfig.getEffectiveSpacing(Enums.Spacing.Default);
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      this["handleOverflow"](this.renderedElement.offsetHeight - padding);
    }
  };
  AdaptiveCard.prototype.shouldFallback = function () {
    return _super.prototype.shouldFallback.call(this) || !this.isVersionSupported();
  };
  Object.defineProperty(AdaptiveCard.prototype, "hasVisibleSeparator", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  AdaptiveCard.schemaUrl = "http://adaptivecards.io/schemas/adaptive-card.json";
  //#region Schema
  // eslint-disable-next-line @typescript-eslint/naming-convention
  AdaptiveCard.$schemaProperty = new serialization_1.CustomProperty(serialization_1.Versions.v1_0, "$schema", function (sender, property, source, context) {
    return AdaptiveCard.schemaUrl;
  }, function (sender, prop, target, value, context) {
    context.serializeValue(target, prop.name, AdaptiveCard.schemaUrl);
  });
  AdaptiveCard.versionProperty = new serialization_1.CustomProperty(serialization_1.Versions.v1_0, "version", function (sender, prop, source, context) {
    var version = serialization_1.Version.parse(source[prop.name], context);
    if (version === undefined) {
      version = serialization_1.Versions.latest;
      context.logParseEvent(sender, Enums.ValidationEvent.InvalidPropertyValue, strings_1.Strings.errors.invalidCardVersion(version.toString()));
    }
    return version;
  }, function (sender, prop, target, value, context) {
    if (value !== undefined) {
      context.serializeValue(target, prop.name, value.toString());
    }
  }, serialization_1.Versions.v1_0);
  AdaptiveCard.fallbackTextProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "fallbackText");
  AdaptiveCard.speakProperty = new serialization_1.StringProperty(serialization_1.Versions.v1_0, "speak");
  AdaptiveCard.refreshProperty = new serialization_1.SerializableObjectProperty(serialization_1.Versions.v1_4, "refresh", RefreshDefinition, true);
  AdaptiveCard.authenticationProperty = new serialization_1.SerializableObjectProperty(serialization_1.Versions.v1_4, "authentication", Authentication, true);
  //#endregion
  AdaptiveCard._haveWarnedAboutNoMarkdownProcessing = false;
  __decorate([(0, serialization_1.property)(AdaptiveCard.versionProperty)], AdaptiveCard.prototype, "version", void 0);
  __decorate([(0, serialization_1.property)(AdaptiveCard.fallbackTextProperty)], AdaptiveCard.prototype, "fallbackText", void 0);
  __decorate([(0, serialization_1.property)(AdaptiveCard.speakProperty)], AdaptiveCard.prototype, "speak", void 0);
  __decorate([(0, serialization_1.property)(AdaptiveCard.refreshProperty)], AdaptiveCard.prototype, "refresh", null);
  __decorate([(0, serialization_1.property)(AdaptiveCard.authenticationProperty)], AdaptiveCard.prototype, "authentication", void 0);
  return AdaptiveCard;
}(ContainerWithActions);
exports.AdaptiveCard = AdaptiveCard;
var InlineAdaptiveCard = /** @class */function (_super) {
  __extends(InlineAdaptiveCard, _super);
  function InlineAdaptiveCard() {
    //#region Schema
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.suppressStyle = false;
    return _this;
  }
  InlineAdaptiveCard.prototype.getSchemaKey = function () {
    return "InlineAdaptiveCard";
  };
  InlineAdaptiveCard.prototype.populateSchema = function (schema) {
    _super.prototype.populateSchema.call(this, schema);
    schema.remove(AdaptiveCard.$schemaProperty, AdaptiveCard.versionProperty);
  };
  //#endregion
  InlineAdaptiveCard.prototype.getDefaultPadding = function () {
    return new shared_1.PaddingDefinition(this.suppressStyle ? Enums.Spacing.None : Enums.Spacing.Padding, Enums.Spacing.Padding, this.suppressStyle ? Enums.Spacing.None : Enums.Spacing.Padding, Enums.Spacing.Padding);
  };
  Object.defineProperty(InlineAdaptiveCard.prototype, "bypassVersionCheck", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(InlineAdaptiveCard.prototype, "defaultStyle", {
    get: function () {
      if (this.suppressStyle) {
        return Enums.ContainerStyle.Default;
      } else {
        return this.hostConfig.actions.showCard.style ? this.hostConfig.actions.showCard.style : Enums.ContainerStyle.Emphasis;
      }
    },
    enumerable: false,
    configurable: true
  });
  InlineAdaptiveCard.prototype.render = function (target) {
    var renderedCard = _super.prototype.render.call(this, target);
    if (renderedCard) {
      renderedCard.setAttribute("aria-live", "polite");
      renderedCard.removeAttribute("tabindex");
    }
    return renderedCard;
  };
  return InlineAdaptiveCard;
}(AdaptiveCard);
var SerializationContext = /** @class */function (_super) {
  __extends(SerializationContext, _super);
  function SerializationContext() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._forbiddenTypes = new Set();
    return _this;
  }
  SerializationContext.prototype.internalParseCardObject = function (parent, source, forbiddenTypes, allowFallback, createInstanceCallback, logParseEvent) {
    var _this = this;
    var result = undefined;
    if (source && typeof source === "object") {
      var oldForbiddenTypes_1 = new Set();
      this._forbiddenTypes.forEach(function (type) {
        oldForbiddenTypes_1.add(type);
      });
      forbiddenTypes.forEach(function (type) {
        _this._forbiddenTypes.add(type);
      });
      var typeName = Utils.parseString(source["type"]);
      if (typeName && this._forbiddenTypes.has(typeName)) {
        logParseEvent(typeName, Enums.TypeErrorType.ForbiddenType);
      } else {
        var tryToFallback = false;
        result = createInstanceCallback(typeName);
        if (!result) {
          tryToFallback = shared_1.GlobalSettings.enableFallback && allowFallback;
          logParseEvent(typeName, Enums.TypeErrorType.UnknownType);
        } else {
          result.setParent(parent);
          result.parse(source, this);
          tryToFallback = shared_1.GlobalSettings.enableFallback && allowFallback && result.shouldFallback();
        }
        if (tryToFallback) {
          var fallback = source["fallback"];
          if (!fallback && parent) {
            parent.setShouldFallback(true);
          }
          if (typeof fallback === "string" && fallback.toLowerCase() === "drop") {
            result = undefined;
          } else if (typeof fallback === "object") {
            result = this.internalParseCardObject(parent, fallback, forbiddenTypes, true, createInstanceCallback, logParseEvent);
          }
        }
      }
      this._forbiddenTypes = oldForbiddenTypes_1;
    }
    return result;
  };
  SerializationContext.prototype.cardObjectParsed = function (o, source) {
    if (o instanceof Action && this.onParseAction) {
      this.onParseAction(o, source, this);
    } else if (o instanceof CardElement && this.onParseElement) {
      this.onParseElement(o, source, this);
    }
  };
  SerializationContext.prototype.shouldSerialize = function (o) {
    if (o instanceof Action) {
      return this.actionRegistry.findByName(o.getJsonTypeName()) !== undefined;
    } else if (o instanceof CardElement) {
      return this.elementRegistry.findByName(o.getJsonTypeName()) !== undefined;
    } else {
      return true;
    }
  };
  SerializationContext.prototype.parseCardObject = function (parent, source, forbiddenTypeNames, allowFallback, createInstanceCallback, logParseEvent) {
    var forbiddenTypes = new Set(forbiddenTypeNames);
    var result = this.internalParseCardObject(parent, source, forbiddenTypes, allowFallback, createInstanceCallback, logParseEvent);
    if (result !== undefined) {
      this.cardObjectParsed(result, source);
    }
    return result;
  };
  SerializationContext.prototype.parseElement = function (parent, source, forbiddenTypes, allowFallback) {
    var _this = this;
    return this.parseCardObject(parent, source, forbiddenTypes, allowFallback, function (typeName) {
      return _this.elementRegistry.createInstance(typeName, _this.targetVersion);
    }, function (typeName, errorType) {
      if (errorType === Enums.TypeErrorType.UnknownType) {
        _this.logParseEvent(undefined, Enums.ValidationEvent.UnknownElementType, strings_1.Strings.errors.unknownElementType(typeName));
      } else {
        _this.logParseEvent(undefined, Enums.ValidationEvent.ElementTypeNotAllowed, strings_1.Strings.errors.elementTypeNotAllowed(typeName));
      }
    });
  };
  SerializationContext.prototype.parseAction = function (parent, source, forbiddenActionTypes, allowFallback) {
    var _this = this;
    return this.parseCardObject(parent, source, forbiddenActionTypes, allowFallback, function (typeName) {
      return _this.actionRegistry.createInstance(typeName, _this.targetVersion);
    }, function (typeName, errorType) {
      if (errorType === Enums.TypeErrorType.UnknownType) {
        _this.logParseEvent(undefined, Enums.ValidationEvent.UnknownActionType, strings_1.Strings.errors.unknownActionType(typeName));
      } else {
        _this.logParseEvent(undefined, Enums.ValidationEvent.ActionTypeNotAllowed, strings_1.Strings.errors.actionTypeNotAllowed(typeName));
      }
    });
  };
  Object.defineProperty(SerializationContext.prototype, "elementRegistry", {
    get: function () {
      var _a;
      return (_a = this._elementRegistry) !== null && _a !== void 0 ? _a : registry_1.GlobalRegistry.elements;
    },
    enumerable: false,
    configurable: true
  });
  // Not using a property setter here because the setter should accept "undefined"
  // whereas the getter should never return undefined.
  SerializationContext.prototype.setElementRegistry = function (value) {
    this._elementRegistry = value;
  };
  Object.defineProperty(SerializationContext.prototype, "actionRegistry", {
    get: function () {
      var _a;
      return (_a = this._actionRegistry) !== null && _a !== void 0 ? _a : registry_1.GlobalRegistry.actions;
    },
    enumerable: false,
    configurable: true
  });
  // Not using a property setter here because the setter should accept "undefined"
  // whereas the getter should never return undefined.
  SerializationContext.prototype.setActionRegistry = function (value) {
    this._actionRegistry = value;
  };
  return SerializationContext;
}(serialization_1.BaseSerializationContext);
exports.SerializationContext = SerializationContext;
registry_1.GlobalRegistry.defaultElements.register("Container", Container);
registry_1.GlobalRegistry.defaultElements.register("TextBlock", TextBlock);
registry_1.GlobalRegistry.defaultElements.register("RichTextBlock", RichTextBlock, serialization_1.Versions.v1_2);
registry_1.GlobalRegistry.defaultElements.register("TextRun", TextRun, serialization_1.Versions.v1_2);
registry_1.GlobalRegistry.defaultElements.register("Image", Image);
registry_1.GlobalRegistry.defaultElements.register("ImageSet", ImageSet);
registry_1.GlobalRegistry.defaultElements.register("Media", Media, serialization_1.Versions.v1_1);
registry_1.GlobalRegistry.defaultElements.register("FactSet", FactSet);
registry_1.GlobalRegistry.defaultElements.register("ColumnSet", ColumnSet);
registry_1.GlobalRegistry.defaultElements.register("ActionSet", ActionSet, serialization_1.Versions.v1_2);
registry_1.GlobalRegistry.defaultElements.register("Input.Text", TextInput);
registry_1.GlobalRegistry.defaultElements.register("Input.Date", DateInput);
registry_1.GlobalRegistry.defaultElements.register("Input.Time", TimeInput);
registry_1.GlobalRegistry.defaultElements.register("Input.Number", NumberInput);
registry_1.GlobalRegistry.defaultElements.register("Input.ChoiceSet", ChoiceSetInput);
registry_1.GlobalRegistry.defaultElements.register("Input.Toggle", ToggleInput);
registry_1.GlobalRegistry.defaultActions.register(OpenUrlAction.JsonTypeName, OpenUrlAction);
registry_1.GlobalRegistry.defaultActions.register(SubmitAction.JsonTypeName, SubmitAction);
registry_1.GlobalRegistry.defaultActions.register(ShowCardAction.JsonTypeName, ShowCardAction);
registry_1.GlobalRegistry.defaultActions.register(ToggleVisibilityAction.JsonTypeName, ToggleVisibilityAction, serialization_1.Versions.v1_2);
registry_1.GlobalRegistry.defaultActions.register(ExecuteAction.JsonTypeName, ExecuteAction, serialization_1.Versions.v1_4);